export const PAGE_CONFIG = {
  "name": "CommonTab",
  "data": {
    "studioYtmActualEndTime": "",
    "studioMonthActualEndTime": "",
    "studioYtdActualEndTime": "",
    "studioDownloadSortState": null,
    "selfIncubationDownloadSortState": null,
  },
  "props": {
    "tabList": [
      {
        "id": "yearToMonth",
        "tabName": "Year to Month",
        "tabNameCN": "按月累计",
        "path": "/home",
        "rightSlot": {
          "name": "KPIFilter",
          "config": {
            "dateFilterConfig": {
              "pickerType": "month",
              "disabledStart": "2024-01-01",
              "dateSubtract": 1,
              "disableCurrent": true,
              "disableFuture": true
            }
          }
        }
      },
      {
        "id": "month",
        "tabName": "Month",
        "tabNameCN": "月",
        "path": "/home",
        "rightSlot": {
          "name": "KPIFilter",
          "config": {
            "dateFilterConfig": {
              "pickerType": "monthRange",
              "disabledStart": "2024-01-01",
              "dateSubtract": 1,
              "disableCurrent": true,
              "disableFuture": true
            }
          }
        }
      },
      {
        "id": "yearToDate",
        "tabName": "Year To Date",
        "tabNameCN": "按日累计",
        "path": "/home",
        "rightSlot": {
          "name": "KPIFilter",
          "config": {
            "dateFilterConfig": {
              "pickerType": "day",
              "disabledStart": "2024-01-01",
              "dateSubtract": 1,
              "dayAsYtd": true,
              "disableCurrent": true,
              "disableFuture": true
            }
          }
        }
      },
      {
        "id": "day",
        "tabName": "Day",
        "tabNameCN": "日",
        "path": "/home",
        "rightSlot": {
          "name": "KPIFilter",
          "config": {
            "dateFilterConfig": {
              "pickerType": "dayRange",
              "disabledStart": "2024-01-01",
              "dateSubtract": 1,
              "disableCurrent": true,
              "disableFuture": true
            }
          }
        }
      }
    ],
    "defaultTab": "yearToMonth"
  },
  "children": [
    {
      "name": "CommonLogWrap",
      "tabId": "yearToMonth",
      "config": {
        "logConfig": {
          "menuId": "",
          "pageId": "903001",
          "pageName": "IEGG Casual Overview Year to Month",
          "extInfo": "Casual Studio Overview Year To Month",
          "pagePath": "/home/yearToMonth"
        }
      },
      "children": [
        {
          "name": "CommonTabContentWrap",
          "children": [
            {
              "name": "CasualOverviewWrap",
              "children": [
                {
                  "name": "CommonRow",
                  "className": "dbh-casual-overview__row",
                  "type": "layout",
                  "props": {},
                  "children": [
                    {
                      "name": "CommonCol",
                      "type": "layout",
                      "props": {
                        "w": 8
                      },
                      "children": [
                        {
                          "name": "Service",
                          "className": "",
                          "type": "view",
                          "props": {
                            "api": "/api/v2/dashboard/studio/casual_hub/overview/card_metrics",
                            "trackData": [
                              "extraParams",
                              "frameCode"
                            ],
                            "dataKey": "casualTotalRevenueYtmMetricCardData",
                            "filterLoading": false,
                            "beforeRequest": (data) => {
                              const { filterVal, frameCode } = data || {};
                              const endTime = filterVal && filterVal.end_time;
                              let trendSixMonthStart;
                              if (endTime) {
                                const datePart = String(endTime).trim().slice(0, 10);
                                const match = /^([0-9]{4})-([0-9]{2})-([0-9]{2})$/.exec(datePart);
                                if (match) {
                                  const year = Number(match[1]);
                                  const month = Number(match[2]);
                                  const day = Number(match[3]);
                                  if (month >= 1 && month <= 12 && day >= 1 && day <= 31) {
                                    const parsed = new Date(year, month - 1, day);
                                    if (
                                      parsed.getFullYear() === year &&
                                      parsed.getMonth() === month - 1 &&
                                      parsed.getDate() === day
                                    ) {
                                      const start = new Date(year, month - 1 - 5, 1);
                                      trendSixMonthStart = `${start.getFullYear()  }-${  String(start.getMonth() + 1).padStart(2, '0')  }-${  String(start.getDate()).padStart(2, '0')}`;
                                    }
                                  }
                                }
                              }
                              return Object.assign(
                                {},
                                {
                                  studio_code: frameCode,
                                  filters: {},
                                  period: 'monthly',
                                  start_time: trendSixMonthStart || (filterVal && filterVal.start_time),
                                  end_time: filterVal && filterVal.end_time,
                                  is_confirm: false,
                                  logical_flag: 'ytd_actual_date',
                                  metrics: ['ytd_cs_casual_total_revenue_m', 'ytd_cs_self_incubation_revenue_m', 'ytd_cs_studio_total_revenue'],
                                  trend_metrics: [
                                    'cs_studio_total_revenue',
                                    'cs_self_incubation_revenue_m',
                                  ],
                                },
                                data.extraParams,
                              );
                            },
                            "formatData": (data) => {
                              const rawCardList = data && data.card_list ? data.card_list : [];
                              const cardList = rawCardList.map((card) => {
                                const result = {
                                  metrics_name: card.metrics_name,
                                  value: card.value,
                                  time: card.time,
                                };
                                const {dod} = card;
                                if (dod) {
                                  result.dod = {
                                    show_value: dod.show_value || '',
                                    this_value: dod.this_value || '',
                                    last_value: dod.last_value || '',
                                    this_time: dod.this_time || '',
                                    last_time: dod.last_time || '',
                                  };
                                }
                                const {sdlw} = card;
                                if (sdlw) {
                                  result.yoy = {
                                    show_value: sdlw.show_value || '',
                                    this_value: sdlw.this_value || '',
                                    last_value: sdlw.last_value || '',
                                    this_time: sdlw.this_time || '',
                                    last_time: sdlw.last_time || '',
                                  };
                                }
                                const {change} = card;
                                if (change) {
                                  result.change = {
                                    show_value: change.show_value || '',
                                    this_value: change.this_value || '',
                                    last_value: change.last_value || '',
                                    this_time: change.this_time || '',
                                    last_time: change.last_time || '',
                                  };
                                }
                                return result;
                              });
                              const rawTrendList = data && data.trend_list ? data.trend_list : [];
                              const trendList = rawTrendList.map((item) => {
                                const dateStr = item.date;
                                const formattedDate = dateStr && dateStr.length === 8
                                  ? dateStr.slice(0, 6)
                                  : dateStr;
                                return {
                                  date: formattedDate,
                                  metrics: item.metrics,
                                };
                              });
                              return {
                                card_list: cardList,
                                trend_list: trendList,
                                breakdown: (data && data.breakdown) || [],
                              };
                            }
                          },
                          "children": [
                            {
                              "name": "CasualTotalRevenueCard",
                              "props": {
                                "apiDataKey": "casualTotalRevenueYtmMetricCardData",
                                "config": {
                                  "titleEn": "Casual Total Revenue YTM",
                                  "titleCn": "休闲游戏当年累计收入",
                                  "metricKey": "ytd_cs_casual_total_revenue_m",
                                  "formatRule": "bmk00",
                                  "preUnit": "$",
                                  "useChangeOnMultiMonth": false,
                                  "donutSegments": [
                                    {
                                      "label": "Miniclip",
                                      "labelCn": "Miniclip",
                                      "value": 70,
                                      "color": "#69D19C",
                                      "metricKey": "ytd_cs_studio_total_revenue"
                                    },
                                    {
                                      "label": "Self-Incubation",
                                      "labelCn": "自孵化项目",
                                      "value": 30,
                                      "color": "#5086F3",
                                      "metricKey": "ytd_cs_self_incubation_revenue_m"
                                    }
                                  ],
                                  "trendMetrics": [
                                    {
                                      "metricKey": "cs_studio_total_revenue",
                                      "nameEn": "Miniclip",
                                      "nameCn": "Miniclip",
                                      "formatRule": "bmk00",
                                      "color": "#69D19C"
                                    },
                                    {
                                      "metricKey": "cs_self_incubation_revenue_m",
                                      "nameEn": "Self-Incubation",
                                      "nameCn": "自孵化项目",
                                      "formatRule": "bmk00",
                                      "color": "#5086F3"
                                    }
                                  ],
                                  "trendTitleEn": "Revenue Trend",
                                  "trendTitleCn": "收入趋势",
                                  "trendShowConfig": {
                                    "showBarChart": true,
                                    "showLineChart": false,
                                    "showBubbleTitle": true,
                                    "isStackBar": true,
                                    "stackBarShowTotalLabel": false
                                  }
                                }
                              }
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "name": "CommonCol",
                      "type": "layout",
                      "props": {
                        "w": 8
                      },
                      "children": [
                        {
                          "name": "Service",
                          "className": "",
                          "type": "view",
                          "props": {
                            "api": "/api/v2/dashboard/studio/casual_hub/overview/card_metrics",
                            "trackData": [
                              "extraParams",
                              "frameCode"
                            ],
                            "dataKey": "selfIncubationRevenueYtmMetricCardData",
                            "filterLoading": false,
                            "beforeRequest": (data) => {
                              const { filterVal, frameCode } = data || {};
                              const endTime = filterVal && filterVal.end_time;
                              let trendSixMonthStart;
                              if (endTime) {
                                const datePart = String(endTime).trim().slice(0, 10);
                                const match = /^([0-9]{4})-([0-9]{2})-([0-9]{2})$/.exec(datePart);
                                if (match) {
                                  const year = Number(match[1]);
                                  const month = Number(match[2]);
                                  const day = Number(match[3]);
                                  if (month >= 1 && month <= 12 && day >= 1 && day <= 31) {
                                    const parsed = new Date(year, month - 1, day);
                                    if (
                                      parsed.getFullYear() === year &&
                                      parsed.getMonth() === month - 1 &&
                                      parsed.getDate() === day
                                    ) {
                                      const start = new Date(year, month - 1 - 5, 1);
                                      trendSixMonthStart = `${start.getFullYear()  }-${  String(start.getMonth() + 1).padStart(2, '0')  }-${  String(start.getDate()).padStart(2, '0')}`;
                                    }
                                  }
                                }
                              }
                              return Object.assign(
                                {},
                                {
                                  studio_code: frameCode,
                                  filters: {},
                                  period: 'monthly',
                                  start_time: trendSixMonthStart || (filterVal && filterVal.start_time),
                                  end_time: filterVal && filterVal.end_time,
                                  card_type: '1',
                                  is_confirm: false,
                                  breakdown_dimension: 'game_code',
                                  logical_flag: 'top_no_others,ytd_actual_date',
                                  metrics: ['ytd_cs_self_incubation_revenue_m', 'cs_self_incubation_avg_dau'],
                                  trend_metrics: ['cs_self_incubation_revenue_m'],
                                  breakdown_metrics: 'ytd_cs_si_iaa_revenue_m',
                                },
                                data.extraParams,
                              );
                            },
                            "formatData": (data) => {
                              const rawCardList = data && data.card_list ? data.card_list : [];
                              const cardList = rawCardList.map((card) => {
                                const result = {
                                  metrics_name: card.metrics_name,
                                  value: card.value,
                                  time: card.time,
                                };
                                const {dod} = card;
                                if (dod) {
                                  result.dod = {
                                    show_value: dod.show_value || '',
                                    this_value: dod.this_value || '',
                                    last_value: dod.last_value || '',
                                    this_time: dod.this_time || '',
                                    last_time: dod.last_time || '',
                                  };
                                }
                                const {sdlw} = card;
                                if (sdlw) {
                                  result.yoy = {
                                    show_value: sdlw.show_value || '',
                                    this_value: sdlw.this_value || '',
                                    last_value: sdlw.last_value || '',
                                    this_time: sdlw.this_time || '',
                                    last_time: sdlw.last_time || '',
                                  };
                                }
                                const {change} = card;
                                if (change) {
                                  result.change = {
                                    show_value: change.show_value || '',
                                    this_value: change.this_value || '',
                                    last_value: change.last_value || '',
                                    this_time: change.this_time || '',
                                    last_time: change.last_time || '',
                                  };
                                }
                                return result;
                              });
                              const rawTrendList = data && data.trend_list ? data.trend_list : [];
                              const trendList = rawTrendList.map((item) => {
                                const dateStr = item.date;
                                const formattedDate = dateStr && dateStr.length === 8
                                  ? dateStr.slice(0, 6)
                                  : dateStr;
                                return {
                                  date: formattedDate,
                                  metrics: item.metrics,
                                };
                              });
                              const rawBreakdown = data && data.breakdown ? data.breakdown : [];
                              const sortedBreakdown = rawBreakdown
                                .slice()
                                .sort((a, b) => {
                                  return parseFloat(String(b.value || '0')) - parseFloat(String(a.value || '0'));
                                })
                                .slice(0, 3);
                              const gameRanks = sortedBreakdown.map((item, idx) => {
                                return {
                                  gameCode: item.name || item.full_name || '',
                                  rank: idx + 1,
                                  name: String(item.full_name || item.name || ''),
                                };
                              });
                              return {
                                card_list: cardList,
                                trend_list: trendList,
                                breakdown: (data && data.breakdown) || [],
                                gameRanks,
                              };
                            }
                          },
                          "children": [
                            {
                              "name": "CasualSubMetricCard",
                              "props": {
                                "apiDataKey": "selfIncubationRevenueYtmMetricCardData",
                                "config": {
                                  "titleEn": "Self-Incubation Revenue YTM",
                                  "titleCn": "自孵化项目当年累计收入",
                                  "metricKey": "ytd_cs_self_incubation_revenue_m",
                                  "formatRule": "bmk00",
                                  "preUnit": "$",
                                  "useChangeOnMultiMonth": false,
                                  "useDataGameRanks": true,
                                  "gameRankJumpType": "window",
                                  "useDynamicSubtitle": true,
                                  "subtitleMode": "ytmSelfIncubation",
                                  "ytmSubtitleMainMetricKey": "ytd_cs_self_incubation_revenue_m",
                                  "subMetrics": [
                                    {
                                      "labelEn": "Avg.DAU",
                                      "labelCn": "日均活跃",
                                      "metricKey": "cs_self_incubation_avg_dau",
                                      "formatRule": "bmk00",
                                      "preUnit": "",
                                      "useDynamicSubtitle": true
                                    }
                                  ],
                                  "trendConfig": {
                                    "metricKey": "cs_self_incubation_revenue_m",
                                    "nameEn": "Revenue",
                                    "nameCn": "总收入"
                                  },
                                  "trendTitleEn": "Revenue Trend",
                                  "trendTitleCn": "收入趋势"
                                }
                              }
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "name": "CommonCol",
                      "type": "layout",
                      "props": {
                        "w": 8
                      },
                      "children": [
                        {
                          "name": "Service",
                          "className": "",
                          "type": "view",
                          "props": {
                            "api": "/api/v2/dashboard/studio/casual_hub/overview/card_metrics",
                            "trackData": [
                              "extraParams",
                              "frameCode"
                            ],
                            "dataKey": "studioRevenueYtmMetricCardData",
                            "filterLoading": false,
                            "beforeRequest": (data) => {
                              const { filterVal, frameCode } = data || {};
                              const endTime = filterVal && filterVal.end_time;
                              let trendSixMonthStart;
                              let effectiveEndTime = endTime;
                              if (endTime) {
                                const datePart = String(endTime).trim().slice(0, 10);
                                const match = /^([0-9]{4})-([0-9]{2})-([0-9]{2})$/.exec(datePart);
                                if (match) {
                                  const year = Number(match[1]);
                                  const month = Number(match[2]);
                                  const day = Number(match[3]);
                                  if (month >= 1 && month <= 12 && day >= 1 && day <= 31) {
                                    const parsed = new Date(year, month - 1, day);
                                    if (
                                      parsed.getFullYear() === year &&
                                      parsed.getMonth() === month - 1 &&
                                      parsed.getDate() === day
                                    ) {
                                      const now = new Date();
                                      const isCurrentMonth = year === now.getFullYear() && month === now.getMonth() + 1;
                                      if (isCurrentMonth) {
                                        const prevMonthLast = new Date(year, month - 1, 0);
                                        effectiveEndTime = `${prevMonthLast.getFullYear()  }-${  String(prevMonthLast.getMonth() + 1).padStart(2, '0')  }-${  String(prevMonthLast.getDate()).padStart(2, '0')}`;
                                        const prevMonthFirst = new Date(year, month - 2, 1);
                                        trendSixMonthStart = `${prevMonthFirst.getFullYear()  }-${  String(prevMonthFirst.getMonth() + 1).padStart(2, '0')  }-01`;
                                      } else {
                                        const start = new Date(year, month - 1 - 5, 1);
                                        trendSixMonthStart = `${start.getFullYear()  }-${  String(start.getMonth() + 1).padStart(2, '0')  }-${  String(start.getDate()).padStart(2, '0')}`;
                                      }
                                    }
                                  }
                                }
                              }
                              return Object.assign(
                                {},
                                {
                                  studio_code: frameCode,
                                  filters: {},
                                  period: 'monthly',
                                  start_time: trendSixMonthStart || (filterVal && filterVal.start_time),
                                  end_time: effectiveEndTime,
                                  card_type: '1',
                                  is_confirm: false,
                                  breakdown_dimension: 'game_code',
                                  logical_flag: 'top_no_others,ytd_actual_date',
                                  metrics: ['ytd_cs_studio_total_revenue_m', 'ytd_cs_studio_iaa_revenue_m', 'ytd_cs_studio_iap_revenue_m'],
                                  trend_metrics: ['cs_studio_total_revenue_m'],
                                  breakdown_metrics: 'ytd_cs_studio_total_revenue_m',
                                },
                                data.extraParams,
                              );
                            },
                            "formatData": (data) => {
                              const rawCardList = data && data.card_list ? data.card_list : [];
                              const cardList = rawCardList.map((card) => {
                                const result = {
                                  metrics_name: card.metrics_name,
                                  value: card.value,
                                  time: card.time,
                                };
                                const {dod} = card;
                                if (dod) {
                                  result.dod = {
                                    show_value: dod.show_value || '',
                                    this_value: dod.this_value || '',
                                    last_value: dod.last_value || '',
                                    this_time: dod.this_time || '',
                                    last_time: dod.last_time || '',
                                  };
                                }
                                const {sdlw} = card;
                                if (sdlw) {
                                  result.yoy = {
                                    show_value: sdlw.show_value || '',
                                    this_value: sdlw.this_value || '',
                                    last_value: sdlw.last_value || '',
                                    this_time: sdlw.this_time || '',
                                    last_time: sdlw.last_time || '',
                                  };
                                }
                                const {change} = card;
                                if (change) {
                                  result.change = {
                                    show_value: change.show_value || '',
                                    this_value: change.this_value || '',
                                    last_value: change.last_value || '',
                                    this_time: change.this_time || '',
                                    last_time: change.last_time || '',
                                  };
                                }
                                return result;
                              });
                              const rawTrendList = data && data.trend_list ? data.trend_list : [];
                              const trendList = rawTrendList.map((item) => {
                                const dateStr = item.date;
                                const formattedDate = dateStr && dateStr.length === 8
                                  ? dateStr.slice(0, 6)
                                  : dateStr;
                                return {
                                  date: formattedDate,
                                  metrics: item.metrics,
                                };
                              });
                              const rawBreakdown = data && data.breakdown ? data.breakdown : [];
                              const sortedBreakdown = rawBreakdown
                                .slice()
                                .sort((a, b) => {
                                  return parseFloat(String(b.value || '0')) - parseFloat(String(a.value || '0'));
                                })
                                .slice(0, 3);
                              const gameRanks = sortedBreakdown.map((item, idx) => {
                                return {
                                  gameCode: item.name || item.full_name || '',
                                  rank: idx + 1,
                                  name: String(item.full_name || item.name || ''),
                                };
                              });
                              return {
                                card_list: cardList,
                                trend_list: trendList,
                                breakdown: (data && data.breakdown) || [],
                                gameRanks,
                              };
                            }
                          },
                          "children": [
                            {
                              "name": "CasualSubMetricCard",
                              "props": {
                                "apiDataKey": "studioRevenueYtmMetricCardData",
                                "config": {
                                  "titleEn": "Miniclip Revenue YTM",
                                  "titleCn": "Miniclip当年累计收入",
                                  "titleIconUrl": "https://ogdb-cdn.intlgame.cn/aupload/admin/studio_hub/image/1741760898187_选中态.png",
                                  "metricKey": "ytd_cs_studio_total_revenue_m",
                                  "subtitleTimeMetricKey": "ytd_cs_studio_total_revenue_m",
                                  "subtitleChangeKey": "studioYtmActualEndTime",
                                  "formatRule": "bmk00",
                                  "preUnit": "$",
                                  "isRightCard": true,
                                  "useDataGameRanks": true,
                                  "useDynamicSubtitle": true,
                                  "subMetrics": [
                                    {
                                      "labelEn": "IAP Revenue",
                                      "labelCn": "IAP 收入",
                                      "metricKey": "ytd_cs_studio_iap_revenue_m",
                                      "formatRule": "bmk00",
                                      "preUnit": "$"
                                    },
                                    {
                                      "labelEn": "IAA Revenue",
                                      "labelCn": "IAA 收入",
                                      "metricKey": "ytd_cs_studio_iaa_revenue_m",
                                      "formatRule": "bmk00",
                                      "preUnit": "$"
                                    }
                                  ],
                                  "trendConfig": {
                                    "metricKey": "cs_studio_total_revenue_m",
                                    "nameEn": "Revenue",
                                    "nameCn": "总收入"
                                  },
                                  "trendTitleEn": "Revenue Trend",
                                  "trendTitleCn": "收入趋势",
                                  "useChangeOnMultiMonth": false
                                }
                              }
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  "name": "Service",
                  "data": {
                    "extraParams": {
                      "multi_sort": [
                        {
                          "sort_by": "ytd_cs_si_iaa_revenue_m",
                          "desc": true
                        }
                      ],
                      "page": 1,
                      "page_size": 9999
                    }
                  },
                  "props": {
                    "api": "/api/v2/dashboard/studio/casual_hub/overview/overall_performance",
                    "trackData": [
                      "extraParams",
                      "frameCode"
                    ],
                    "dataKey": "selfIncubationTableData",
                    "filterLoading": false,
                    "beforeRequest": (data) => {
                      const { filterVal, frameCode } = data || {};
                      const et = filterVal?.end_time;
                      const endDateStr = et ? String(et).trim().slice(0, 10).split('-').join('') : '';
                      let startDateStr = '';
                      if (et) {
                        const datePart = String(et).trim().slice(0, 10);
                        const m = /^([0-9]{4})-([0-9]{2})-[0-9]{2}$/.exec(datePart);
                        if (m) {
                          startDateStr = `${m[1] + m[2]  }01`;
                        }
                      }
                      return Object.assign(
                        {},
                        {
                          studio_code: frameCode,
                          filters: {},
                          accumulation: {
                            custom_accumulation: [
                              { is_accumulation: true, key: 'game_code' },
                              { is_accumulation: true, key: 'category' },
                              { is_accumulation: false, key: 'studio' },
                            ],
                          },
                          page: 1,
                          page_size: 9999,
                          start_date: startDateStr,
                          end_date: endDateStr,
                          sorted_by: 'ytd_cs_si_iaa_revenue_m',
                          desc: true,
                          multi_sort: [{ sort_by: 'ytd_cs_si_iaa_revenue_m', desc: true }],
                          metrics: [
                            'ytd_cs_si_iaa_revenue_m',
                            'ytd_cs_si_new_m',
                            'ytd_cs_si_spend_m',
                            'cs_si_avg_dau',
                          ],
                          logical_flag: 'ytd_actual_date',
                          period: 'monthly',
                        },
                        data.extraParams,
                      );
                    },
                    "formatData": (data) => { return data }
                  },
                  "children": [
                    {
                      "name": "Service",
                      "props": {
                        "api": "/api/v2/dashboard/studio/casual_hub/overview/overall_performance",
                        "trackData": [
                          "frameCode"
                        ],
                        "dataKey": "selfIncubationSparklineData",
                        "filterLoading": false,
                        "beforeRequest": (data) => {
                          const { filterVal, frameCode } = data || {};
                          const et = filterVal?.end_time;

                          const getTargetDate = (dateStr, monthOffset = 0, type = 'current', sep = '') => {
                            if (!dateStr) return '';

                            const parts = dateStr.split(/[-/]/); 
                            const year = parseInt(parts[0], 10);
                            const month = parseInt(parts[1], 10) - 1;
                            const day = parseInt(parts[2], 10) || 1;

                            const dayMap = { 'first': 1, 'last': 0, 'current': day };
                            const offset = type === 'last' ? monthOffset + 1 : monthOffset;
  
                            const target = new Date(year, month + offset, dayMap[type]);

                            const rYear = target.getFullYear();
                            const rMonth = String(target.getMonth() + 1).padStart(2, '0');
                            const rDay = String(target.getDate()).padStart(2, '0');

                            return [rYear, rMonth, rDay].join(sep);
                          };
                          const isCurrentMonth = (dateStr) => {
                            if (!dateStr) return false;

                            const parts = dateStr.split(/[-/]/);
                            const inputYear = parseInt(parts[0], 10);
                            const inputMonth = parseInt(parts[1], 10) - 1;

                            const now = new Date();
                            const currentYear = now.getFullYear();
                            const currentMonth = now.getMonth();

                            return inputYear === currentYear && inputMonth === currentMonth;
                          };
                          const mFirstDate = getTargetDate(et, 0, 'first');
                          const mLastDate = getTargetDate(et, 0, 'last');
                          const mMinus1FirstDate = getTargetDate(et, -1, 'first');
                          const mMinus1LastDate = getTargetDate(et, -1, 'last');
                          const mMinus5FirstDate = getTargetDate(et, -5, 'first');
                          const mMinus6FirstDate = getTargetDate(et, -6, 'first');
                          const isM = isCurrentMonth(et);

                          return Object.assign(
                            {},
                            {
                              logical_flag: 'trend_chart',
                              studio_code: frameCode,
                              filters: {},
                              accumulation: {
                                custom_accumulation: [
                                  { is_accumulation: true, key: 'game_code' },
                                  { is_accumulation: true, key: 'category' },
                                  { is_accumulation: false, key: 'studio' },
                                ],
                              },
                              start_date: isM ? mMinus6FirstDate : mMinus5FirstDate,
                              end_date: isM ? mMinus1LastDate : mLastDate,
                              sorted_by: 'date',
                              desc: true,
                              multi_sort: [{ sort_by: 'cs_si_iaa_revenue_m', desc: true }],
                              metrics: ['cs_si_iaa_revenue_m'],
                              period: 'monthly',
                            },
                          );
                        },
                        "formatData": (data) => { return data }
                      },
                      "children": [
                        {
                          "name": "DataMergeWrap",
                          "props": {
                            "dataKey": "selfIncubationTableData",
                            "sparklineDataKey": "selfIncubationSparklineData",
                            "dateSubtitleConfig": {
                              "templateEn": "Year to Month({{start}}~{{end}})",
                              "templateCn": "按月累计({{start}}~{{end}})"
                            }
                          },
                          "children": [
                            {
                              "name": "TableWithDateSubtitle",
                              "className": "margin-t-20 dbh-casual-table",
                              "props": {
                                "dataKey": "selfIncubationTableData",
                                "dataPath": "metrics_list",
                                "totalRecordPath": "row_count",
                                "metricsCardWrapProps": {
                                  "titleEn": "Self-Incubation Projects",
                                  "titleCn": "自孵化项目",
                                  "operation": [
                                    {
                                      "name": "DownloadButton",
                                      "className": "dbd-common-table__operation-btn",
                                      "config": {
                                        "apiDownload": {
                                          "fileNameEn": "Self-Incubation Projects",
                                          "fileNameCn": "自孵化项目",
                                          "sheetNameEn": "Self-Incubation Projects",
                                          "sheetNameCn": "自孵化项目",
                                          "api": "/api/v2/dashboard/studio/casual_hub/overview/overall_performance",
                                          "fixedPageSize": 50000,
                                          "formatData": (metricsList, context) => {
                                            const casualInfo = context && context.casualInfo;
                                            const games = casualInfo && casualInfo.games;
                                            const gameMap = {};
                                            if (games && games.length) {
                                              games.forEach((g) => {
                                                if (g.game_name) gameMap[g.game_name] = g;
                                                if (g.entity_name) gameMap[g.entity_name] = g;
                                                if (g.entity_name_cn) gameMap[g.entity_name_cn] = g;
                                              });
                                            }
                                            const rows = metricsList.map((item, index) => {
                                              const rawDate = item.date ? String(item.date) : '';
                                              const formattedDate = rawDate.length === 8
                                                ? `${rawDate.slice(0, 4)  }-${  rawDate.slice(4, 6)}`
                                                : rawDate;
                                              // 从 custom_dimensions 取维度，再用 gameMap 映射为真实游戏名
                                              const customDims = item.custom_dimensions;
                                              const getDimValue = (key) => {
                                                if (!customDims || !customDims.length) return '';
                                                const dim = customDims.find((d) => d.key === key);
                                                return (dim && dim.value) ? dim.value : '';
                                              };
                                              const rawGameCode = getDimValue('game_code');
                                              const gameInfo = gameMap[rawGameCode];
                                              const isEN = !!(context && context.isEN);
                                              const gameName = gameInfo ? (isEN ? (gameInfo.entity_name || gameInfo.entity_name_cn || rawGameCode) : (gameInfo.entity_name_cn || gameInfo.entity_name || rawGameCode)) : rawGameCode;
                                              const category = getDimValue('category');
                                              const {metrics} = item;
                                              const flatMetrics = {};
                                              if (metrics) {
                                                Object.keys(metrics).forEach((key) => {
                                                  const m = metrics[key];
                                                  flatMetrics[key] = (m && m.value !== undefined && m.value !== '') ? m.value : '';
                                                  flatMetrics[`${key  }_dod`] = (m && m.dod !== undefined && m.dod !== '') ? m.dod : '';
                                                });
                                              }
                                              return Object.assign({}, item, flatMetrics, {
                                                rank: index + 1,
                                                date: formattedDate,
                                                game_name: gameName,
                                                category,
                                              });
                                            });
                                            // 前端排序：读取用户当前排序状态（由 downloadSortKey 写入）
                                            const userSortState = context && context.selfIncubationDownloadSortState;
                                            const sortBy = (userSortState && userSortState.length > 0) ? userSortState[0].by : null;
                                            const sortDesc = (userSortState && userSortState.length > 0) ? userSortState[0].order === 'desc' : true;
                                            if (sortBy) {
                                              return rows.sort((a, b) => {
                                                const va = (a[sortBy] !== '' && a[sortBy] !== undefined && a[sortBy] !== null) ? Number(a[sortBy]) : (sortDesc ? -Infinity : Infinity);
                                                const vb = (b[sortBy] !== '' && b[sortBy] !== undefined && b[sortBy] !== null) ? Number(b[sortBy]) : (sortDesc ? -Infinity : Infinity);
                                                return sortDesc ? vb - va : va - vb;
                                              });
                                            }
                                            const defaultMetric = 'ytd_cs_si_iaa_revenue_m';
                                            return rows.sort((a, b) => {
                                              const va = (a[defaultMetric] !== '' && a[defaultMetric] !== undefined && a[defaultMetric] !== null) ? Number(a[defaultMetric]) : -Infinity;
                                              const vb = (b[defaultMetric] !== '' && b[defaultMetric] !== undefined && b[defaultMetric] !== null) ? Number(b[defaultMetric]) : -Infinity;
                                              return vb - va;
                                            });
                                          },
                                          "beforeRequest": (data) => {
                                            const frameCode = data && data.frameCode;
                                            const filter = data && data.filter;
                                            const fv = filter;
                                            const et = fv && fv.end_time;
                                            let endDateStr = '';
                                            let startDateStr = '';
                                            if (et) {
                                              // 和宽表 Service 一致：取筛选器 end_time 当月末
                                              const parts = String(et).trim().split(/[-/]/);
                                              const year = parseInt(parts[0], 10);
                                              const month = parseInt(parts[1], 10) - 1;
                                              const lastDay = new Date(year, month + 1, 0);
                                              const rYear = lastDay.getFullYear();
                                              const rMonth = String(lastDay.getMonth() + 1).padStart(2, '0');
                                              const rDay = String(lastDay.getDate()).padStart(2, '0');
                                              endDateStr = `${  rYear  }${rMonth  }${rDay}`;
                                              startDateStr = `${String(rYear)  }0101`;
                                            }
                                            return Object.assign(
                                              {},
                                              data.extraParams,
                                              {
                                                studio_code: frameCode,
                                                filters: {},
                                                accumulation: {
                                                  custom_accumulation: [
                                                    { is_accumulation: true, key: 'game_code' },
                                                    { is_accumulation: true, key: 'category' },
                                                    { is_accumulation: false, key: 'studio' },
                                                  ],
                                                },
                                                page: 1,
                                                page_size: 9999,
                                                start_date: startDateStr,
                                                end_date: endDateStr,
                                                sorted_by: 'ytd_cs_si_iaa_revenue_m',
                                                desc: true,
                                                multi_sort: [{ sort_by: 'ytd_cs_si_iaa_revenue_m', desc: true }],
                                                metrics: [
                                                  'ytd_cs_si_iaa_revenue_m',
                                                  'cs_si_iaa_revenue_m',
                                                  'ytd_cs_si_new_m',
                                                  'cs_si_new',
                                                  'ytd_cs_si_spend_m',
                                                  'cs_si_spend_m',
                                                  'cs_si_avg_dau',
                                                ],
                                                logical_flag: 'ytd_actual_date',
                                                period: 'monthly',
                                              },
                                            );
                                          },
                                          "columns": [
                                            { "code": "date", "name": "Date", "nameEn": "Date", "nameCn": "日期", "format": "@", "width": 120 },
                                            { "code": "game_name", "name": "Game", "nameEn": "Game", "nameCn": "游戏", "format": "@", "width": 200 },
                                            { "code": "category", "name": "Category", "nameEn": "Category", "nameCn": "类型", "format": "@", "width": 140 },
                                            { "code": "ytd_cs_si_iaa_revenue_m", "name": "IAA Revenue($)", "nameEn": "IAA Revenue($)", "nameCn": "IAA 收入($)", "format": "#,##0.00", "width": 160 },
                                            { "code": "ytd_cs_si_iaa_revenue_m_dod", "name": "IAA Revenue($)_mom", "nameEn": "IAA Revenue($)_mom", "nameCn": "IAA收入($)_月环比", "format": "0.0%", "width": 140 },
                                            { "code": "cs_si_iaa_revenue_m", "name": "Monthly IAA Revenue($)", "nameEn": "Monthly IAA Revenue($)", "nameCn": "月IAA收入($)", "format": "#,##0.00", "width": 180 },
                                            { "code": "cs_si_iaa_revenue_m_dod", "name": "Monthly IAA Revenue($)_mom", "nameEn": "Monthly IAA Revenue($)_mom", "nameCn": "月IAA收入($)_月环比", "format": "0.0%", "width": 180 },
                                            { "code": "ytd_cs_si_new_m", "name": "New", "nameEn": "New", "nameCn": "新进", "format": "#,##0", "width": 140 },
                                            { "code": "ytd_cs_si_new_m_dod", "name": "New_mom", "nameEn": "New_mom", "nameCn": "新进_月环比", "format": "0.0%", "width": 120 },
                                            { "code": "cs_si_new", "name": "Monthly New", "nameEn": "Monthly New", "nameCn": "月新进", "format": "#,##0", "width": 140 },
                                            { "code": "cs_si_new_dod", "name": "Monthly New_mom", "nameEn": "Monthly New_mom", "nameCn": "月新进_月环比", "format": "0.0%", "width": 120 },
                                            { "code": "cs_si_avg_dau", "name": "Avg.DAU", "nameEn": "Avg.DAU", "nameCn": "日均活跃", "format": "#,##0", "width": 160 },
                                            { "code": "cs_si_avg_dau_dod", "name": "Monthly Avg.DAU_mom", "nameEn": "Monthly Avg.DAU_mom", "nameCn": "日均活跃_月环比", "format": "0.0%", "width": 140 },
                                            { "code": "ytd_cs_si_spend_m", "name": "Spend($)", "nameEn": "Spend($)", "nameCn": "UA 花费($)", "format": "#,##0.00", "width": 140 },
                                            { "code": "ytd_cs_si_spend_m_dod", "name": "Spend($)_mom", "nameEn": "Spend($)_mom", "nameCn": "UA花费($)_月环比", "format": "0.0%", "width": 120 },
                                            { "code": "cs_si_spend_m", "name": "Monthly Spend($)", "nameEn": "Monthly Spend($)", "nameCn": "月UA花费($)", "format": "#,##0.00", "width": 160 },
                                            { "code": "cs_si_spend_m_dod", "name": "Monthly Spend($)_mom", "nameEn": "Monthly Spend($)_mom", "nameCn": "月UA花费($)_月环比", "format": "0.0%", "width": 140 },
                                          ]
                                        }
                                      }
                                    }
                                  ]
                                },
                                "commonBaseTableProps": {
                                  "tableConfig": {
                                    "hidePaginationWhenSinglePage": true,
                                    "pagination": {},
                                    "downloadSortKey": "selfIncubationDownloadSortState"
                                  },
                                  "columns": [
                                    {
                                      "nameEn": "Game",
                                      "nameCn": "游戏",
                                      "code": "game_name",
                                      "align": "left",
                                      "width": 250,
                                      "features": {
                                        "sortable": false,
                                        "cell": {
                                          "type": "gameIcon",
                                          "showRawOnHover": true,
                                          "rankKey": "rank",
                                          "iconKey": "game_icon",
                                          "nameKey": "game_name",
                                          "countryCodeKey": "country_code",
                                          "countryNameKey": "country_name"
                                        }
                                      }
                                    },
                                    {
                                      "nameEn": "Category",
                                      "nameCn": "类型",
                                      "code": "category",
                                      "align": "left",
                                      "width": 140,
                                      "features": {
                                        "sortable": false,
                                        "cell": {
                                          "type": "category",
                                          "valueMapping": {
                                            "Self-Incubation": {
                                              "color": "#28B463",
                                              "backgroundColor": "#EAFAF1",
                                              "label": "Self-Incubation"
                                            },
                                            "Self-incubation": {
                                              "color": "#28B463",
                                              "backgroundColor": "#EAFAF1",
                                              "label": "Self-incubation"
                                            }
                                          }
                                        }
                                      }
                                    },
                                    {
                                      "nameEn": "IAA Revenue($)",
                                      "nameCn": "IAA 收入($)",
                                      "code": "ytd_cs_si_iaa_revenue_m",
                                      "align": "right",
                                      "width": 240,
                                      "features": {
                                        "sortable": true,
                                        "explainEn": "Total Ad Revenue Generated from Players' Ad Views",
                                        "explainCn": "玩家观看广告后产生的全部广告收入",
                                        "cell": {
                                          "type": "sparkline",
                                          "showChangeRate": true,
                                          "showRawOnHover": true,
                                          "hoverFormatRule": "thousands2Decimal",
                                          "changeKey": "ytd_cs_si_iaa_revenue_m_dod",
                                          "dodDecimals": 2,
                                          "dodDownloadFormat": "0.0%",
                                          "hoverBubble": true,
                                          "sparklineKey": "sparkline_cs_si_iaa_revenue_m",
                                          "sparklineDatesKey": "sparkline_dates",
                                          "tooltipDateFormat": "YYYY-MM"
                                        },
                                        "format": "bmk00"
                                      }
                                    },
                                    {
                                      "nameEn": "New",
                                      "nameCn": "新进",
                                      "code": "ytd_cs_si_new_m",
                                      "align": "right",
                                      "width": 240,
                                      "features": {
                                        "sortable": true,
                                        "cell": {
                                          "type": "percentage",
                                          "showProgressBar": false,
                                          "showChangeRate": true,
                                          "showRawOnHover": true,
                                          "hoverFormatRule": "thousandsInit",
                                          "changeKey": "ytd_cs_si_new_m_dod",
                                          "formatDodAsPercent": true,
                                          "dodDecimals": 1,
                                          "dodDownloadFormat": "0.0%",
                                          "hoverBubble": true,
                                        },
                                        "explainEn": "Newly installed device count during the statistical period(device id deduplicated).Data more than 1 day show sum new",
                                        "explainCn": "统计周期内新安装设备数(xwid），超过一天展示累计新进",
                                        "format": "db_int_bmk00"
                                      }
                                    },
                                    {
                                      "nameEn": "Avg.DAU",
                                      "nameCn": "日均活跃",
                                      "code": "cs_si_avg_dau",
                                      "align": "right",
                                      "width": 240,
                                      "features": {
                                        "sortable": true,
                                        "cell": {
                                          "type": "percentage",
                                          "showProgressBar": false,
                                          "showChangeRate": true,
                                          "showRawOnHover": true,
                                          "hoverFormatRule": "thousandsInit",
                                          "changeKey": "cs_si_avg_dau_dod",
                                          "formatDodAsPercent": true,
                                          "dodDecimals": 1,
                                          "dodDownloadFormat": "0.0%",
                                          "hoverBubble": true,
                                        },
                                        "explainEn": " Based on the selected end month, this metric shows the average daily active users for that month.",
                                        "explainCn": "  统计周期为截止月份，表示对应月份平均每日活跃用户数。",
                                        "format": "db_int_bmk00"
                                      }
                                    },
                                    {
                                      "nameEn": "Spend($)",
                                      "nameCn": "UA 花费($)",
                                      "code": "ytd_cs_si_spend_m",
                                      "align": "right",
                                      "features": {
                                        "sortable": true,
                                        "cell": {
                                          "type": "percentage",
                                          "showProgressBar": false,
                                          "showChangeRate": true,
                                          "showRawOnHover": true,
                                          "hoverFormatRule": "thousands2Decimal",
                                          "changeKey": "ytd_cs_si_spend_m_dod",
                                          "formatDodAsPercent": true,
                                          "dodDecimals": 1,
                                          "dodDownloadFormat": "0.0%",
                                          "hoverBubble": true,
                                        },
                                        "explainEn": "UA Spend",
                                        "explainCn": "UA花费",
                                        "format": "bmk00"
                                      }
                                    }
                                  ]
                                }
                              }
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  "name": "Service",
                  "data": {
                    "searchKeyword": "",
                    "clientSearchKeyword": "",
                    "extraParams": {
                      "multi_sort": [
                        {
                          "sort_by": "ytd_cs_studio_total_revenue_m",
                          "desc": true
                        }
                      ],
                      "page": 1,
                      "page_size": 9999
                    }
                  },
                  "props": {
                    "api": "/api/v2/dashboard/studio/casual_hub/overview/overall_performance",
                    "trackData": [
                      "extraParams",
                      "frameCode"
                    ],
                    "dataKey": "studioOverviewTableData",
                    "filterLoading": false,
                    "beforeRequest": (data) => {
                      const { filterVal, frameCode } = data || {};
                      const frontendSearch = true; // 前后端搜索开关：true=前端, false=后端
                      const searchKeyword = !frontendSearch && data && data.searchKeyword ? String(data.searchKeyword).trim() : '';
                      const customFilters = searchKeyword ? [
                        {
                          key: 'game_code',
                          operate: 'like',
                          filter_list: [searchKeyword],
                        },
                      ] : [];
                      const et = filterVal?.end_time;
                      const getTargetDate = (dateStr, monthOffset = 0, type = 'current', sep = '') => {
                        if (!dateStr) return '';

                        const parts = dateStr.split(/[-/]/); 
                        const year = parseInt(parts[0], 10);
                        const month = parseInt(parts[1], 10) - 1;
                        const day = parseInt(parts[2], 10) || 1;

                        const dayMap = { 'first': 1, 'last': 0, 'current': day };
                        const offset = type === 'last' ? monthOffset + 1 : monthOffset;
  
                        const target = new Date(year, month + offset, dayMap[type]);

                        const rYear = target.getFullYear();
                        const rMonth = String(target.getMonth() + 1).padStart(2, '0');
                        const rDay = String(target.getDate()).padStart(2, '0');

                        return [rYear, rMonth, rDay].join(sep);
                      };
                      const isCurrentMonth = (dateStr) => {
                        if (!dateStr) return false;

                        const parts = dateStr.split(/[-/]/);
                        const inputYear = parseInt(parts[0], 10);
                        const inputMonth = parseInt(parts[1], 10) - 1;

                        const now = new Date();
                        const currentYear = now.getFullYear();
                        const currentMonth = now.getMonth();

                        return inputYear === currentYear && inputMonth === currentMonth;
                      };
                      const mFirstDate = getTargetDate(et, 0, 'first');
                      const mLastDate = getTargetDate(et, 0, 'last');
                      const mMinus1FirstDate = getTargetDate(et, -1, 'first');
                      const mMinus1LastDate = getTargetDate(et, -1, 'last');
                      const mMinus5FirstDate = getTargetDate(et, -5, 'first');
                      const mMinus6FirstDate = getTargetDate(et, -6, 'first');
                      const isM = isCurrentMonth(et);

                      return Object.assign(
                        {},
                        {
                          studio_code: frameCode,
                          filters: customFilters.length > 0 ? { custom_filters: customFilters } : {},
                          accumulation: {
                            custom_accumulation: [
                              { is_accumulation: true, key: 'game_code' },
                              { is_accumulation: false, key: 'category' },
                              { is_accumulation: true, key: 'studio' },
                            ],
                          },
                          page: 1,
                          page_size: frontendSearch ? 9999 : 10,
                          start_date: isM ? mMinus1FirstDate : mFirstDate,
                          end_date: isM ? mMinus1LastDate : mLastDate,
                          sorted_by: 'ytd_cs_studio_total_revenue_m',
                          desc: true,
                          multi_sort: [{ sort_by: 'ytd_cs_studio_total_revenue_m', desc: true }],
                          metrics: [
                            'ytd_cs_studio_total_revenue_m',
                            'ytd_cs_studio_iaa_revenue_m',
                            'ytd_cs_studio_iap_revenue_m',
                            'ytd_cs_studio_spend_m',
                          ],
                          logical_flag: 'ytd_actual_date',
                          period: 'monthly',
                        },
                        data.extraParams,
                      );
                    },
                    "formatData": (data) => { return data }
                  },
                  "children": [
                    {
                      "name": "Service",
                      "props": {
                        "api": "/api/v2/dashboard/studio/casual_hub/overview/overall_performance",
                        "trackData": [
                          "frameCode"
                        ],
                        "dataKey": "studioOverviewSparklineData",
                        "filterLoading": false,
                        "beforeRequest": (data) => {
                          const { filterVal, frameCode } = data || {};
                          const et = filterVal?.end_time;
                          const getTargetDate = (dateStr, monthOffset = 0, type = 'current', sep = '') => {
                            if (!dateStr) return '';

                            const parts = dateStr.split(/[-/]/); 
                            const year = parseInt(parts[0], 10);
                            const month = parseInt(parts[1], 10) - 1;
                            const day = parseInt(parts[2], 10) || 1;

                            const dayMap = { 'first': 1, 'last': 0, 'current': day };
                            const offset = type === 'last' ? monthOffset + 1 : monthOffset;
  
                            const target = new Date(year, month + offset, dayMap[type]);

                            const rYear = target.getFullYear();
                            const rMonth = String(target.getMonth() + 1).padStart(2, '0');
                            const rDay = String(target.getDate()).padStart(2, '0');

                            return [rYear, rMonth, rDay].join(sep);
                          };
                          const isCurrentMonth = (dateStr) => {
                            if (!dateStr) return false;

                            const parts = dateStr.split(/[-/]/);
                            const inputYear = parseInt(parts[0], 10);
                            const inputMonth = parseInt(parts[1], 10) - 1;

                            const now = new Date();
                            const currentYear = now.getFullYear();
                            const currentMonth = now.getMonth();

                            return inputYear === currentYear && inputMonth === currentMonth;
                          };
                          const mFirstDate = getTargetDate(et, 0, 'first');
                          const mLastDate = getTargetDate(et, 0, 'last');
                          const mMinus1FirstDate = getTargetDate(et, -1, 'first');
                          const mMinus1LastDate = getTargetDate(et, -1, 'last');
                          const mMinus5FirstDate = getTargetDate(et, -5, 'first');
                          const mMinus6FirstDate = getTargetDate(et, -6, 'first');
                          const isM = isCurrentMonth(et);

                          return Object.assign(
                            {},
                            {
                              logical_flag: 'trend_chart',
                              studio_code: frameCode,
                              filters: {},
                              accumulation: {
                                custom_accumulation: [
                                  { is_accumulation: true, key: 'game_code' },
                                  { is_accumulation: false, key: 'category' },
                                  { is_accumulation: true, key: 'studio' },
                                ],
                              },
                              start_date: isM ? mMinus6FirstDate : mMinus5FirstDate,
                              end_date: isM ? mMinus1LastDate : mLastDate,
                              sorted_by: 'date',
                              desc: true,
                              multi_sort: [{ sort_by: 'cs_studio_total_revenue_m', desc: true }],
                              metrics: [
                                'cs_studio_total_revenue_m',
                                'cs_studio_iaa_revenue_m',
                                'cs_studio_iap_revenue_m',
                              ],
                              period: 'monthly',
                            },
                          );
                        },
                        "formatData": (data) => { return data }
                      },
                      "children": [
                        {
                          "name": "DataMergeWrap",
                          "props": {
                            "dataKey": "studioOverviewTableData",
                            "sparklineDataKey": "studioOverviewSparklineData",
                            "studioIconMap": {
                              "Miniclip": "https://ogdb-cdn.intlgame.cn/aupload/admin/studio_hub/image/1741760898187_选中态.png",
                              "Miniclip Game Studios": "https://ogdb-cdn.intlgame.cn/aupload/admin/studio_hub/image/1741760898187_选中态.png"
                            },
                            "dateSubtitleConfig": {
                              "templateEn": "Year to Month({{start}}~{{end}})",
                              "templateCn": "按月累计({{start}}~{{end}})",
                              "subtitleEndTimeDataKey": "studioYtmActualEndTime"
                            }
                          },
                          "children": [
                            {
                              "name": "TableWithDateSubtitle",
                              "className": "margin-t-20",
                              "props": {
                                "dataKey": "studioOverviewTableData",
                                "dataPath": "metrics_list",
                                "clientFilter": {
                                  "searchKey": "clientSearchKeyword",
                                  "searchFields": [
                                    "game_name"
                                  ]
                                },
                                "metricsCardWrapProps": {
                                  "titleEn": "Studio Projects",
                                  "titleCn": "Studio项目",
                                  "operation": [
                                    {
                                      "name": "SearchBox",
                                      "className": "dbd-common-table__operation-btn",
                                      "props": {
                                        "showWhen": "function() {\n                                                                                    return true;\n                                                                                }",
                                        "placeholderEn": "Search games",
                                        "placeholderCn": "搜索游戏",
                                        "patchData": {
                                          "keys": "data.clientSearchKeyword"
                                        }
                                      }
                                    },
                                    {
                                      "name": "DownloadButton",
                                      "className": "dbd-common-table__operation-btn",
                                      "config": {
                                        "apiDownload": {
                                          "fileNameEn": "Studio Projects",
                                          "fileNameCn": "Studio项目",
                                          "sheetNameEn": "Studio Projects",
                                          "sheetNameCn": "Studio项目",
                                          "api": "/api/v2/dashboard/studio/casual_hub/overview/overall_performance",
                                          "fixedPageSize": 50000,
                                          "formatData": (metricsList, context) => {
                                            // 先展平数据
                                            // 用 casualInfo.games 把 game_code 映射成完整游戏名（与展示一致）
                                            const casualInfo = context && context.casualInfo;
                                            const games = casualInfo && casualInfo.games;
                                            const gameInfoMap = {};
                                            if (games && games.length) {
                                              games.forEach((g) => {
                                                if (g.game_name) gameInfoMap[g.game_name] = g;
                                                if (g.entity_name) gameInfoMap[g.entity_name] = g;
                                                if (g.entity_name_cn) gameInfoMap[g.entity_name_cn] = g;
                                              });
                                            }
                                            const rows = metricsList.map((item, index) => {
                                              const rawDate = item.date ? String(item.date) : '';
                                              const formattedDate = rawDate.length === 8
                                                ? `${rawDate.slice(0, 4)  }-${  rawDate.slice(4, 6)}`
                                                : rawDate;
                                              const customDims = item.custom_dimensions;
                                              const getDimValue = function (key) {
                                                if (!customDims || !customDims.length) return '';
                                                const dim = customDims.find((d) => { return d.key === key });
                                                return (dim && dim.value) ? dim.value : '';
                                              };
                                              const rawGameCode = getDimValue('game_code');
                                              const gameInfo = gameInfoMap[rawGameCode];
                                              const isEN = !!(context && context.isEN);
                                              const gameName = gameInfo ? (isEN ? (gameInfo.entity_name || gameInfo.entity_name_cn || rawGameCode) : (gameInfo.entity_name_cn || gameInfo.entity_name || rawGameCode)) : rawGameCode;
                                              const {metrics} = item;
                                              const flatMetrics = {};
                                              if (metrics) {
                                                Object.keys(metrics).forEach((key) => {
                                                  const m = metrics[key];
                                                  flatMetrics[key] = (m && m.value !== undefined && m.value !== '') ? m.value : '';
                                                  flatMetrics[`${key  }_dod`] = (m && m.dod !== undefined && m.dod !== '') ? m.dod : '';
                                                });
                                              }
                                              return Object.assign({}, item, flatMetrics, {
                                                rank: index + 1,
                                                date: formattedDate,
                                                game_name: gameName,
                                                studio_name: getDimValue('studio'),
                                              });
                                            });
                                            // 前端排序：读取用户当前排序状态（由 downloadSortKey 写入）
                                            const userSortState = context && context.studioDownloadSortState;
                                            const sortBy = (userSortState && userSortState.length > 0) ? userSortState[0].by : null;
                                            const sortDesc = (userSortState && userSortState.length > 0) ? userSortState[0].order === 'desc' : true;
                                            if (sortBy) {
                                              // 有用户排序：直接整体按该指标排序
                                              return rows.sort((a, b) => {
                                                const va = (a[sortBy] !== '' && a[sortBy] !== undefined && a[sortBy] !== null) ? Number(a[sortBy]) : (sortDesc ? -Infinity : Infinity);
                                                const vb = (b[sortBy] !== '' && b[sortBy] !== undefined && b[sortBy] !== null) ? Number(b[sortBy]) : (sortDesc ? -Infinity : Infinity);
                                                return sortDesc ? vb - va : va - vb;
                                              });
                                            }
                                            // 无用户排序：与宽表展示一致，显式按 ytd_cs_studio_total_revenue_m 降序
                                            // （不再按 game 分组，且不依赖接口返回顺序）
                                            const defaultMetric = 'ytd_cs_studio_total_revenue_m';
                                            return rows.sort((a, b) => {
                                              const va = (a[defaultMetric] !== '' && a[defaultMetric] !== undefined && a[defaultMetric] !== null) ? Number(a[defaultMetric]) : -Infinity;
                                              const vb = (b[defaultMetric] !== '' && b[defaultMetric] !== undefined && b[defaultMetric] !== null) ? Number(b[defaultMetric]) : -Infinity;
                                              return vb - va;
                                            });
                                          },
                                          "beforeRequest": (data) => {
                                            const filter = data && data.filter;
                                            const frameCode = data && data.frameCode;
                                            const fv = filter;
                                            const et = fv && fv.end_time;
                                            // 搜索关键词（前端搜索时从 clientSearchKeyword 读取）
                                            const searchKeyword = data && data.clientSearchKeyword ? String(data.clientSearchKeyword).trim() : '';
                                            const customFilters = searchKeyword ? [
                                              { key: 'game_code', operate: 'like', filter_list: [searchKeyword] },
                                            ] : [];
                                            // 优先用宽表实际截止日（和副标题一致），格式 YYYYMMDD
                                            const actualEndTime = data && data.studioYtmActualEndTime;
                                            let endDate = '';
                                            let startDate = '';
                                            if (actualEndTime && String(actualEndTime).length >= 6) {
                                              endDate = String(actualEndTime).replace(/-/g, '').slice(0, 8);
                                              startDate = `${endDate.slice(0, 4)  }0101`;
                                            } else if (et) {
                                              // 兜底：用筛选器 end_time 取当月末
                                              const parts = String(et).trim().split(/[-/]/);
                                              const year = parseInt(parts[0], 10);
                                              const month = parseInt(parts[1], 10) - 1;
                                              const lastDay = new Date(year, month + 1, 0);
                                              const rYear = lastDay.getFullYear();
                                              const rMonth = String(lastDay.getMonth() + 1).padStart(2, '0');
                                              const rDay = String(lastDay.getDate()).padStart(2, '0');
                                              endDate = `${  rYear  }${rMonth  }${rDay}`;
                                              startDate = `${String(rYear)  }0101`;
                                            }
                                            return Object.assign(
                                              {},
                                              data.extraParams,
                                              {
                                                studio_code: frameCode,
                                                filters: customFilters.length > 0 ? { custom_filters: customFilters } : {},
                                                accumulation: {
                                                  custom_accumulation: [
                                                    { is_accumulation: true, key: 'game_code' },
                                                    { is_accumulation: false, key: 'category' },
                                                    { is_accumulation: true, key: 'studio' },
                                                  ],
                                                },
                                                page: 1,
                                                page_size: 9999,
                                                start_date: startDate,
                                                end_date: endDate,
                                                sorted_by: 'ytd_cs_studio_total_revenue_m',
                                                desc: true,
                                                multi_sort: [{ sort_by: 'ytd_cs_studio_total_revenue_m', desc: true }],
                                                metrics: [
                                                  'ytd_cs_studio_total_revenue_m',
                                                  'cs_studio_total_revenue_m',
                                                  'ytd_cs_studio_iaa_revenue_m',
                                                  'cs_studio_iaa_revenue_m',
                                                  'ytd_cs_studio_iap_revenue_m',
                                                  'cs_studio_iap_revenue_m',
                                                  'ytd_cs_studio_spend_m',
                                                  'cs_studio_spend',
                                                ],
                                                logical_flag: 'ytd_actual_date',
                                                period: 'monthly',
                                              },
                                            );
                                          },
                                          "columns": [
                                            { "code": "date", "name": "Date", "nameEn": "Date", "nameCn": "日期", "format": "@", "width": 120 },
                                            { "code": "game_name", "name": "Game", "nameEn": "Game", "nameCn": "游戏", "format": "@", "width": 200 },
                                            { "code": "studio_name", "name": "Studio", "nameEn": "Studio", "nameCn": "Studio", "format": "@", "width": 160 },
                                            { "code": "ytd_cs_studio_total_revenue_m", "name": "Revenue($)", "nameEn": "Revenue($)", "nameCn": "总收入($)", "format": "#,##0.00", "width": 160 },
                                            { "code": "ytd_cs_studio_total_revenue_m_dod", "name": "Revenue($)_mom", "nameEn": "Revenue($)_mom", "nameCn": "总收入($)_月环比", "format": "0.0%", "width": 140 },
                                            { "code": "cs_studio_total_revenue_m", "name": "Monthly Revenue($)", "nameEn": "Monthly Revenue($)", "nameCn": "月总收入($)", "format": "#,##0.00", "width": 180 },
                                            { "code": "cs_studio_total_revenue_m_dod", "name": "Monthly Revenue($)_mom", "nameEn": "Monthly Revenue($)_mom", "nameCn": "月总收入($)_月环比", "format": "0.0%", "width": 160 },
                                            { "code": "ytd_cs_studio_iaa_revenue_m", "name": "IAA Revenue($)", "nameEn": "IAA Revenue($)", "nameCn": "IAA 收入($)", "format": "#,##0.00", "width": 160 },
                                            { "code": "ytd_cs_studio_iaa_revenue_m_dod", "name": "IAA Revenue($)_mom", "nameEn": "IAA Revenue($)_mom", "nameCn": "IAA收入($)_月环比", "format": "0.0%", "width": 140 },
                                            { "code": "cs_studio_iaa_revenue_m", "name": "Monthly IAA Revenue($)", "nameEn": "Monthly IAA Revenue($)", "nameCn": "月IAA收入($)", "format": "#,##0.00", "width": 180 },
                                            { "code": "cs_studio_iaa_revenue_m_dod", "name": "Monthly IAA Revenue($)_mom", "nameEn": "Monthly IAA Revenue($)_mom", "nameCn": "月IAA收入($)_月环比", "format": "0.0%", "width": 180 },
                                            { "code": "ytd_cs_studio_iap_revenue_m", "name": "IAP Revenue($)", "nameEn": "IAP Revenue($)", "nameCn": "IAP 收入($)", "format": "#,##0.00", "width": 160 },
                                            { "code": "ytd_cs_studio_iap_revenue_m_dod", "name": "IAP Revenue($)_mom", "nameEn": "IAP Revenue($)_mom", "nameCn": "IAP收入($)_月环比", "format": "0.0%", "width": 140 },
                                            { "code": "cs_studio_iap_revenue_m", "name": "Monthly IAP Revenue($)", "nameEn": "Monthly IAP Revenue($)", "nameCn": "月IAP收入($)", "format": "#,##0.00", "width": 180 },
                                            { "code": "cs_studio_iap_revenue_m_dod", "name": "Monthly IAP Revenue($)_mom", "nameEn": "Monthly IAP Revenue($)_mom", "nameCn": "月IAP收入($)_月环比", "format": "0.0%", "width": 160 },
                                            { "code": "ytd_cs_studio_spend_m", "name": "Spend($)", "nameEn": "Spend($)", "nameCn": "UA 花费($)", "format": "#,##0.00", "width": 140 },
                                            { "code": "ytd_cs_studio_spend_m_dod", "name": "Spend($)_mom", "nameEn": "Spend($)_mom", "nameCn": "UA花费($)_月环比", "format": "0.0%", "width": 120 },
                                            { "code": "cs_studio_spend", "name": "Monthly Spend($)", "nameEn": "Monthly Spend($)", "nameCn": "月UA花费($)", "format": "#,##0.00", "width": 160 },
                                            { "code": "cs_studio_spend_dod", "name": "Monthly Spend($)_mom", "nameEn": "Monthly Spend($)_mom", "nameCn": "月UA花费($)_月环比", "format": "0.0%", "width": 140 },
                                          ]
                                        }
                                      }
                                    }
                                  ]
                                },
                                "commonBaseTableProps": {
                                  "height": 806.83,
                                  "tableConfig": {
                                    "tableHeight": 756.85,
                                    "isOpenForegroundPage": true,
                                    "hoverBubbleDateFormat": "YYYY-MM",
                                    "pagination": {},
                                    "downloadSortKey": "studioDownloadSortState"
                                  },
                                  "columns": [
                                    {
                                      "nameEn": "Games",
                                      "nameCn": "游戏",
                                      "code": "game_name",
                                      "align": "left",
                                      "width": 250,
                                      "features": {
                                        "sortable": false,
                                        "cell": {
                                          "type": "gameIcon",
                                          "showRawOnHover": true,
                                          "rankKey": "rank",
                                          "iconKey": "game_icon",
                                          "nameKey": "game_name",
                                          "countryCodeKey": "country_code",
                                          "countryNameKey": "country_name"
                                        }
                                      }
                                    },
                                    {
                                      "nameEn": "Studio",
                                      "nameCn": "Studio",
                                      "code": "studio_name",
                                      "align": "left",
                                      "width": 140,
                                      "features": {
                                        "sortable": false,
                                        "cell": {
                                          "type": "studioIcon",
                                          "iconKey": "studio_icon",
                                          "nameKey": "studio_name"
                                        }
                                      }
                                    },
                                    {
                                      "nameEn": "Revenue($)",
                                      "nameCn": "总收入($)",
                                      "code": "ytd_cs_studio_total_revenue_m",
                                      "align": "right",
                                      "width": 240,
                                      "features": {
                                        "sortable": true,
                                        "cell": {
                                          "type": "sparkline",
                                          "showChangeRate": true,
                                          "showRawOnHover": true,
                                          "hoverFormatRule": "thousands2Decimal",
                                          "changeKey": "ytd_cs_studio_total_revenue_m_dod",
                                          "dodDecimals": 2,
                                          "dodDownloadFormat": "0.0%",
                                          "hoverBubble": true,
                                          "sparklineKey": "sparkline_cs_studio_total_revenue_m",
                                          "sparklineDatesKey": "sparkline_dates",
                                          "tooltipDateFormat": "YYYY-MM"
                                        },
                                        "explainEn": "Total Revenue = IAP Revenue + Ad Revenue",
                                        "explainCn": "总收入=游戏内购收入+广告收入",
                                        "format": "bmk00"
                                      }
                                    },
                                    {
                                      "nameEn": "IAA Revenue($)",
                                      "nameCn": "IAA 收入($)",
                                      "code": "ytd_cs_studio_iaa_revenue_m",
                                      "align": "right",
                                      "width": 240,
                                      "features": {
                                        "sortable": true,
                                        "cell": {
                                          "type": "sparkline",
                                          "showChangeRate": true,
                                          "showRawOnHover": true,
                                          "hoverFormatRule": "thousands2Decimal",
                                          "changeKey": "ytd_cs_studio_iaa_revenue_m_dod",
                                          "dodDecimals": 2,
                                          "dodDownloadFormat": "0.0%",
                                          "hoverBubble": true,
                                          "sparklineKey": "sparkline_cs_studio_iaa_revenue_m",
                                          "sparklineDatesKey": "sparkline_dates",
                                          "tooltipDateFormat": "YYYY-MM"
                                        },
                                        "explainEn": "Total Ad Revenue Generated from Players' Ad Views",
                                        "explainCn": "玩家观看广告后产生的全部广告收入",
                                        "format": "bmk00"
                                      }
                                    },
                                    {
                                      "nameEn": "IAP Revenue($)",
                                      "nameCn": "IAP 收入($)",
                                      "code": "ytd_cs_studio_iap_revenue_m",
                                      "align": "right",
                                      "width": 240,
                                      "features": {
                                        "sortable": true,
                                        "cell": {
                                          "type": "sparkline",
                                          "showChangeRate": true,
                                          "showRawOnHover": true,
                                          "hoverFormatRule": "thousands2Decimal",
                                          "changeKey": "ytd_cs_studio_iap_revenue_m_dod",
                                          "dodDecimals": 2,
                                          "dodDownloadFormat": "0.0%",
                                          "hoverBubble": true,
                                          "sparklineKey": "sparkline_cs_studio_iap_revenue_m",
                                          "sparklineDatesKey": "sparkline_dates",
                                          "tooltipDateFormat": "YYYY-MM"
                                        },
                                        "explainEn": "Revenue generated from users’ in-app purchases, such as items, bundles, and subscriptions.",
                                        "explainCn": "用户通过游戏内购买道具、礼包、订阅等产生的收入。",
                                        "format": "bmk00"
                                      }
                                    },
                                    {
                                      "nameEn": "Spend($)",
                                      "nameCn": "UA 花费($)",
                                      "code": "ytd_cs_studio_spend_m",
                                      "align": "right",
                                      "features": {
                                        "sortable": true,
                                        "cell": {
                                          "type": "percentage",
                                          "showProgressBar": false,
                                          "showChangeRate": true,
                                          "showRawOnHover": true,
                                          "hoverFormatRule": "thousands2Decimal",
                                          "changeKey": "ytd_cs_studio_spend_m_dod",
                                          "formatDodAsPercent": true,
                                          "dodDecimals": 1,
                                          "dodDownloadFormat": "0.0%",
                                          "hoverBubble": true,
                                        },
                                        "explainEn": "UA Spend",
                                        "explainCn": "UA花费",
                                        "format": "bmk00"
                                      }
                                    }
                                  ]
                                }
                              }
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "name": "CommonLogWrap",
      "tabId": "month",
      "config": {
        "logConfig": {
          "menuId": "",
          "pageId": "903002",
          "pageName": "IEGG Casual Overview Month",
          "extInfo": "Casual Studio Overview Month",
          "pagePath": "/home/month"
        }
      },
      "children": [
        {
          "name": "CommonTabContentWrap",
          "children": [
            {
              "name": "CasualOverviewWrap",
              "children": [
                {
                  "name": "CommonRow",
                  "className": "dbh-casual-overview__row",
                  "type": "layout",
                  "props": {},
                  "children": [
                    {
                      "name": "CommonCol",
                      "type": "layout",
                      "props": {
                        "w": 8
                      },
                      "children": [
                        {
                          "name": "Service",
                          "className": "",
                          "type": "view",
                          "props": {
                            "api": "/api/v2/dashboard/studio/casual_hub/overview/card_metrics",
                            "trackData": [
                              "extraParams",
                              "frameCode"
                            ],
                            "dataKey": "casualTotalRevenueYtmMetricCardData",
                            "filterLoading": false,
                            "beforeRequest": (data) => {
                              const { filterVal, frameCode } = data || {};
                              const shiftMonths = function (ymd, delta) {
                                const m = /^([0-9]{4})-([0-9]{2})-([0-9]{2})$/.exec(String(ymd).trim().slice(0, 10));
                                if (!m) return ymd;
                                const y = Number(m[1]);
                                const mo = Number(m[2]);
                                const d = Number(m[3]);
                                const dt = new Date(y, mo - 1 + delta, d);
                                return `${dt.getFullYear()  }-${  String(dt.getMonth() + 1).padStart(2, '0')  }-${  String(dt.getDate()).padStart(2, '0')}`;
                              };
                              const endTime = filterVal && filterVal.end_time;
                              let trendSixMonthStart;
                              if (endTime) {
                                const datePart = String(endTime).trim().slice(0, 10);
                                const match = /^([0-9]{4})-([0-9]{2})-([0-9]{2})$/.exec(datePart);
                                if (match) {
                                  const year = Number(match[1]);
                                  const month = Number(match[2]);
                                  const day = Number(match[3]);
                                  if (month >= 1 && month <= 12 && day >= 1 && day <= 31) {
                                    const parsed = new Date(year, month - 1, day);
                                    if (
                                      parsed.getFullYear() === year &&
          parsed.getMonth() === month - 1 &&
          parsed.getDate() === day
                                    ) {
                                      const start = new Date(year, month - 1 - 5, 1);
                                      trendSixMonthStart = `${start.getFullYear()  }-${  String(start.getMonth() + 1).padStart(2, '0')  }-${  String(start.getDate()).padStart(2, '0')}`;
                                    }
                                  }
                                }
                              }
                              let baseStart;
                              if (filterVal && filterVal.is_confirm === false) {
                                baseStart = trendSixMonthStart || (filterVal && filterVal.start_time);
                                if (!trendSixMonthStart && baseStart) {
                                  baseStart = shiftMonths(baseStart, -5);
                                }
                              } else {
                                baseStart = filterVal && filterVal.start_time;
                              }
                              return Object.assign(
                                {},
                                {
                                  studio_code: frameCode,
                                  filters: {},
                                  period: 'monthly',
                                  start_time: baseStart,
                                  end_time: filterVal && filterVal.end_time,
                                  is_confirm: filterVal?.is_confirm,
                                  metrics: ['cs_casual_total_revenue_m', 'cs_self_incubation_revenue_m', 'cs_studio_total_revenue'],
                                  trend_metrics: [
                                    'cs_studio_total_revenue',
                                    'cs_self_incubation_revenue_m',
                                  ],
                                },
                                data.extraParams,
                              );
                            },
                            "formatData": (data) => {
                              const rawCardList = data && data.card_list ? data.card_list : [];
                              const cardList = rawCardList.map((card) => {
                                const result = {
                                  metrics_name: card.metrics_name,
                                  value: card.value,
                                  time: card.time,
                                };
                                const {dod} = card;
                                if (dod) {
                                  result.dod = {
                                    show_value: dod.show_value || '',
                                    this_value: dod.this_value || '',
                                    last_value: dod.last_value || '',
                                    this_time: dod.this_time || '',
                                    last_time: dod.last_time || '',
                                  };
                                }
                                const {sdlw} = card;
                                if (sdlw) {
                                  result.yoy = {
                                    show_value: sdlw.show_value || '',
                                    this_value: sdlw.this_value || '',
                                    last_value: sdlw.last_value || '',
                                    this_time: sdlw.this_time || '',
                                    last_time: sdlw.last_time || '',
                                  };
                                }
                                const {change} = card;
                                if (change) {
                                  result.change = {
                                    show_value: change.show_value || '',
                                    this_value: change.this_value || '',
                                    last_value: change.last_value || '',
                                    this_time: change.this_time || '',
                                    last_time: change.last_time || '',
                                  };
                                }
                                return result;
                              });
                              const rawTrendList = data && data.trend_list ? data.trend_list : [];
                              const trendList = rawTrendList.map((item) => {
                                const dateStr = item.date;
                                const formattedDate = dateStr && dateStr.length === 8
                                  ? dateStr.slice(0, 6)
                                  : dateStr;
                                return {
                                  date: formattedDate,
                                  metrics: item.metrics,
                                };
                              });
                              return {
                                card_list: cardList,
                                trend_list: trendList,
                                breakdown: (data && data.breakdown) || [],
                              };
                            }
                          },
                          "children": [
                            {
                              "name": "CasualTotalRevenueCard",
                              "props": {
                                "apiDataKey": "casualTotalRevenueYtmMetricCardData",
                                "config": {
                                  "titleEn": "Casual Total Revenue",
                                  "titleCn": "休闲游戏总收入",
                                  "metricKey": "cs_casual_total_revenue_m",
                                  "formatRule": "bmk00",
                                  "preUnit": "$",
                                  "donutSegments": [
                                    {
                                      "label": "Miniclip",
                                      "labelCn": "Miniclip",
                                      "value": 70,
                                      "color": "#69D19C",
                                      "metricKey": "cs_studio_total_revenue"
                                    },
                                    {
                                      "label": "Self-Incubation",
                                      "labelCn": "自孵化项目",
                                      "value": 30,
                                      "color": "#5086F3",
                                      "metricKey": "cs_self_incubation_revenue_m"
                                    }
                                  ],
                                  "trendMetrics": [
                                    {
                                      "metricKey": "cs_studio_total_revenue",
                                      "nameEn": "Miniclip",
                                      "nameCn": "Miniclip",
                                      "formatRule": "bmk00",
                                      "color": "#69D19C"
                                    },
                                    {
                                      "metricKey": "cs_self_incubation_revenue_m",
                                      "nameEn": "Self-Incubation",
                                      "nameCn": "自孵化项目",
                                      "formatRule": "bmk00",
                                      "color": "#5086F3"
                                    }
                                  ],
                                  "trendTitleEn": "Revenue Trend",
                                  "trendTitleCn": "收入趋势",
                                  "trendShowConfig": {
                                    "showBarChart": true,
                                    "showLineChart": false,
                                    "showBubbleTitle": true,
                                    "isStackBar": true,
                                    "stackBarShowTotalLabel": false
                                  },
                                  "compareMetrics": [
                                    {
                                      "dataKey": "dod",
                                      "titleEn": "MoM",
                                      "titleCn": "月环比",
                                      "when": "single"
                                    },
                                    {
                                      "dataKey": "yoy",
                                      "titleEn": "YoY",
                                      "titleCn": "同比",
                                      "when": "single"
                                    },
                                    {
                                      "dataKey": "change",
                                      "titleEn": "Change",
                                      "titleCn": "变化率",
                                      "when": "multi"
                                    }
                                  ]
                                }
                              }
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "name": "CommonCol",
                      "type": "layout",
                      "props": {
                        "w": 8
                      },
                      "children": [
                        {
                          "name": "Service",
                          "className": "",
                          "type": "view",
                          "props": {
                            "api": "/api/v2/dashboard/studio/casual_hub/overview/card_metrics",
                            "trackData": [
                              "extraParams",
                              "frameCode"
                            ],
                            "dataKey": "selfIncubationRevenueYtmMetricCardData",
                            "filterLoading": false,
                            "beforeRequest": (data) => {
                              const { filterVal, frameCode } = data || {};
                              const shiftMonths = function (ymd, delta) {
                                const m = /^([0-9]{4})-([0-9]{2})-([0-9]{2})$/.exec(String(ymd).trim().slice(0, 10));
                                if (!m) return ymd;
                                const y = Number(m[1]);
                                const mo = Number(m[2]);
                                const d = Number(m[3]);
                                const dt = new Date(y, mo - 1 + delta, d);
                                return `${dt.getFullYear()  }-${  String(dt.getMonth() + 1).padStart(2, '0')  }-${  String(dt.getDate()).padStart(2, '0')}`;
                              };
                              let startTime = filterVal && filterVal.start_time;
                              if (filterVal && filterVal.is_confirm === false && startTime) {
                                startTime = shiftMonths(startTime, -5);
                              }
                              return Object.assign(
                                {},
                                {
                                  studio_code: frameCode,
                                  filters: {},
                                  period: 'monthly',
                                  start_time: startTime,
                                  end_time: filterVal && filterVal.end_time,
                                  card_type: '1',
                                  is_confirm: filterVal?.is_confirm,
                                  breakdown_dimension: 'game_code',
                                  logical_flag: 'top_no_others',
                                  metrics: ['cs_self_incubation_revenue_m', 'cs_self_incubation_mau', 'cs_overall_d2'],
                                  trend_metrics: ['cs_self_incubation_revenue_m'],
                                  breakdown_metrics: 'cs_si_iaa_revenue_m',
                                },
                                data.extraParams,
                              );
                            },
                            "formatData": (data) => {
                              const rawCardList = data && data.card_list ? data.card_list : [];
                              const cardList = rawCardList.map((card) => {
                                const result = {
                                  metrics_name: card.metrics_name,
                                  value: card.value,
                                  time: card.time,
                                };
                                const {dod} = card;
                                if (dod) {
                                  result.dod = {
                                    show_value: dod.show_value || '',
                                    this_value: dod.this_value || '',
                                    last_value: dod.last_value || '',
                                    this_time: dod.this_time || '',
                                    last_time: dod.last_time || '',
                                  };
                                }
                                const {sdlw} = card;
                                if (sdlw) {
                                  result.yoy = {
                                    show_value: sdlw.show_value || '',
                                    this_value: sdlw.this_value || '',
                                    last_value: sdlw.last_value || '',
                                    this_time: sdlw.this_time || '',
                                    last_time: sdlw.last_time || '',
                                  };
                                }
                                const {change} = card;
                                if (change) {
                                  result.change = {
                                    show_value: change.show_value || '',
                                    this_value: change.this_value || '',
                                    last_value: change.last_value || '',
                                    this_time: change.this_time || '',
                                    last_time: change.last_time || '',
                                  };
                                }
                                return result;
                              });
                              const rawTrendList = data && data.trend_list ? data.trend_list : [];
                              const trendList = rawTrendList.map((item) => {
                                const dateStr = item.date;
                                const formattedDate = dateStr && dateStr.length === 8
                                  ? dateStr.slice(0, 6)
                                  : dateStr;
                                return {
                                  date: formattedDate,
                                  metrics: item.metrics,
                                };
                              });
                              const rawBreakdown = data && data.breakdown ? data.breakdown : [];
                              const sortedBreakdown = rawBreakdown
                                .slice()
                                .sort((a, b) => {
                                  return parseFloat(String(b.value || '0')) - parseFloat(String(a.value || '0'));
                                })
                                .slice(0, 3);
                              const gameRanks = sortedBreakdown.map((item, idx) => {
                                return {
                                  gameCode: item.name || item.full_name || '',
                                  rank: idx + 1,
                                  name: String(item.full_name || item.name || ''),
                                };
                              });
                              return {
                                card_list: cardList,
                                trend_list: trendList,
                                breakdown: (data && data.breakdown) || [],
                                gameRanks,
                              };
                            }
                          },
                          "children": [
                            {
                              "name": "CasualSubMetricCard",
                              "props": {
                                "apiDataKey": "selfIncubationRevenueYtmMetricCardData",
                                "config": {
                                  "titleEn": "Self-Incubation Revenue",
                                  "titleCn": "自孵化项目收入",
                                  "metricKey": "cs_self_incubation_revenue_m",
                                  "formatRule": "bmk00",
                                  "preUnit": "$",
                                  "useDataGameRanks": true,
                                  "gameRankJumpType": "window",
                                  "useDynamicSubtitle": true,
                                  "subtitleMode": "filterRange",
                                  "subMetrics": [
                                    {
                                      "labelEn": "MAU",
                                      "labelCn": "月活跃",
                                      "metricKey": "cs_self_incubation_mau",
                                      "formatRule": "bmk00",
                                      "preUnit": "",
                                      "useDynamicSubtitle": false
                                    },
                                    {
                                      "labelEn": "D2 Retention",
                                      "labelCn": "次日留存",
                                      "metricKey": "cs_overall_d2",
                                      "formatRule": "percent2Decimal",
                                      "preUnit": "",
                                      "useDynamicSubtitle": false
                                    }
                                  ],
                                  "trendConfig": {
                                    "metricKey": "cs_self_incubation_revenue_m",
                                    "nameEn": "Revenue",
                                    "nameCn": "总收入"
                                  },
                                  "trendTitleEn": "Revenue Trend",
                                  "trendTitleCn": "收入趋势",
                                  "compareMetrics": [
                                    {
                                      "dataKey": "dod",
                                      "titleEn": "MoM",
                                      "titleCn": "月环比",
                                      "when": "single"
                                    },
                                    {
                                      "dataKey": "yoy",
                                      "titleEn": "YoY",
                                      "titleCn": "同比",
                                      "when": "single"
                                    },
                                    {
                                      "dataKey": "change",
                                      "titleEn": "Change",
                                      "titleCn": "变化率",
                                      "when": "multi"
                                    }
                                  ]
                                }
                              }
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "name": "CommonCol",
                      "type": "layout",
                      "props": {
                        "w": 8
                      },
                      "children": [
                        {
                          "name": "Service",
                          "className": "",
                          "type": "view",
                          "props": {
                            "api": "/api/v2/dashboard/studio/casual_hub/overview/card_metrics",
                            "trackData": [
                              "extraParams",
                              "frameCode"
                            ],
                            "dataKey": "studioRevenueYtmMetricCardData",
                            "filterLoading": false,
                            "beforeRequest": (data) => {
                              const { filterVal, frameCode } = data || {};
                              const shiftMonths = function (ymd, delta) {
                                const m = /^([0-9]{4})-([0-9]{2})-([0-9]{2})$/.exec(String(ymd).trim().slice(0, 10));
                                if (!m) return ymd;
                                const y = Number(m[1]);
                                const mo = Number(m[2]);
                                const d = Number(m[3]);
                                const dt = new Date(y, mo - 1 + delta, d);
                                return `${dt.getFullYear()  }-${  String(dt.getMonth() + 1).padStart(2, '0')  }-${  String(dt.getDate()).padStart(2, '0')}`;
                              };
                              let startTime = filterVal && filterVal.start_time;
                              if (filterVal && filterVal.is_confirm === false && startTime) {
                                startTime = shiftMonths(startTime, -5);
                              }
                              return Object.assign(
                                {},
                                {
                                  studio_code: frameCode,
                                  filters: {},
                                  period: 'monthly',
                                  start_time: startTime,
                                  end_time: filterVal && filterVal.end_time,
                                  card_type: '1',
                                  is_confirm: filterVal?.is_confirm,
                                  breakdown_dimension: 'game_code',
                                  logical_flag: 'top_no_others',
                                  metrics: ['cs_studio_total_revenue_m', 'cs_studio_iaa_revenue_m', 'cs_studio_iap_revenue_m'],
                                  trend_metrics: ['cs_studio_total_revenue_m'],
                                  breakdown_metrics: 'cs_studio_total_revenue_m',
                                },
                                data.extraParams,
                              );
                            },
                            "formatData": (data) => {
                              const rawCardList = data && data.card_list ? data.card_list : [];
                              const cardList = rawCardList.map((card) => {
                                const result = {
                                  metrics_name: card.metrics_name,
                                  value: card.value,
                                  time: card.time,
                                };
                                const {dod} = card;
                                if (dod) {
                                  result.dod = {
                                    show_value: dod.show_value || '',
                                    this_value: dod.this_value || '',
                                    last_value: dod.last_value || '',
                                    this_time: dod.this_time || '',
                                    last_time: dod.last_time || '',
                                  };
                                }
                                const {sdlw} = card;
                                if (sdlw) {
                                  result.yoy = {
                                    show_value: sdlw.show_value || '',
                                    this_value: sdlw.this_value || '',
                                    last_value: sdlw.last_value || '',
                                    this_time: sdlw.this_time || '',
                                    last_time: sdlw.last_time || '',
                                  };
                                }
                                const {change} = card;
                                if (change) {
                                  result.change = {
                                    show_value: change.show_value || '',
                                    this_value: change.this_value || '',
                                    last_value: change.last_value || '',
                                    this_time: change.this_time || '',
                                    last_time: change.last_time || '',
                                  };
                                }
                                return result;
                              });
                              const rawTrendList = data && data.trend_list ? data.trend_list : [];
                              const trendList = rawTrendList.map((item) => {
                                const dateStr = item.date;
                                const formattedDate = dateStr && dateStr.length === 8
                                  ? dateStr.slice(0, 6)
                                  : dateStr;
                                return {
                                  date: formattedDate,
                                  metrics: item.metrics,
                                };
                              });
                              const rawBreakdown = data && data.breakdown ? data.breakdown : [];
                              const sortedBreakdown = rawBreakdown
                                .slice()
                                .sort((a, b) => {
                                  return parseFloat(String(b.value || '0')) - parseFloat(String(a.value || '0'));
                                })
                                .slice(0, 3);
                              const gameRanks = sortedBreakdown.map((item, idx) => {
                                return {
                                  gameCode: item.name || item.full_name || '',
                                  rank: idx + 1,
                                  name: String(item.full_name || item.name || ''),
                                };
                              });
                              return {
                                card_list: cardList,
                                trend_list: trendList,
                                breakdown: (data && data.breakdown) || [],
                                gameRanks,
                              };
                            }
                          },
                          "children": [
                            {
                              "name": "Service",
                              "className": "",
                              "type": "view",
                              "props": {
                                "api": "/api/v2/dashboard/studio/casual_hub/overview/card_metrics",
                                "trackData": [
                                  "extraParams",
                                  "frameCode"
                                ],
                                "dataKey": "miniclipMonthTabSubtitleTimeData",
                                "filterLoading": false,
                                "beforeRequest": (data) => {
                                  const { filterVal, frameCode } = data || {};
                                  const et = filterVal?.end_time;
                                  let monthStart = '';
                                  let monthEnd = '';
                                  if (et) {
                                    const datePart = String(et).trim().slice(0, 10);
                                    const match = /^([0-9]{4})-([0-9]{2})-([0-9]{2})$/.exec(datePart);
                                    if (match) {
                                      const year = Number(match[1]);
                                      const month = Number(match[2]);
                                      const day = Number(match[3]);
                                      if (month >= 1 && month <= 12 && day >= 1 && day <= 31) {
                                        const parsed = new Date(year, month - 1, day);
                                        if (
                                          parsed.getFullYear() === year &&
                                          parsed.getMonth() === month - 1 &&
                                          parsed.getDate() === day
                                        ) {
                                          const lastDay = new Date(year, month, 0).getDate();
                                          monthStart =
                                            `${year 
                                            }-${ 
                                              String(month).padStart(2, '0') 
                                            }-01`;
                                          monthEnd =
                                            `${year 
                                            }-${ 
                                              String(month).padStart(2, '0') 
                                            }-${ 
                                              String(lastDay).padStart(2, '0')}`;
                                        }
                                      }
                                    }
                                  }
                                  if (!monthStart || !monthEnd) {
                                    return false;
                                  }
                                  return Object.assign(
                                    {},
                                    {
                                      studio_code: frameCode,
                                      filters: {},
                                      period: 'monthly',
                                      start_time: monthStart,
                                      end_time: monthEnd,
                                      logical_flag: 'fallback_latest_date',
                                      is_confirm: false,
                                      metrics: ['cs_studio_total_revenue_m'],
                                    },
                                    data.extraParams,
                                  );
                                },
                                "formatData": (data) => {
                                  const rawCardList = data && data.card_list ? data.card_list : [];
                                  const cardList = rawCardList.map((card) => {
                                    return {
                                      metrics_name: card.metrics_name,
                                      value: card.value,
                                      time: card.time,
                                    };
                                  });
                                  return {
                                    card_list: cardList,
                                    trend_list: [],
                                  };
                                }
                              },
                              "children": [
                                {
                                  "name": "CasualSubMetricCard",
                                  "props": {
                                    "apiDataKey": "studioRevenueYtmMetricCardData",
                                    "config": {
                                      "titleEn": "Miniclip Revenue",
                                      "titleCn": "Miniclip收入",
                                      "titleIconUrl": "https://ogdb-cdn.intlgame.cn/aupload/admin/studio_hub/image/1741760898187_选中态.png",
                                      "metricKey": "cs_studio_total_revenue_m",
                                      "subtitleTimeMetricKey": "cs_studio_total_revenue_m",
                                      "subtitleTimeApiDataKey": "miniclipMonthTabSubtitleTimeData",
                                      "subtitleChangeKey": "studioMonthActualEndTime",
                                      "formatRule": "bmk00",
                                      "preUnit": "$",
                                      "isRightCard": true,
                                      "useDataGameRanks": true,
                                      "useDynamicSubtitle": true,
                                      "subtitleMode": "metricTime",
                                      "subMetrics": [
                                        {
                                          "labelEn": "IAP Revenue",
                                          "labelCn": "IAP 收入",
                                          "metricKey": "cs_studio_iap_revenue_m",
                                          "formatRule": "bmk00",
                                          "preUnit": "$"
                                        },
                                        {
                                          "labelEn": "IAA Revenue",
                                          "labelCn": "IAA 收入",
                                          "metricKey": "cs_studio_iaa_revenue_m",
                                          "formatRule": "bmk00",
                                          "preUnit": "$"
                                        }
                                      ],
                                      "trendConfig": {
                                        "metricKey": "cs_studio_total_revenue_m",
                                        "nameEn": "Revenue",
                                        "nameCn": "总收入"
                                      },
                                      "trendTitleEn": "Revenue Trend",
                                      "trendTitleCn": "收入趋势",
                                      "compareMetrics": [
                                        {
                                          "dataKey": "dod",
                                          "titleEn": "MoM",
                                          "titleCn": "月环比",
                                          "when": "single"
                                        },
                                        {
                                          "dataKey": "yoy",
                                          "titleEn": "YoY",
                                          "titleCn": "同比",
                                          "when": "single"
                                        },
                                        {
                                          "dataKey": "change",
                                          "titleEn": "Change",
                                          "titleCn": "变化率",
                                          "when": "multi"
                                        }
                                      ]
                                    }
                                  }
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  "name": "Service",
                  "data": {
                    "extraParams": {
                      "multi_sort": [
                        {
                          "sort_by": "cs_si_iaa_revenue_m",
                          "desc": true
                        }
                      ],
                      "page": 1,
                      "page_size": 9999
                    }
                  },
                  "props": {
                    "api": "/api/v2/dashboard/studio/casual_hub/overview/overall_performance",
                    "trackData": [
                      "extraParams",
                      "frameCode"
                    ],
                    "dataKey": "selfIncubationTableData",
                    "filterLoading": false,
                    "beforeRequest": (data) => {
                      const { filterVal, frameCode } = data || {};
                      const st = filterVal && filterVal.start_time;
                      const et = filterVal && filterVal.end_time;
                      const startDateStr = st ? String(st).trim().slice(0, 10).split('-').join('') : '';
                      const endDateStr = et ? String(et).trim().slice(0, 10).split('-').join('') : '';
                      const mauMetric = filterVal && filterVal.is_confirm ? 'cs_si_avg_mau' : 'cs_si_mau';
                      return Object.assign(
                        {},
                        {
                          studio_code: frameCode,
                          filters: {},
                          accumulation: {
                            custom_accumulation: [
                              { is_accumulation: true, key: 'game_code' },
                              { is_accumulation: true, key: 'category' },
                              { is_accumulation: false, key: 'studio' },
                            ],
                            not_by_date: true,
                          },
                          page: 1,
                          page_size: 9999,
                          start_date: startDateStr,
                          end_date: endDateStr,
                          sorted_by: 'cs_si_iaa_revenue_m',
                          desc: true,
                          multi_sort: [{ sort_by: 'cs_si_iaa_revenue_m', desc: true }],
                          metrics: [
                            'cs_si_iaa_revenue_m',
                            'cs_si_new',
                            'cs_si_spend_m',
                            'cs_si_avg_dau',
                            mauMetric,
                            'cs_si_ret_d2',
                            'cs_si_ret_d7',
                          ],
                          period: 'monthly',
                        },
                        data.extraParams,
                      );
                    },
                    "formatData": (data) => { return data }
                  },
                  "children": [
                    {
                      "name": "Service",
                      "props": {
                        "api": "/api/v2/dashboard/studio/casual_hub/overview/overall_performance",
                        "trackData": [
                          "frameCode"
                        ],
                        "dataKey": "selfIncubationSparklineData",
                        "filterLoading": false,
                        "beforeRequest": (data) => {
                          const { filterVal, frameCode } = data || {};
                          const shiftMonths = function (ymd, delta) {
                            const m = /^([0-9]{4})-([0-9]{2})-([0-9]{2})$/.exec(String(ymd).trim().slice(0, 10));
                            if (!m) return ymd;
                            const y = Number(m[1]);
                            const mo = Number(m[2]);
                            const d = Number(m[3]);
                            const dt = new Date(y, mo - 1 + delta, d);
                            return `${dt.getFullYear()  }-${  String(dt.getMonth() + 1).padStart(2, '0')  }-${  String(dt.getDate()).padStart(2, '0')}`;
                          };
                          let startTime = filterVal && filterVal.start_time;
                          if (filterVal && filterVal.is_confirm === false && startTime) {
                            startTime = shiftMonths(startTime, -5);
                          }
                          const et = filterVal && filterVal.end_time;
                          const startDate = startTime ? startTime.split('-').join('') : '';
                          const endDate = et ? et.split('-').join('') : '';
                          return Object.assign(
                            {},
                            {
                              logical_flag: 'trend_chart',
                              studio_code: frameCode,
                              filters: {},
                              accumulation: {
                                custom_accumulation: [
                                  { is_accumulation: true, key: 'game_code' },
                                  { is_accumulation: true, key: 'category' },
                                  { is_accumulation: false, key: 'studio' },
                                ],
                                not_by_date: false,
                              },
                              start_date: startDate,
                              end_date: endDate,
                              sorted_by: 'date',
                              desc: true,
                              multi_sort: [{ sort_by: 'cs_si_iaa_revenue_m', desc: true }],
                              metrics: ['cs_si_iaa_revenue_m'],
                              period: 'monthly',
                            },
                          );
                        },
                        "formatData": (data) => { return data }
                      },
                      "children": [
                        {
                          "name": "DataMergeWrap",
                          "props": {
                            "dataKey": "selfIncubationTableData",
                            "sparklineDataKey": "selfIncubationSparklineData"
                          },
                          "children": [
                            {
                              "name": "CommonTable",
                              "className": "margin-t-20 dbh-casual-table",
                              "props": {
                                "dataKey": "selfIncubationTableData",
                                "dataPath": "metrics_list",
                                "totalRecordPath": "row_count",
                                "metricsCardWrapProps": {
                                  "titleEn": "Self-Incubation Projects",
                                  "titleCn": "自孵化项目",
                                  "operation": [
                                    {
                                      "name": "DownloadButton",
                                      "className": "dbd-common-table__operation-btn",
                                      "config": {
                                        "apiDownload": {
                                          "fileNameEn": "Self-Incubation Projects",
                                          "fileNameCn": "自孵化项目",
                                          "sheetNameEn": "Self-Incubation Projects",
                                          "sheetNameCn": "自孵化项目",
                                          "api": "/api/v2/dashboard/studio/casual_hub/overview/overall_performance",
                                          "fixedPageSize": 50000,
                                          "beforeDownloadModal": {
                                            "fields": [
                                              {
                                                "labelEn": "Granularity",
                                                "labelCn": "数据粒度",
                                                "paramKey": "period_mode",
                                                "type": "radio",
                                                "clientOnly": true,
                                                "options": [
                                                  { "labelEn": "Detail", "labelCn": "明细数据", "value": "detail" },
                                                  { "labelEn": "Aggregation", "labelCn": "聚合数据", "value": "aggregation" }
                                                ]
                                              }
                                            ]
                                          },
                                          "formatData": (metricsList, context) => {
                                            const isDetail = context && context.period_mode !== 'aggregation';
                                            const filter = context && context.filter;
                                            const fv = filter;
                                            const st = fv && fv.start_time;
                                            const et = fv && fv.end_time;
                                            const startLabel = st ? String(st).trim().slice(0, 7) : '';
                                            const endLabel = et ? String(et).trim().slice(0, 7) : '';
                                            const rangeLabel = startLabel && endLabel ? `${startLabel}~${endLabel}` : (startLabel || endLabel);
                                            const casualInfo = context && context.casualInfo;
                                            const games = casualInfo && casualInfo.games;
                                            const gameMap = {};
                                            if (games && games.length) {
                                              games.forEach((g) => {
                                                if (g.game_name) gameMap[g.game_name] = g;
                                                if (g.entity_name) gameMap[g.entity_name] = g;
                                                if (g.entity_name_cn) gameMap[g.entity_name_cn] = g;
                                              });
                                            }
                                            const getRawDate = (it) => (it && it.date ? String(it.date) : '');
                                            const rows = metricsList.map((item, index) => {
                                              const rawDate = item.date ? String(item.date) : '';
                                              const formattedDate = isDetail
                                                ? (rawDate.length === 8 ? rawDate.slice(0, 4) + '-' + rawDate.slice(4, 6) : rawDate)
                                                : rangeLabel;
                                              const customDims = item.custom_dimensions;
                                              const gameDim = customDims && customDims.find((d) => { return d.key === 'game_code' });
                                              const categoryDim = customDims && customDims.find((d) => { return d.key === 'category' });
                                              const rawGameName = (gameDim && gameDim.value) ? gameDim.value : '';
                                              const gameInfo = gameMap[rawGameName];
                                              const isEN = !!(context && context.isEN);
                                              const gameName = gameInfo ? (isEN ? (gameInfo.entity_name || gameInfo.entity_name_cn || rawGameName) : (gameInfo.entity_name_cn || gameInfo.entity_name || rawGameName)) : rawGameName;
                                              const category = (categoryDim && categoryDim.value) ? categoryDim.value : '';
                                              const {metrics} = item;
                                              const flatMetrics = {};
                                              if (metrics) {
                                                Object.keys(metrics).forEach((key) => {
                                                  const m = metrics[key];
                                                  flatMetrics[key] = (m && m.value) ? m.value : '';
                                                  flatMetrics[`${key}_dod`] = (m && m.dod) ? m.dod : '';
                                                });
                                              }
                                              return Object.assign({}, item, flatMetrics, {
                                                rank: index + 1,
                                                date: formattedDate,
                                                game_name: gameName,
                                                category,
                                                _rawDate: getRawDate(item),
                                              });
                                            });
                                            // 前端排序：读取用户当前排序状态（由 downloadSortKey 写入）
                                            const userSortState = context && context.selfIncubationDownloadSortState;
                                            const sortBy = (userSortState && userSortState.length > 0) ? userSortState[0].by : null;
                                            const sortDesc = (userSortState && userSortState.length > 0) ? userSortState[0].order === 'desc' : true;
                                            if (sortBy) {
                                              return rows.sort((a, b) => {
                                                const va = (a[sortBy] !== '' && a[sortBy] !== undefined && a[sortBy] !== null) ? Number(a[sortBy]) : (sortDesc ? -Infinity : Infinity);
                                                const vb = (b[sortBy] !== '' && b[sortBy] !== undefined && b[sortBy] !== null) ? Number(b[sortBy]) : (sortDesc ? -Infinity : Infinity);
                                                return sortDesc ? vb - va : va - vb;
                                              });
                                            }
                                            if (!isDetail) {
                                              const defaultMetric = 'cs_si_iaa_revenue_m';
                                              return rows.sort((a, b) => {
                                                const va = (a[defaultMetric] !== '' && a[defaultMetric] !== undefined && a[defaultMetric] !== null) ? Number(a[defaultMetric]) : -Infinity;
                                                const vb = (b[defaultMetric] !== '' && b[defaultMetric] !== undefined && b[defaultMetric] !== null) ? Number(b[defaultMetric]) : -Infinity;
                                                return vb - va;
                                              });
                                            }
                                            // 明细模式：先按日期倒序，再按 IAA 收入降序（同月份即按收入降序）
                                            const detailMetric = 'cs_si_iaa_revenue_m';
                                            return rows.sort((a, b) => {
                                              const da = String(a._rawDate || '');
                                              const db = String(b._rawDate || '');
                                              if (da !== db) return db.localeCompare(da);
                                              const va = (a[detailMetric] !== '' && a[detailMetric] !== undefined && a[detailMetric] !== null) ? Number(a[detailMetric]) : -Infinity;
                                              const vb = (b[detailMetric] !== '' && b[detailMetric] !== undefined && b[detailMetric] !== null) ? Number(b[detailMetric]) : -Infinity;
                                              return vb - va;
                                            });
                                          },
                                          "beforeRequest": (data) => {
                                            const filter = data && data.filter;
                                            const frameCode = data && data.frameCode;
                                            const fv = filter;
                                            const st = fv && fv.start_time;
                                            const et = fv && fv.end_time;
                                            const startDateStr = st ? String(st).trim().slice(0, 10).split('-').join('') : '';
                                            const endDateStr = et ? String(et).trim().slice(0, 10).split('-').join('') : '';
                                            const isDetail = data.period_mode !== 'aggregation';
                                            const mauMetric = (!isDetail && fv && fv.is_confirm) ? 'cs_si_avg_mau' : 'cs_si_mau';
                                            return Object.assign(
                                              {},
                                              data.extraParams,
                                              {
                                                studio_code: frameCode,
                                                filters: {},
                                                accumulation: {
                                                  custom_accumulation: [
                                                    { is_accumulation: true, key: 'game_code' },
                                                    { is_accumulation: true, key: 'category' },
                                                    { is_accumulation: false, key: 'studio' },
                                                  ],
                                                  not_by_date: !isDetail,
                                                },
                                                page: 1,
                                                page_size: 9999,
                                                start_date: startDateStr,
                                                end_date: endDateStr,
                                                sorted_by: 'date',
                                                desc: true,
                                                multi_sort: [{ sort_by: 'date', desc: true }, { sort_by: 'cs_si_iaa_revenue_m', desc: true }],
                                                metrics: [
                                                  'cs_si_iaa_revenue_m',
                                                  'cs_si_new',
                                                  'cs_si_spend_m',
                                                  'cs_si_avg_dau',
                                                  mauMetric,
                                                  'cs_si_ret_d2',
                                                  'cs_si_ret_d7',
                                                ],
                                                period: 'monthly',
                                              },
                                            );
                                          },
                                          "columns": [
                                            { "code": "date", "name": "Date", "nameEn": "Date", "nameCn": "日期", "format": "@", "width": 140 },
                                            { "code": "game_name", "name": "Game", "nameEn": "Game", "nameCn": "游戏", "format": "@", "width": 200 },
                                            { "code": "category", "name": "Category", "nameEn": "Category", "nameCn": "类型", "format": "@", "width": 140 },
                                            { "code": "cs_si_iaa_revenue_m", "name": "IAA Revenue($)", "nameEn": "IAA Revenue($)", "nameCn": "IAA 收入($)", "format": "#,##0.00", "width": 180 },
                                            { "code": "cs_si_iaa_revenue_m_dod", "name": "IAA Revenue($)_mom", "nameEn": "IAA Revenue($)_mom", "nameCn": "IAA收入($)_月环比", "format": "0.0%", "width": 160 },
                                            { "code": "cs_si_new", "name": "New", "nameEn": "New", "nameCn": "新进", "format": "#,##0", "width": 140 },
                                            { "code": "cs_si_new_dod", "name": "New_mom", "nameEn": "New_mom", "nameCn": "新进_月环比", "format": "0.0%", "width": 120 },
                                            { "code": "cs_si_avg_dau", "name": "Avg.DAU", "nameEn": "Avg.DAU", "nameCn": "日均活跃", "format": "#,##0", "width": 160 },
                                            { "code": "cs_si_avg_dau_dod", "name": "Avg.DAU_mom", "nameEn": "Avg.DAU_mom", "nameCn": "日均活跃_月环比", "format": "0.0%", "width": 140 },
                                            { "code": "cs_si_mau", "name": "MAU", "nameEn": "MAU", "nameCn": "月活跃", "format": "#,##0", "width": 160 },
                                            { "code": "cs_si_mau_dod", "name": "MAU_mom", "nameEn": "MAU_mom", "nameCn": "月活跃_月环比", "format": "0.0%", "width": 140 },
                                            { "code": "cs_si_avg_mau", "overrideCode": "cs_si_mau", "overrideWhen"(data) { return !!(data && data.filter && data.filter.is_confirm && data.period_mode === 'aggregation') }, "name": "Avg.MAU", "nameEn": "Avg.MAU", "nameCn": "月均活跃", "format": "#,##0", "width": 160 },
                                            { "code": "cs_si_avg_mau_dod", "overrideCode": "cs_si_mau_dod", "overrideWhen"(data) { return !!(data && data.filter && data.filter.is_confirm && data.period_mode === 'aggregation') }, "name": "Avg.MAU_mom", "nameEn": "Avg.MAU_mom", "nameCn": "月均活跃_月环比", "format": "0.0%", "width": 140 },
                                            { "code": "cs_si_ret_d2", "name": "Ret D2", "nameEn": "Ret D2", "nameCn": "次留", "format": "0.00%", "width": 140 },
                                            { "code": "cs_si_ret_d2_dod", "name": "Ret D2_mom", "nameEn": "Ret D2_mom", "nameCn": "次留_月环比", "format": "0.0%", "width": 120 },
                                            { "code": "cs_si_ret_d7", "name": "Ret D7", "nameEn": "Ret D7", "nameCn": "7留", "format": "0.00%", "width": 140 },
                                            { "code": "cs_si_ret_d7_dod", "name": "Ret D7_mom", "nameEn": "Ret D7_mom", "nameCn": "7留_月环比", "format": "0.0%", "width": 120 },
                                            { "code": "cs_si_spend_m", "name": "Spend($)", "nameEn": "Spend($)", "nameCn": "UA 花费($)", "format": "#,##0.00", "width": 160 },
                                            { "code": "cs_si_spend_m_dod", "name": "Spend($)_mom", "nameEn": "Spend($)_mom", "nameCn": "UA花费($)_月环比", "format": "0.0%", "width": 140 },
                                            { "code": "cs_si_iaa_revenue_m_dod", "overrideCode": "cs_si_iaa_revenue_m_dod", "overrideWhen"(d) { const f = d && d.filter; const s = f && f.start_time ? String(f.start_time).slice(0, 7) : ''; const e = f && f.end_time ? String(f.end_time).slice(0, 7) : ''; return !!(s && e && s !== e); }, "name": "IAA Revenue($)_Change", "nameEn": "IAA Revenue($)_Change", "nameCn": "IAA收入($)_变化率" },
                                            { "code": "cs_si_new_dod", "overrideCode": "cs_si_new_dod", "overrideWhen"(d) { const f = d && d.filter; const s = f && f.start_time ? String(f.start_time).slice(0, 7) : ''; const e = f && f.end_time ? String(f.end_time).slice(0, 7) : ''; return !!(s && e && s !== e); }, "name": "New_Change", "nameEn": "New_Change", "nameCn": "新进_变化率" },
                                            { "code": "cs_si_avg_dau_dod", "overrideCode": "cs_si_avg_dau_dod", "overrideWhen"(d) { const f = d && d.filter; const s = f && f.start_time ? String(f.start_time).slice(0, 7) : ''; const e = f && f.end_time ? String(f.end_time).slice(0, 7) : ''; return !!(s && e && s !== e); }, "name": "Avg.DAU_Change", "nameEn": "Avg.DAU_Change", "nameCn": "日均活跃_变化率" },
                                            { "code": "cs_si_mau_dod", "overrideCode": "cs_si_mau_dod", "overrideWhen"(d) { const f = d && d.filter; const s = f && f.start_time ? String(f.start_time).slice(0, 7) : ''; const e = f && f.end_time ? String(f.end_time).slice(0, 7) : ''; return !!(s && e && s !== e); }, "name": "MAU_Change", "nameEn": "MAU_Change", "nameCn": "月活跃_变化率" },
                                            { "code": "cs_si_ret_d2_dod", "overrideCode": "cs_si_ret_d2_dod", "overrideWhen"(d) { const f = d && d.filter; const s = f && f.start_time ? String(f.start_time).slice(0, 7) : ''; const e = f && f.end_time ? String(f.end_time).slice(0, 7) : ''; return !!(s && e && s !== e); }, "name": "Ret D2_Change", "nameEn": "Ret D2_Change", "nameCn": "次留_变化率" },
                                            { "code": "cs_si_ret_d7_dod", "overrideCode": "cs_si_ret_d7_dod", "overrideWhen"(d) { const f = d && d.filter; const s = f && f.start_time ? String(f.start_time).slice(0, 7) : ''; const e = f && f.end_time ? String(f.end_time).slice(0, 7) : ''; return !!(s && e && s !== e); }, "name": "Ret D7_Change", "nameEn": "Ret D7_Change", "nameCn": "7留_变化率" },
                                            { "code": "cs_si_spend_m_dod", "overrideCode": "cs_si_spend_m_dod", "overrideWhen"(d) { const f = d && d.filter; const s = f && f.start_time ? String(f.start_time).slice(0, 7) : ''; const e = f && f.end_time ? String(f.end_time).slice(0, 7) : ''; return !!(s && e && s !== e); }, "name": "Spend($)_Change", "nameEn": "Spend($)_Change", "nameCn": "UA花费($)_变化率" },
                                          ]
                                        }
                                      }
                                    }
                                  ]
                                },
                                "commonBaseTableProps": {
                                  "tableConfig": {
                                    "useVirtual": {
                                      "horizontal": false,
                                      "vertical": false,
                                      "header": false
                                    },
                                    "hidePaginationWhenSinglePage": true,
                                    "pagination": {},
                                    "downloadSortKey": "selfIncubationDownloadSortState"
                                  },
                                  "columns": [
                                    {
                                      "nameEn": "Game",
                                      "nameCn": "游戏",
                                      "code": "game_name",
                                      "align": "left",
                                      "width": 250,
                                      "features": {
                                        "sortable": false,
                                        "cell": {
                                          "type": "gameIcon",
                                          "showRawOnHover": true,
                                          "rankKey": "rank",
                                          "iconKey": "game_icon",
                                          "nameKey": "game_name",
                                          "countryCodeKey": "country_code",
                                          "countryNameKey": "country_name"
                                        }
                                      }
                                    },
                                    {
                                      "nameEn": "Category",
                                      "nameCn": "类型",
                                      "code": "category",
                                      "align": "left",
                                      "width": 140,
                                      "features": {
                                        "sortable": false,
                                        "cell": {
                                          "type": "category",
                                          "valueMapping": {
                                            "Self-Incubation": {
                                              "color": "#28B463",
                                              "backgroundColor": "#EAFAF1",
                                              "label": "Self-Incubation"
                                            },
                                            "Self-incubation": {
                                              "color": "#28B463",
                                              "backgroundColor": "#EAFAF1",
                                              "label": "Self-incubation"
                                            }
                                          }
                                        }
                                      }
                                    },
                                    {
                                      "nameEn": "IAA Revenue($)",
                                      "nameCn": "IAA 收入($)",
                                      "code": "cs_si_iaa_revenue_m",
                                      "align": "right",
                                      "width": 240,
                                      "features": {
                                        "sortable": true,
                                        "explainEn": "Total Ad Revenue Generated from Players' Ad Views",
                                        "explainCn": "玩家观看广告后产生的全部广告收入",
                                        "cell": {
                                          "type": "sparkline",
                                          "showChangeRate": true,
                                          "showRawOnHover": true,
                                          "hoverFormatRule": "thousands2Decimal",
                                          "changeKey": "cs_si_iaa_revenue_m_dod",
                                          "dodDecimals": 2,
                                          "dodDownloadFormat": "0.0%",
                                          "hoverBubble": true,
                                          "sparklineKey": "sparkline_cs_si_iaa_revenue_m",
                                          "sparklineDatesKey": "sparkline_dates",
                                          "tooltipDateFormat": "YYYY-MM"
                                        },
                                        "format": "bmk00"
                                      }
                                    },
                                    {
                                      "nameEn": "New",
                                      "nameCn": "新进",
                                      "code": "cs_si_new",
                                      "align": "right",
                                      "width": 170,
                                      "features": {
                                        "sortable": true,
                                        "cell": {
                                          "type": "percentage",
                                          "showProgressBar": false,
                                          "showChangeRate": true,
                                          "showRawOnHover": true,
                                          "hoverFormatRule": "thousandsInit",
                                          "changeKey": "cs_si_new_dod",
                                          "formatDodAsPercent": true,
                                          "dodDecimals": 1,
                                          "dodDownloadFormat": "0.0%",
                                          "hoverBubble": true,
                                        },
                                        "explainEn": "Newly installed device count during the statistical period(device id deduplicated).Data more than 1 day show sum new",
                                        "explainCn": "统计周期内新安装设备数(xwid），超过一天展示累计新进",
                                        "format": "intBmk00"
                                      }
                                    },
                                    {
                                      "nameEn": "Avg.DAU",
                                      "nameCn": "日均活跃",
                                      "code": "cs_si_avg_dau",
                                      "align": "right",
                                      "width": 170,
                                      "features": {
                                        "sortable": true,
                                        "cell": {
                                          "type": "percentage",
                                          "showProgressBar": false,
                                          "showChangeRate": true,
                                          "showRawOnHover": true,
                                          "hoverFormatRule": "thousandsInit",
                                          "changeKey": "cs_si_avg_dau_dod",
                                          "formatDodAsPercent": true,
                                          "dodDecimals": 1,
                                          "dodDownloadFormat": "0.0%",
                                          "hoverBubble": true,
                                        },
                                        "explainEn": " Based on the selected end month, this metric shows the average daily active users for that month.",
                                        "explainCn": "  统计周期为截止月份，表示对应月份平均每日活跃用户数。",
                                        "format": "intBmk00"
                                      }
                                    },
                                    {
                                      "nameEn": "MAU",
                                      "nameCn": "月活跃",
                                      "code": "cs_si_mau",
                                      "align": "right",
                                      "width": 170,
                                      "features": {
                                        "sortable": true,
                                        "cell": {
                                          "type": "percentage",
                                          "showProgressBar": false,
                                          "showChangeRate": true,
                                          "showRawOnHover": true,
                                          "hoverFormatRule": "thousandsInit",
                                          "changeKey": "cs_si_mau_dod",
                                          "formatDodAsPercent": true,
                                          "dodDecimals": 1,
                                          "dodDownloadFormat": "0.0%",
                                          "hoverBubble": true,
                                        },
                                        "explainEn": "Unique device count with game logins during the statistical period(device id deduplicated)",
                                        "explainCn": "统计周期内登录过游戏的去重设备数(xwid)。",
                                        "format": "intBmk00"
                                      }
                                    },
                                    {
                                      "nameEn": "Avg.MAU",
                                      "nameCn": "月均活跃",
                                      "code": "cs_si_avg_mau",
                                      "overrideCode": "cs_si_mau",
                                      "overrideWhen"(data) { return !!(data && data.filter && data.filter.is_confirm) },
                                      "align": "right",
                                      "width": 170,
                                      "features": {
                                        "sortable": true,
                                        "cell": {
                                          "type": "percentage",
                                          "showProgressBar": false,
                                          "showChangeRate": true,
                                          "showRawOnHover": true,
                                          "hoverFormatRule": "thousandsInit",
                                          "changeKey": "cs_si_avg_mau_dod",
                                          "formatDodAsPercent": true,
                                          "dodDecimals": 1,
                                          "dodDownloadFormat": "0.0%",
                                          "hoverBubble": true,
                                        },
                                        "explainEn": "Unique device count with game logins during the statistical period(device id deduplicated)",
                                        "explainCn": "统计周期内登录过游戏的去重设备数(xwid)。",
                                        "format": "intBmk00"
                                      }
                                    },
                                    {
                                      "nameEn": "Ret D2",
                                      "nameCn": "次留",
                                      "code": "cs_si_ret_d2",
                                      "align": "right",
                                      "width": 170,
                                      "features": {
                                        "sortable": true,
                                        "explainEn": "Number of retained users on day N from XX (registration date)/Number of new users on XX (registration date)，Registration date is D1",
                                        "explainCn": "次留=xx日期第2天留存用户数/xx日期新进用户数，注册日期是D1。",
                                        "format": "absPercent2Decimal",
                                        "downLoadFormat": "0.00%",
                                        "cell": {
                                          "type": "percentage",
                                          "showProgressBar": true,
                                          "showChangeRate": true,
                                          "showRawOnHover": true,
                                          "hoverFormatRule": "percent2Decimal",
                                          "changeKey": "cs_si_ret_d2_dod",
                                          "formatDodAsPercent": true,
                                          "dodDecimals": 1,
                                          "dodDownloadFormat": "0.0%",
                                          "hoverBubble": true,
                                        }
                                      }
                                    },
                                    {
                                      "nameEn": "Ret D7",
                                      "nameCn": "7留",
                                      "code": "cs_si_ret_d7",
                                      "align": "right",
                                      "width": 170,
                                      "features": {
                                        "sortable": true,
                                        "explainEn": "Number of retained users on day 7 from XX (registration date)/Number of new users on XX (registration date)，Registration date is D1",
                                        "explainCn": "7留=xx日期第7天留存用户数/xx日期新进用户数，注册日期是D1。",
                                        "format": "absPercent2Decimal",
                                        "downLoadFormat": "0.00%",
                                        "cell": {
                                          "type": "percentage",
                                          "showProgressBar": true,
                                          "showChangeRate": true,
                                          "showRawOnHover": true,
                                          "hoverFormatRule": "percent2Decimal",
                                          "changeKey": "cs_si_ret_d7_dod",
                                          "formatDodAsPercent": true,
                                          "dodDecimals": 1,
                                          "dodDownloadFormat": "0.0%",
                                          "hoverBubble": true,
                                        }
                                      }
                                    },
                                    {
                                      "nameEn": "Spend($)",
                                      "nameCn": "UA 花费($)",
                                      "code": "cs_si_spend_m",
                                      "align": "right",
                                      "features": {
                                        "sortable": true,
                                        "cell": {
                                          "type": "percentage",
                                          "showProgressBar": false,
                                          "showChangeRate": true,
                                          "showRawOnHover": true,
                                          "hoverFormatRule": "thousands2Decimal",
                                          "changeKey": "cs_si_spend_m_dod",
                                          "formatDodAsPercent": true,
                                          "dodDecimals": 1,
                                          "dodDownloadFormat": "0.0%",
                                          "hoverBubble": true,
                                        },
                                        "explainEn": "UA Spend",
                                        "explainCn": "UA花费",
                                        "format": "bmk00"
                                      }
                                    }
                                  ]
                                }
                              }
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  "name": "Service",
                  "data": {
                    "searchKeyword": "",
                    "clientSearchKeyword": "",
                    "extraParams": {
                      "multi_sort": [
                        {
                          "sort_by": "cs_studio_total_revenue_m",
                          "desc": true
                        }
                      ],
                      "page": 1,
                      "page_size": 9999
                    }
                  },
                  "props": {
                    "api": "/api/v2/dashboard/studio/casual_hub/overview/overall_performance",
                    "trackData": [
                      "extraParams",
                      "frameCode"
                    ],
                    "dataKey": "studioOverviewTableData",
                    "filterLoading": false,
                    "beforeRequest": (data) => {
                      const { filterVal, frameCode } = data || {};
                      const frontendSearch = true; // 前后端搜索开关：true=前端, false=后端
                      const searchKeyword = !frontendSearch && data && data.searchKeyword ? String(data.searchKeyword).trim() : '';
                      const customFilters = searchKeyword ? [
                        {
                          key: 'game_code',
                          operate: 'like',
                          filter_list: [searchKeyword],
                        },
                      ] : [];
                      const st = filterVal && filterVal.start_time;
                      const et = filterVal && filterVal.end_time;
                      const startDateStr = st ? String(st).trim().slice(0, 10).split('-').join('') : '';
                      const endDateStr = et ? String(et).trim().slice(0, 10).split('-').join('') : '';
                      return Object.assign(
                        {},
                        {
                          studio_code: frameCode,
                          filters: customFilters.length > 0 ? { custom_filters: customFilters } : {},
                          accumulation: {
                            custom_accumulation: [
                              { is_accumulation: true, key: 'game_code' },
                              { is_accumulation: false, key: 'category' },
                              { is_accumulation: true, key: 'studio' },
                            ],
                            not_by_date: true,
                          },
                          page: 1,
                          page_size: frontendSearch ? 9999 : 10,
                          start_date: startDateStr,
                          end_date: endDateStr,
                          sorted_by: 'cs_studio_total_revenue_m',
                          desc: true,
                          multi_sort: [{ sort_by: 'cs_studio_total_revenue_m', desc: true }],
                          metrics: [
                            'cs_studio_total_revenue_m',
                            'cs_studio_iaa_revenue_m',
                            'cs_studio_iap_revenue_m',
                            'cs_studio_spend',
                          ],
                          period: 'monthly',
                        },
                        data.extraParams,
                      );
                    },
                    "formatData": (data) => { return data }
                  },
                  "children": [
                    {
                      "name": "Service",
                      "props": {
                        "api": "/api/v2/dashboard/studio/casual_hub/overview/overall_performance",
                        "trackData": [
                          "frameCode"
                        ],
                        "dataKey": "studioOverviewSparklineData",
                        "filterLoading": false,
                        "beforeRequest": (data) => {
                          const { filterVal, frameCode } = data || {};
                          const shiftMonths = function (ymd, delta) {
                            const m = /^([0-9]{4})-([0-9]{2})-([0-9]{2})$/.exec(String(ymd).trim().slice(0, 10));
                            if (!m) return ymd;
                            const y = Number(m[1]);
                            const mo = Number(m[2]);
                            const d = Number(m[3]);
                            const dt = new Date(y, mo - 1 + delta, d);
                            return `${dt.getFullYear()  }-${  String(dt.getMonth() + 1).padStart(2, '0')  }-${  String(dt.getDate()).padStart(2, '0')}`;
                          };
                          let startTime = filterVal && filterVal.start_time;
                          if (filterVal && filterVal.is_confirm === false && startTime) {
                            startTime = shiftMonths(startTime, -5);
                          }
                          const et = filterVal && filterVal.end_time;
                          const startDate = startTime ? startTime.split('-').join('') : '';
                          const endDate = et ? et.split('-').join('') : '';
                          return Object.assign(
                            {},
                            {
                              logical_flag: 'trend_chart',
                              studio_code: frameCode,
                              filters: {},
                              accumulation: {
                                custom_accumulation: [
                                  { is_accumulation: true, key: 'game_code' },
                                  { is_accumulation: false, key: 'category' },
                                  { is_accumulation: true, key: 'studio' },
                                ],
                                not_by_date: false,
                              },
                              start_date: startDate,
                              end_date: endDate,
                              sorted_by: 'date',
                              desc: true,
                              multi_sort: [{ sort_by: 'cs_studio_total_revenue_m', desc: true }],
                              metrics: [
                                'cs_studio_total_revenue_m',
                                'cs_studio_iaa_revenue_m',
                                'cs_studio_iap_revenue_m',
                              ],
                              period: 'monthly',
                            },
                          );
                        },
                        "formatData": (data) => { return data }
                      },
                      "children": [
                        {
                          "name": "DataMergeWrap",
                          "props": {
                            "dataKey": "studioOverviewTableData",
                            "sparklineDataKey": "studioOverviewSparklineData",
                            "dateSubtitleConfig": {
                              "templateEn": "{{start}}~{{end}}",
                              "templateCn": "{{start}}~{{end}}",
                              "dateSeparator": "-",
                              "subtitleEndTimeDataKey": "studioMonthActualEndTime"
                            },
                            "studioIconMap": {
                              "Miniclip": "https://ogdb-cdn.intlgame.cn/aupload/admin/studio_hub/image/1741760898187_选中态.png",
                              "Miniclip Game Studios": "https://ogdb-cdn.intlgame.cn/aupload/admin/studio_hub/image/1741760898187_选中态.png"
                            }
                          },
                          "children": [
                            {
                              "name": "TableWithDateSubtitle",
                              "className": "margin-t-20",
                              "props": {
                                "dataKey": "studioOverviewTableData",
                                "dataPath": "metrics_list",
                                "clientFilter": {
                                  "searchKey": "clientSearchKeyword",
                                  "searchFields": [
                                    "game_name"
                                  ]
                                },
                                "metricsCardWrapProps": {
                                  "titleEn": "Studio Projects",
                                  "titleCn": "Studio项目",
                                  "operation": [
                                    {
                                      "name": "SearchBox",
                                      "className": "dbd-common-table__operation-btn",
                                      "props": {
                                        "showWhen": "function() {\n                                                                                    return true;\n                                                                                }",
                                        "placeholderEn": "Search games",
                                        "placeholderCn": "搜索游戏",
                                        "patchData": {
                                          "keys": "data.clientSearchKeyword"
                                        }
                                      }
                                    },
                                    {
                                      "name": "DownloadButton",
                                      "className": "dbd-common-table__operation-btn",
                                      "config": {
                                        "apiDownload": {
                                          "fileNameEn": "Studio Projects",
                                          "fileNameCn": "Studio项目",
                                          "sheetNameEn": "Studio Projects",
                                          "sheetNameCn": "Studio项目",
                                          "api": "/api/v2/dashboard/studio/casual_hub/overview/overall_performance",
                                          "fixedPageSize": 50000,
                                          "beforeDownloadModal": {
                                            "fields": [
                                              {
                                                "labelEn": "Granularity",
                                                "labelCn": "数据粒度",
                                                "paramKey": "period_mode",
                                                "type": "radio",
                                                "clientOnly": true,
                                                "options": [
                                                  { "labelEn": "Detail", "labelCn": "明细数据", "value": "detail" },
                                                  { "labelEn": "Aggregation", "labelCn": "聚合数据", "value": "aggregation" }
                                                ]
                                              }
                                            ]
                                          },
                                          "formatData": (metricsList, context) => {
                                            const isDetail = context && context.period_mode !== 'aggregation';
                                            const filter = context && context.filter;
                                            const fv = filter;
                                            const st = fv && fv.start_time;
                                            const et = fv && fv.end_time;
                                            const startLabel = st ? String(st).trim().slice(0, 7) : '';
                                            const endLabel = et ? String(et).trim().slice(0, 7) : '';
                                            const rangeLabel = startLabel && endLabel ? `${startLabel}~${endLabel}` : (startLabel || endLabel);
                                            const casualInfo = context && context.casualInfo;
                                            const games = casualInfo && casualInfo.games;
                                            const gameMap = {};
                                            if (games && games.length) {
                                              games.forEach(function (g) {
                                                if (g.game_name) gameMap[g.game_name] = g;
                                                if (g.entity_name) gameMap[g.entity_name] = g;
                                                if (g.entity_name_cn) gameMap[g.entity_name_cn] = g;
                                              });
                                            }
                                            const getRawDate = function (it) { return (it && it.date ? String(it.date) : ''); };
                                            const getMetricVal = function (it, key) {
                                              const m = it && it.metrics && it.metrics[key];
                                              return (m && m.value !== '' && m.value !== undefined && m.value !== null) ? Number(m.value) : -Infinity;
                                            };
                                            // 明细模式：先按日期倒序，再按总收入降序（同月份即按总收入降序）；
                                            // 聚合模式：与宽表展示一致，按总收入降序
                                            const sortedList = isDetail
                                              ? metricsList.slice().sort(function (a, b) {
                                                const da = getRawDate(a);
                                                const db = getRawDate(b);
                                                if (da !== db) return db.localeCompare(da);
                                                return getMetricVal(b, 'cs_studio_total_revenue_m') - getMetricVal(a, 'cs_studio_total_revenue_m');
                                              })
                                              : metricsList.slice().sort(function (a, b) {
                                                return getMetricVal(b, 'cs_studio_total_revenue_m') - getMetricVal(a, 'cs_studio_total_revenue_m');
                                              });
                                            const rows = sortedList.map(function (item, index) {
                                              const rawDate = item.date ? String(item.date) : '';
                                              const formattedDate = isDetail
                                                ? (rawDate.length === 8 ? rawDate.slice(0, 4) + '-' + rawDate.slice(4, 6) : rawDate)
                                                : rangeLabel;
                                              const customDims = item.custom_dimensions;
                                              const getDimValue = function (key) {
                                                if (!customDims || !customDims.length) return '';
                                                const dim = customDims.find(function (d) { return d.key === key; });
                                                return (dim && dim.value) ? dim.value : '';
                                              };
                                              const rawGameCode = getDimValue('game_code');
                                              const gameInfo = gameMap[rawGameCode];
                                              const isEN = !!(context && context.isEN);
                                              const gameName = gameInfo ? (isEN ? (gameInfo.entity_name || gameInfo.entity_name_cn || rawGameCode) : (gameInfo.entity_name_cn || gameInfo.entity_name || rawGameCode)) : rawGameCode;
                                              const studioName = getDimValue('studio');
                                              const metrics = item.metrics;
                                              const flatMetrics = {};
                                              if (metrics) {
                                                Object.keys(metrics).forEach(function (key) {
                                                  const m = metrics[key];
                                                  flatMetrics[key] = (m && m.value) ? m.value : '';
                                                  flatMetrics[key + '_dod'] = (m && m.dod) ? m.dod : '';
                                                });
                                              }
                                              return Object.assign({}, item, flatMetrics, {
                                                rank: index + 1,
                                                date: formattedDate,
                                                game_name: gameName,
                                                studio_name: studioName,
                                              });
                                            });
                                            // 前端排序：读取用户当前排序状态（由 downloadSortKey 写入）
                                            const userSortState = context && context.studioDownloadSortState;
                                            const sortBy = (userSortState && userSortState.length > 0) ? userSortState[0].by : null;
                                            const sortDesc = (userSortState && userSortState.length > 0) ? userSortState[0].order === 'desc' : true;
                                            if (sortBy) {
                                              return rows.sort((a, b) => {
                                                const va = (a[sortBy] !== '' && a[sortBy] !== undefined && a[sortBy] !== null) ? Number(a[sortBy]) : (sortDesc ? -Infinity : Infinity);
                                                const vb = (b[sortBy] !== '' && b[sortBy] !== undefined && b[sortBy] !== null) ? Number(b[sortBy]) : (sortDesc ? -Infinity : Infinity);
                                                return sortDesc ? vb - va : va - vb;
                                              });
                                            }
                                            return rows;
                                          },
                                          "beforeRequest": (data) => {
                                            const filter = data && data.filter;
                                            const frameCode = data && data.frameCode;
                                            const fv = filter;
                                            const st = fv && fv.start_time;
                                            const et = fv && fv.end_time;
                                            const startDateStr = st ? String(st).trim().slice(0, 10).split('-').join('') : '';
                                            const endDateStr = et ? String(et).trim().slice(0, 10).split('-').join('') : '';
                                            const searchKeyword = data && data.clientSearchKeyword ? String(data.clientSearchKeyword).trim() : '';
                                            const customFilters = searchKeyword ? [
                                              { key: 'game_code', operate: 'like', filter_list: [searchKeyword] },
                                            ] : [];
                                            const isDetail = data.period_mode !== 'aggregation';
                                            return Object.assign(
                                              {},
                                              data.extraParams,
                                              {
                                                studio_code: frameCode,
                                                filters: customFilters.length > 0 ? { custom_filters: customFilters } : {},
                                                accumulation: {
                                                  custom_accumulation: [
                                                    { is_accumulation: true, key: 'game_code' },
                                                    { is_accumulation: false, key: 'category' },
                                                    { is_accumulation: true, key: 'studio' },
                                                  ],
                                                  not_by_date: !isDetail,
                                                },
                                                page: 1,
                                                page_size: 9999,
                                                start_date: startDateStr,
                                                end_date: endDateStr,
                                                sorted_by: 'date',
                                                desc: true,
                                                multi_sort: [{ sort_by: 'date', desc: true }, { sort_by: 'cs_studio_total_revenue_m', desc: true }],
                                                metrics: [
                                                  'cs_studio_total_revenue_m',
                                                  'cs_studio_iaa_revenue_m',
                                                  'cs_studio_iap_revenue_m',
                                                  'cs_studio_spend',
                                                ],
                                                period: 'monthly',
                                              },
                                            );
                                          },
                                          "columns": [
                                            { "code": "date", "name": "Date", "nameEn": "Date", "nameCn": "日期", "format": "@", "width": 140 },
                                            { "code": "game_name", "name": "Game", "nameEn": "Game", "nameCn": "游戏", "format": "@", "width": 200 },
                                            { "code": "studio_name", "name": "Studio", "nameEn": "Studio", "nameCn": "Studio", "format": "@", "width": 160 },
                                            { "code": "cs_studio_total_revenue_m", "name": "Revenue($)", "nameEn": "Revenue($)", "nameCn": "总收入($)", "format": "#,##0.00", "width": 180 },
                                            { "code": "cs_studio_total_revenue_m_dod", "name": "Revenue($)_mom", "nameEn": "Revenue($)_mom", "nameCn": "总收入($)_月环比", "format": "0.0%", "width": 160 },
                                            { "code": "cs_studio_iaa_revenue_m", "name": "IAA Revenue($)", "nameEn": "IAA Revenue($)", "nameCn": "IAA 收入($)", "format": "#,##0.00", "width": 180 },
                                            { "code": "cs_studio_iaa_revenue_m_dod", "name": "IAA Revenue($)_mom", "nameEn": "IAA Revenue($)_mom", "nameCn": "IAA收入($)_月环比", "format": "0.0%", "width": 160 },
                                            { "code": "cs_studio_iap_revenue_m", "name": "IAP Revenue($)", "nameEn": "IAP Revenue($)", "nameCn": "IAP 收入($)", "format": "#,##0.00", "width": 180 },
                                            { "code": "cs_studio_iap_revenue_m_dod", "name": "IAP Revenue($)_mom", "nameEn": "IAP Revenue($)_mom", "nameCn": "IAP收入($)_月环比", "format": "0.0%", "width": 160 },
                                            { "code": "cs_studio_spend", "name": "Spend($)", "nameEn": "Spend($)", "nameCn": "UA 花费($)", "format": "#,##0.00", "width": 160 },
                                            { "code": "cs_studio_spend_dod", "name": "Spend($)_mom", "nameEn": "Spend($)_mom", "nameCn": "UA花费($)_月环比", "format": "0.0%", "width": 140 },
                                            { "code": "cs_studio_total_revenue_m_dod", "overrideCode": "cs_studio_total_revenue_m_dod", "overrideWhen"(d) { const f = d && d.filter; const s = f && f.start_time ? String(f.start_time).slice(0, 7) : ''; const e = f && f.end_time ? String(f.end_time).slice(0, 7) : ''; return !!(s && e && s !== e); }, "name": "Revenue($)_Change", "nameEn": "Revenue($)_Change", "nameCn": "总收入($)_变化率" },
                                            { "code": "cs_studio_iaa_revenue_m_dod", "overrideCode": "cs_studio_iaa_revenue_m_dod", "overrideWhen"(d) { const f = d && d.filter; const s = f && f.start_time ? String(f.start_time).slice(0, 7) : ''; const e = f && f.end_time ? String(f.end_time).slice(0, 7) : ''; return !!(s && e && s !== e); }, "name": "IAA Revenue($)_Change", "nameEn": "IAA Revenue($)_Change", "nameCn": "IAA收入($)_变化率" },
                                            { "code": "cs_studio_iap_revenue_m_dod", "overrideCode": "cs_studio_iap_revenue_m_dod", "overrideWhen"(d) { const f = d && d.filter; const s = f && f.start_time ? String(f.start_time).slice(0, 7) : ''; const e = f && f.end_time ? String(f.end_time).slice(0, 7) : ''; return !!(s && e && s !== e); }, "name": "IAP Revenue($)_Change", "nameEn": "IAP Revenue($)_Change", "nameCn": "IAP收入($)_变化率" },
                                            { "code": "cs_studio_spend_dod", "overrideCode": "cs_studio_spend_dod", "overrideWhen"(d) { const f = d && d.filter; const s = f && f.start_time ? String(f.start_time).slice(0, 7) : ''; const e = f && f.end_time ? String(f.end_time).slice(0, 7) : ''; return !!(s && e && s !== e); }, "name": "Spend($)_Change", "nameEn": "Spend($)_Change", "nameCn": "UA花费($)_变化率" },
                                          ]
                                        }
                                      }
                                    }
                                  ]
                                },
                                "commonBaseTableProps": {
                                  "height": 806.83,
                                  "tableConfig": {
                                    "tableHeight": 756.85,
                                    "isOpenForegroundPage": true,
                                    "hoverBubbleDateFormat": "YYYY-MM",
                                    "pagination": {},
                                    "downloadSortKey": "studioDownloadSortState"
                                  },
                                  "columns": [
                                    {
                                      "nameEn": "Games",
                                      "nameCn": "游戏",
                                      "code": "game_name",
                                      "align": "left",
                                      "width": 250,
                                      "features": {
                                        "sortable": false,
                                        "cell": {
                                          "type": "gameIcon",
                                          "showRawOnHover": true,
                                          "rankKey": "rank",
                                          "iconKey": "game_icon",
                                          "nameKey": "game_name",
                                          "countryCodeKey": "country_code",
                                          "countryNameKey": "country_name"
                                        }
                                      }
                                    },
                                    {
                                      "nameEn": "Studio",
                                      "nameCn": "Studio",
                                      "code": "studio_name",
                                      "align": "left",
                                      "width": 140,
                                      "features": {
                                        "sortable": false,
                                        "cell": {
                                          "type": "studioIcon",
                                          "iconKey": "studio_icon",
                                          "nameKey": "studio_name"
                                        }
                                      }
                                    },
                                    {
                                      "nameEn": "Revenue($)",
                                      "nameCn": "总收入($)",
                                      "code": "cs_studio_total_revenue_m",
                                      "align": "right",
                                      "width": 240,
                                      "features": {
                                        "sortable": true,
                                        "cell": {
                                          "type": "sparkline",
                                          "showChangeRate": true,
                                          "showRawOnHover": true,
                                          "hoverFormatRule": "thousands2Decimal",
                                          "changeKey": "cs_studio_total_revenue_m_dod",
                                          "dodDecimals": 2,
                                          "dodDownloadFormat": "0.0%",
                                          "hoverBubble": true,
                                          "sparklineKey": "sparkline_cs_studio_total_revenue_m",
                                          "sparklineDatesKey": "sparkline_dates",
                                          "tooltipDateFormat": "YYYY-MM"
                                        },
                                        "explainEn": "Total Revenue = IAP Revenue + Ad Revenue",
                                        "explainCn": "总收入=游戏内购收入+广告收入",
                                        "format": "bmk00"
                                      }
                                    },
                                    {
                                      "nameEn": "IAA Revenue($)",
                                      "nameCn": "IAA 收入($)",
                                      "code": "cs_studio_iaa_revenue_m",
                                      "align": "right",
                                      "width": 240,
                                      "features": {
                                        "sortable": true,
                                        "cell": {
                                          "type": "sparkline",
                                          "showChangeRate": true,
                                          "showRawOnHover": true,
                                          "hoverFormatRule": "thousands2Decimal",
                                          "changeKey": "cs_studio_iaa_revenue_m_dod",
                                          "dodDecimals": 2,
                                          "dodDownloadFormat": "0.0%",
                                          "hoverBubble": true,
                                          "sparklineKey": "sparkline_cs_studio_iaa_revenue_m",
                                          "sparklineDatesKey": "sparkline_dates",
                                          "tooltipDateFormat": "YYYY-MM"
                                        },
                                        "explainEn": "Total Ad Revenue Generated from Players' Ad Views",
                                        "explainCn": "玩家观看广告后产生的全部广告收入",
                                        "format": "bmk00"
                                      }
                                    },
                                    {
                                      "nameEn": "IAP Revenue($)",
                                      "nameCn": "IAP 收入($)",
                                      "code": "cs_studio_iap_revenue_m",
                                      "align": "right",
                                      "width": 240,
                                      "features": {
                                        "sortable": true,
                                        "cell": {
                                          "type": "sparkline",
                                          "showChangeRate": true,
                                          "showRawOnHover": true,
                                          "hoverFormatRule": "thousands2Decimal",
                                          "changeKey": "cs_studio_iap_revenue_m_dod",
                                          "dodDecimals": 2,
                                          "dodDownloadFormat": "0.0%",
                                          "hoverBubble": true,
                                          "sparklineKey": "sparkline_cs_studio_iap_revenue_m",
                                          "sparklineDatesKey": "sparkline_dates",
                                          "tooltipDateFormat": "YYYY-MM"
                                        },
                                        "explainEn": "Revenue generated from users’ in-app purchases, such as items, bundles, and subscriptions.",
                                        "explainCn": "用户通过游戏内购买道具、礼包、订阅等产生的收入。",
                                        "format": "bmk00"
                                      }
                                    },
                                    {
                                      "nameEn": "Spend($)",
                                      "nameCn": "UA 花费($)",
                                      "code": "cs_studio_spend",
                                      "align": "right",
                                      "features": {
                                        "sortable": true,
                                        "cell": {
                                          "type": "percentage",
                                          "showProgressBar": false,
                                          "showChangeRate": true,
                                          "showRawOnHover": true,
                                          "hoverFormatRule": "thousands2Decimal",
                                          "changeKey": "cs_studio_spend_dod",
                                          "formatDodAsPercent": true,
                                          "dodDecimals": 1,
                                          "dodDownloadFormat": "0.0%",
                                          "hoverBubble": true,
                                        },
                                        "explainEn": "UA Spend",
                                        "explainCn": "UA花费",
                                        "format": "bmk00"
                                      }
                                    }
                                  ]
                                }
                              }
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "name": "CommonLogWrap",
      "tabId": "yearToDate",
      "config": {
        "logConfig": {
          "menuId": "",
          "pageId": "903003",
          "pageName": "IEGG Casual Overview Year To Date",
          "extInfo": "Casual Studio Overview Year To Date",
          "pagePath": "/home/yearToDate"
        }
      },
      "children": [
        {
          "name": "CommonTabContentWrap",
          "className": "dbh-casual-card--year-to-date",
          "children": [
            {
              "name": "CasualOverviewWrap",
              "children": [
                {
                  "name": "CommonRow",
                  "className": "dbh-casual-overview__row",
                  "type": "layout",
                  "props": {},
                  "children": [
                    {
                      "name": "CommonCol",
                      "type": "layout",
                      "props": {
                        "w": 8
                      },
                      "children": [
                        {
                          "name": "Service",
                          "className": "",
                          "type": "view",
                          "props": {
                            "api": "/api/v2/dashboard/studio/casual_hub/overview/card_metrics",
                            "trackData": [
                              "extraParams",
                              "frameCode"
                            ],
                            "dataKey": "casualTotalRevenueYtdMetricCardData",
                            "filterLoading": false,
                            "beforeRequest": "function(data) {\n                                                            var _ref = data || {}, filterVal = _ref.filterVal, frameCode = _ref.frameCode;\n                                                            var et = filterVal === null || filterVal === void 0 ? void 0 : filterVal.end_time;\n                                                            var getTargetDay = function(dateStr) {\n                                                                var dayOffset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, sep = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : '';\n                                                                if (!dateStr) return '';\n                                                                var parts = dateStr.split(/[-/]/);\n                                                                var year = parseInt(parts[0], 10);\n                                                                var month = parseInt(parts[1], 10) - 1;\n                                                                var day = parseInt(parts[2], 10);\n                                                                var target = new Date(year, month, day + dayOffset);\n                                                                var rYear = target.getFullYear();\n                                                                var rMonth = String(target.getMonth() + 1).padStart(2, '0');\n                                                                var rDay = String(target.getDate()).padStart(2, '0');\n                                                                return [\n                                                                    rYear,\n                                                                    rMonth,\n                                                                    rDay\n                                                                ].join(sep);\n                                                            };\n                                                            var isToday = function(dateStr) {\n                                                                if (!dateStr) return false;\n                                                                var parts = dateStr.split(/[-/]/);\n                                                                var inputDate = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));\n                                                                var now = new Date();\n                                                                return inputDate.getFullYear() === now.getFullYear() && inputDate.getMonth() === now.getMonth() && inputDate.getDate() === now.getDate();\n                                                            };\n                                                            var tMinus13 = getTargetDay(et, -13, '-');\n                                                            var isT = isToday(et);\n                                                            return Object.assign({}, {\n                                                                studio_code: frameCode,\n                                                                filters: {},\n                                                                period: 'daily',\n                                                                start_time: tMinus13,\n                                                                end_time: et,\n                                                                // 固定为 false\n                                                                is_confirm: false,\n                                                                \"logical_flag\": \"ytd_actual_date\",\n                                                                metrics: [\n                                                                    'ytd_cs_casual_total_revenue',\n                                                                    'ytd_cs_self_incubation_revenue',\n                                                                    'ytd_overall_studio_total_revenue'\n                                                                ],\n                                                                trend_metrics: [\n                                                                    'overall_studio_total_revenue',\n                                                                    'cs_self_incubation_revenue'\n                                                                ]\n                                                            }, data.extraParams);\n                                                        }",
                            "formatData": "function(data) {\n                                                            var rawCardList = data && data.card_list ? data.card_list : [];\n                                                            var cardList = rawCardList.map(function(card) {\n                                                                var result = {\n                                                                    metrics_name: card.metrics_name,\n                                                                    value: card.value,\n                                                                    time: card.time\n                                                                };\n                                                                var dod = card.dod;\n                                                                if (dod) {\n                                                                    result.dod = {\n                                                                        show_value: dod.show_value || '',\n                                                                        this_value: dod.this_value || '',\n                                                                        last_value: dod.last_value || '',\n                                                                        this_time: dod.this_time || '',\n                                                                        last_time: dod.last_time || ''\n                                                                    };\n                                                                }\n                                                                var sdlw = card.sdlw;\n                                                                if (sdlw) {\n                                                                    result.yoy = {\n                                                                        show_value: sdlw.show_value || '',\n                                                                        this_value: sdlw.this_value || '',\n                                                                        last_value: sdlw.last_value || '',\n                                                                        this_time: sdlw.this_time || '',\n                                                                        last_time: sdlw.last_time || ''\n                                                                    };\n                                                                }\n                                                                var change = card.change;\n                                                                if (change) {\n                                                                    result.change = {\n                                                                        show_value: change.show_value || '',\n                                                                        this_value: change.this_value || '',\n                                                                        last_value: change.last_value || '',\n                                                                        this_time: change.this_time || '',\n                                                                        last_time: change.last_time || ''\n                                                                    };\n                                                                }\n                                                                return result;\n                                                            });\n                                                            var rawTrendList = data && data.trend_list ? data.trend_list : [];\n                                                            var trendList = rawTrendList.map(function(item) {\n                                                                return {\n                                                                    date: item.date,\n                                                                    metrics: item.metrics\n                                                                };\n                                                            });\n                                                            return {\n                                                                card_list: cardList,\n                                                                trend_list: trendList,\n                                                                breakdown: data && data.breakdown || []\n                                                            };\n                                                        }"
                          },
                          "children": [
                            {
                              "name": "CasualTotalRevenueCard",
                              "props": {
                                "apiDataKey": "casualTotalRevenueYtdMetricCardData",
                                "config": {
                                  "titleEn": "Casual Total Revenue YTD",
                                  "titleCn": "休闲游戏当年累计收入",
                                  "metricKey": "ytd_cs_casual_total_revenue",
                                  "formatRule": "bmk00",
                                  "preUnit": "$",
                                  "compareMetrics": [
                                    {
                                      "dataKey": "dod",
                                      "titleEn": "DoD",
                                      "titleCn": "日环比"
                                    }
                                  ],
                                  "donutSegments": [
                                    {
                                      "label": "Miniclip",
                                      "labelCn": "Miniclip",
                                      "value": 70,
                                      "color": "#69D19C",
                                      "metricKey": "ytd_overall_studio_total_revenue"
                                    },
                                    {
                                      "label": "Self-Incubation",
                                      "labelCn": "自孵化项目",
                                      "value": 30,
                                      "color": "#5086F3",
                                      "metricKey": "ytd_cs_self_incubation_revenue"
                                    }
                                  ],
                                  "trendMetrics": [
                                    {
                                      "metricKey": "overall_studio_total_revenue",
                                      "nameEn": "Miniclip",
                                      "nameCn": "Miniclip",
                                      "formatRule": "bmk00",
                                      "color": "#69D19C"
                                    },
                                    {
                                      "metricKey": "cs_self_incubation_revenue",
                                      "nameEn": "Self-Incubation",
                                      "nameCn": "自孵化项目",
                                      "formatRule": "bmk00",
                                      "color": "#5086F3"
                                    }
                                  ],
                                  "trendTitleEn": "Revenue Trend",
                                  "trendTitleCn": "收入趋势",
                                  "trendTimeType": "Day",
                                  "trendShowConfig": {
                                    "showBarChart": true,
                                    "showLineChart": false,
                                    "showBubbleTitle": true,
                                    "isStackBar": true,
                                    "stackBarShowTotalLabel": false
                                  },
                                  "trendLastDays": 14
                                }
                              }
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "name": "CommonCol",
                      "type": "layout",
                      "props": {
                        "w": 8
                      },
                      "children": [
                        {
                          "name": "Service",
                          "className": "",
                          "type": "view",
                          "props": {
                            "api": "/api/v2/dashboard/studio/casual_hub/overview/card_metrics",
                            "trackData": [
                              "extraParams",
                              "frameCode"
                            ],
                            "dataKey": "selfIncubationRevenueYtdMetricCardData",
                            "filterLoading": false,
                            "beforeRequest": "function(data) {\n                                                            var _ref = data || {}, filterVal = _ref.filterVal, frameCode = _ref.frameCode;\n                                                            var et = filterVal === null || filterVal === void 0 ? void 0 : filterVal.end_time;\n                                                            var getTargetDay = function(dateStr) {\n                                                                var dayOffset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, sep = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : '';\n                                                                if (!dateStr) return '';\n                                                                var parts = dateStr.split(/[-/]/);\n                                                                var year = parseInt(parts[0], 10);\n                                                                var month = parseInt(parts[1], 10) - 1;\n                                                                var day = parseInt(parts[2], 10);\n                                                                var target = new Date(year, month, day + dayOffset);\n                                                                var rYear = target.getFullYear();\n                                                                var rMonth = String(target.getMonth() + 1).padStart(2, '0');\n                                                                var rDay = String(target.getDate()).padStart(2, '0');\n                                                                return [\n                                                                    rYear,\n                                                                    rMonth,\n                                                                    rDay\n                                                                ].join(sep);\n                                                            };\n                                                            var isToday = function(dateStr) {\n                                                                if (!dateStr) return false;\n                                                                var parts = dateStr.split(/[-/]/);\n                                                                var inputDate = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));\n                                                                var now = new Date();\n                                                                return inputDate.getFullYear() === now.getFullYear() && inputDate.getMonth() === now.getMonth() && inputDate.getDate() === now.getDate();\n                                                            };\n                                                            var tMinus13 = getTargetDay(et, -13, '-');\n                                                            var isT = isToday(et);\n                                                            return Object.assign({}, {\n                                                                studio_code: frameCode,\n                                                                filters: {},\n                                                                period: 'daily',\n                                                                start_time: tMinus13,\n                                                                end_time: et,\n                                                                card_type: '1',\n                                                                // is_confirm: filterVal?.is_confirm,\n                                                                is_confirm: false,\n                                                                breakdown_dimension: 'game_code',\n                                                                \"logical_flag\": \"top_no_others,ytd_actual_date\",\n                                                                metrics: [\n                                                                    'ytd_cs_self_incubation_revenue',\n                                                                    'cs_self_incubation_dau',\n                                                                    'cs_overall_d2_t1'\n                                                                ],\n                                                                trend_metrics: [\n                                                                    'cs_self_incubation_revenue'\n                                                                ],\n                                                                breakdown_metrics: 'ytd_cs_si_iaa_revenue'\n                                                            }, data.extraParams);\n                                                        }",
                            "formatData": "function(data) {\n                                                            var rawCardList = data && data.card_list ? data.card_list : [];\n                                                            var cardList = rawCardList.map(function(card) {\n                                                                var result = {\n                                                                    metrics_name: card.metrics_name,\n                                                                    value: card.value,\n                                                                    time: card.time\n                                                                };\n                                                                var dod = card.dod;\n                                                                if (dod) {\n                                                                    result.dod = {\n                                                                        show_value: dod.show_value || '',\n                                                                        this_value: dod.this_value || '',\n                                                                        last_value: dod.last_value || '',\n                                                                        this_time: dod.this_time || '',\n                                                                        last_time: dod.last_time || ''\n                                                                    };\n                                                                }\n                                                                var sdlw = card.sdlw;\n                                                                if (sdlw) {\n                                                                    result.yoy = {\n                                                                        show_value: sdlw.show_value || '',\n                                                                        this_value: sdlw.this_value || '',\n                                                                        last_value: sdlw.last_value || '',\n                                                                        this_time: sdlw.this_time || '',\n                                                                        last_time: sdlw.last_time || ''\n                                                                    };\n                                                                }\n                                                                var change = card.change;\n                                                                if (change) {\n                                                                    result.change = {\n                                                                        show_value: change.show_value || '',\n                                                                        this_value: change.this_value || '',\n                                                                        last_value: change.last_value || '',\n                                                                        this_time: change.this_time || '',\n                                                                        last_time: change.last_time || ''\n                                                                    };\n                                                                }\n                                                                return result;\n                                                            });\n                                                            var rawTrendList = data && data.trend_list ? data.trend_list : [];\n                                                            var trendList = rawTrendList.map(function(item) {\n                                                                return {\n                                                                    date: item.date,\n                                                                    metrics: item.metrics\n                                                                };\n                                                            });\n                                                            var rawBreakdown = data && data.breakdown ? data.breakdown : [];\n                                                            var sortedBreakdown = rawBreakdown.slice().sort(function(a, b) {\n                                                                return parseFloat(String(b.value || '0')) - parseFloat(String(a.value || '0'));\n                                                            }).slice(0, 3);\n                                                            var gameRanks = sortedBreakdown.map(function(item, idx) {\n                                                                return {\n                                                                    gameCode: item.name || item.full_name || '',\n                                                                    rank: idx + 1,\n                                                                    name: String(item.full_name || item.name || '')\n                                                                };\n                                                            });\n                                                            return {\n                                                                card_list: cardList,\n                                                                trend_list: trendList,\n                                                                breakdown: data && data.breakdown || [],\n                                                                gameRanks: gameRanks\n                                                            };\n                                                        }"
                          },
                          "children": [
                            {
                              "name": "CasualSubMetricCard",
                              "props": {
                                "apiDataKey": "selfIncubationRevenueYtdMetricCardData",
                                "config": {
                                  "titleEn": "Self-Incubation Revenue YTD",
                                  "titleCn": "自孵化项目当年累计收入",
                                  "metricKey": "ytd_cs_self_incubation_revenue",
                                  "formatRule": "bmk00",
                                  "preUnit": "$",
                                  "compareMetrics": [
                                    {
                                      "dataKey": "dod",
                                      "titleEn": "DoD",
                                      "titleCn": "日环比"
                                    }
                                  ],
                                  "useDataGameRanks": true,
                                  "gameRankJumpType": "window",
                                  "useDynamicSubtitle": true,
                                  "subtitleMode": "filterRange",
                                  "subMetrics": [
                                    {
                                      "labelEn": "DAU",
                                      "labelCn": "日活跃",
                                      "metricKey": "cs_self_incubation_dau",
                                      "formatRule": "bmk00",
                                      "preUnit": "",
                                      "useDynamicSubtitle": false
                                    },
                                    {
                                      "labelEn": "D2(T-1)",
                                      "labelCn": "次留(T-1)",
                                      "metricKey": "cs_overall_d2_t1",
                                      "formatRule": "percent2Decimal",
                                      "preUnit": "",
                                      "useDynamicSubtitle": false,
                                      "compareMetrics": [
                                        {
                                          "dataKey": "dod",
                                          "titleEn": "DoD",
                                          "titleCn": "日环比",
                                          "extendFormatRule": "percent2Decimal"
                                        }
                                      ]
                                    }
                                  ],
                                  "trendConfig": {
                                    "metricKey": "cs_self_incubation_revenue",
                                    "nameEn": "Revenue",
                                    "nameCn": "总收入"
                                  },
                                  "trendTitleEn": "Revenue Trend",
                                  "trendTitleCn": "收入趋势",
                                  "trendTimeType": "Day"
                                }
                              }
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "name": "CommonCol",
                      "type": "layout",
                      "props": {
                        "w": 8
                      },
                      "children": [
                        {
                          "name": "Service",
                          "className": "",
                          "type": "view",
                          "props": {
                            "api": "/api/v2/dashboard/studio/casual_hub/overview/card_metrics",
                            "trackData": [
                              "extraParams",
                              "frameCode"
                            ],
                            "dataKey": "ytd__studioRevenueMetricCardData",
                            "filterLoading": false,
                            "beforeRequest": "function(data) {\n                                                            var _ref = data || {}, filterVal = _ref.filterVal, frameCode = _ref.frameCode;\n                                                            var endTime = filterVal && (filterVal === null || filterVal === void 0 ? void 0 : filterVal.end_time);\n                                                            var trendSixMonthStart;\n                                                            var effectiveEndTime = endTime;\n                                                            if (endTime) {\n                                                                var datePart = String(endTime).trim().slice(0, 10);\n                                                                var match = /^([0-9]{4})-([0-9]{2})-([0-9]{2})$/.exec(datePart);\n                                                                if (match) {\n                                                                    var year = Number(match[1]);\n                                                                    var month = Number(match[2]);\n                                                                    var day = Number(match[3]);\n                                                                    if (month >= 1 && month <= 12 && day >= 1 && day <= 31) {\n                                                                        var parsed = new Date(year, month - 1, day);\n                                                                        if (parsed.getFullYear() === year && parsed.getMonth() === month - 1 && parsed.getDate() === day) {\n                                                                            var now = new Date();\n                                                                            var isCurrentMonth = year === now.getFullYear() && month === now.getMonth() + 1;\n                                                                            if (isCurrentMonth) {\n                                                                                var prevMonthFirst = new Date(year, month - 2 - 5, 1);\n                                                                                var prevMonthLast = new Date(year, month - 1, 0);\n                                                                                trendSixMonthStart = \"\".concat(prevMonthFirst.getFullYear(), \"-\").concat(String(prevMonthFirst.getMonth() + 1).padStart(2, '0'), \"-\").concat(String(prevMonthFirst.getDate()).padStart(2, '0'));\n                                                                                effectiveEndTime = \"\".concat(prevMonthLast.getFullYear(), \"-\").concat(String(prevMonthLast.getMonth() + 1).padStart(2, '0'), \"-\").concat(String(prevMonthLast.getDate()).padStart(2, '0'));\n                                                                            } else {\n                                                                                var start = new Date(year, month - 1 - 5, 1);\n                                                                                trendSixMonthStart = \"\".concat(start.getFullYear(), \"-\").concat(String(start.getMonth() + 1).padStart(2, '0'), \"-\").concat(String(start.getDate()).padStart(2, '0'));\n                                                                                var end = new Date(year, month, 0);\n                                                                                effectiveEndTime = \"\".concat(end.getFullYear(), \"-\").concat(String(end.getMonth() + 1).padStart(2, '0'), \"-\").concat(String(end.getDate()).padStart(2, '0'));\n                                                                            }\n                                                                        }\n                                                                    }\n                                                                }\n                                                            }\n                                                            return Object.assign({}, {\n                                                                studio_code: frameCode,\n                                                                filters: {},\n                                                                period: 'monthly',\n                                                                start_time: trendSixMonthStart || filterVal && filterVal.start_time,\n                                                                end_time: effectiveEndTime,\n                                                                card_type: '1',\n                                                                is_confirm: false,\n                                                                breakdown_dimension: 'game_code',\n                                                                logical_flag: 'top_no_others,ytd_actual_date',\n                                                                metrics: [\n                                                                    'ytd_cs_studio_total_revenue_m',\n                                                                    'ytd_cs_studio_iaa_revenue_m',\n                                                                    'ytd_cs_studio_iap_revenue_m'\n                                                                ],\n                                                                trend_metrics: [\n                                                                    'cs_studio_total_revenue_m'\n                                                                ],\n                                                                breakdown_metrics: 'ytd_cs_studio_total_revenue_m'\n                                                            }, data.extraParams);\n                                                        }",
                            "formatData": "function(data) {\n                                                            var rawCardList = data && data.card_list ? data.card_list : [];\n                                                            var cardList = rawCardList.map(function(card) {\n                                                                var result = {\n                                                                    metrics_name: card.metrics_name,\n                                                                    value: card.value,\n                                                                    time: card.time\n                                                                };\n                                                                var dod = card.dod;\n                                                                if (dod) {\n                                                                    result.dod = {\n                                                                        show_value: dod.show_value || '',\n                                                                        this_value: dod.this_value || '',\n                                                                        last_value: dod.last_value || '',\n                                                                        this_time: dod.this_time || '',\n                                                                        last_time: dod.last_time || ''\n                                                                    };\n                                                                }\n                                                                var sdlw = card.sdlw;\n                                                                if (sdlw) {\n                                                                    result.yoy = {\n                                                                        show_value: sdlw.show_value || '',\n                                                                        this_value: sdlw.this_value || '',\n                                                                        last_value: sdlw.last_value || '',\n                                                                        this_time: sdlw.this_time || '',\n                                                                        last_time: sdlw.last_time || ''\n                                                                    };\n                                                                }\n                                                                var change = card.change;\n                                                                if (change) {\n                                                                    result.change = {\n                                                                        show_value: change.show_value || '',\n                                                                        this_value: change.this_value || '',\n                                                                        last_value: change.last_value || '',\n                                                                        this_time: change.this_time || '',\n                                                                        last_time: change.last_time || ''\n                                                                    };\n                                                                }\n                                                                return result;\n                                                            });\n                                                            var rawTrendList = data && data.trend_list ? data.trend_list : [];\n                                                            var trendList = rawTrendList.map(function(item) {\n                                                                var dateStr = item.date;\n                                                                var formattedDate = dateStr && dateStr.length === 8 ? dateStr.slice(0, 6) : dateStr;\n                                                                return {\n                                                                    date: formattedDate,\n                                                                    metrics: item.metrics\n                                                                };\n                                                            });\n                                                            var rawBreakdown = data && data.breakdown ? data.breakdown : [];\n                                                            var sortedBreakdown = rawBreakdown.slice().sort(function(a, b) {\n                                                                return parseFloat(String(b.value || '0')) - parseFloat(String(a.value || '0'));\n                                                            }).slice(0, 3);\n                                                            var gameRanks = sortedBreakdown.map(function(item, idx) {\n                                                                return {\n                                                                    gameCode: item.name || item.full_name || '',\n                                                                    rank: idx + 1,\n                                                                    name: String(item.full_name || item.name || '')\n                                                                };\n                                                            });\n                                                            return {\n                                                                card_list: cardList,\n                                                                trend_list: trendList,\n                                                                breakdown: data && data.breakdown || [],\n                                                                gameRanks: gameRanks\n                                                            };\n                                                        }"
                          },
                          "children": [
                            {
                              "name": "CasualSubMetricCard",
                              "props": {
                                "apiDataKey": "ytd__studioRevenueMetricCardData",
                                "config": {
                                  "titleEn": "Miniclip Revenue",
                                  "titleCn": "Miniclip累计收入",
                                  "titleIconUrl": "https://ogdb-cdn.intlgame.cn/aupload/admin/studio_hub/image/1741760898187_选中态.png",
                                  "metricKey": "ytd_cs_studio_total_revenue_m",
                                  "subtitleTimeMetricKey": "ytd_cs_studio_total_revenue_m",
                                  "subtitleChangeKey": "studioYtdActualEndTime",
                                  "formatRule": "bmk00",
                                  "preUnit": "$",
                                  "isRightCard": true,
                                  "useDataGameRanks": true,
                                  "useDynamicSubtitle": true,
                                  "subMetrics": [
                                    {
                                      "labelEn": "IAP Revenue",
                                      "labelCn": "IAP 收入",
                                      "metricKey": "ytd_cs_studio_iap_revenue_m",
                                      "formatRule": "bmk00",
                                      "preUnit": "$"
                                    },
                                    {
                                      "labelEn": "IAA Revenue",
                                      "labelCn": "IAA 收入",
                                      "metricKey": "ytd_cs_studio_iaa_revenue_m",
                                      "formatRule": "bmk00",
                                      "preUnit": "$"
                                    }
                                  ],
                                  "trendConfig": {
                                    "metricKey": "cs_studio_total_revenue_m",
                                    "nameEn": "Revenue",
                                    "nameCn": "总收入"
                                  },
                                  "trendTitleEn": "Revenue Trend",
                                  "trendTitleCn": "收入趋势",
                                  "compareMetrics": [
                                    {
                                      "dataKey": "dod",
                                      "titleEn": "DoD",
                                      "titleCn": "日环比"
                                    }
                                  ]
                                }
                              }
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  "name": "Service",
                  "data": {
                    "extraParams": {
                      "multi_sort": [
                        {
                          "sort_by": "ytd_cs_si_iaa_revenue",
                          "desc": true
                        }
                      ],
                      "page": 1,
                      "page_size": 9999
                    }
                  },
                  "props": {
                    "api": "/api/v2/dashboard/studio/casual_hub/overview/overall_performance",
                    "trackData": [
                      "extraParams",
                      "frameCode"
                    ],
                    "dataKey": "selfIncubationTableData",
                    "filterLoading": false,
                    "beforeRequest": (data) => {
                      const { filterVal, frameCode } = data || {};
                      const et = filterVal && filterVal.end_time;
                      const endDateStr = et ? String(et).trim().slice(0, 10).split('-').join('') : '';
                      return Object.assign(
                        {},
                        {
                          studio_code: frameCode,
                          filters: {},
                          accumulation: {
                            custom_accumulation: [
                              { is_accumulation: true, key: 'game_code' },
                              { is_accumulation: true, key: 'category' },
                              { is_accumulation: false, key: 'studio' },
                            ],
                          },
                          page: 1,
                          page_size: 9999,
                          start_date: endDateStr,
                          end_date: endDateStr,
                          sorted_by: 'ytd_cs_si_iaa_revenue',
                          desc: true,
                          multi_sort: [{ sort_by: 'ytd_cs_si_iaa_revenue', desc: true }],
                          metrics: [
                            'ytd_cs_si_iaa_revenue',
                            'cs_si_iaa_revenue',
                            'cs_si_dnu',
                            'cs_si_dau',
                            'cs_si_ret_d2_t1',
                            'cs_si_ret_d7_t6',
                            'cs_si_spend',
                            'cs_si_roi_d1',
                            'cs_si_roi_d7',
                          ],
                          "logical_flag": "ytd_actual_date",
                          period: 'daily',
                        },
                        data.extraParams,
                      );
                    },
                    "formatData": (data) => { return data }
                  },
                  "children": [
                    {
                      "name": "Service",
                      "props": {
                        "api": "/api/v2/dashboard/studio/casual_hub/overview/overall_performance",
                        "trackData": [
                          "frameCode"
                        ],
                        "dataKey": "selfIncubationSparklineData",
                        "filterLoading": false,
                        "beforeRequest": (data) => {
                          const { filterVal, frameCode } = data || {};
                          const et = filterVal?.end_time;
    
                          const getTargetDay = (dateStr, dayOffset = 0, sep = '') => {
                            if (!dateStr) return '';
    
                            const parts = dateStr.split(/[-/]/);
                            const year = parseInt(parts[0], 10);
                            const month = parseInt(parts[1], 10) - 1;
                            const day = parseInt(parts[2], 10);
    
                            const target = new Date(year, month, day + dayOffset);
    
                            const rYear = target.getFullYear();
                            const rMonth = String(target.getMonth() + 1).padStart(2, '0');
                            const rDay = String(target.getDate()).padStart(2, '0');
    
                            return [rYear, rMonth, rDay].join(sep);
                          };
                          const isToday = (dateStr) => {
                            if (!dateStr) return false;
                        
                            const parts = dateStr.split(/[-/]/);
                            const inputDate = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));
                        
                            const now = new Date();
                        
                            return (
                              inputDate.getFullYear() === now.getFullYear() &&
                          inputDate.getMonth() === now.getMonth() &&
                          inputDate.getDate() === now.getDate()
                            );
                          };
                          const t = getTargetDay(et, 0);
                          const tMinus13 = getTargetDay(et, -13);
                          const isT = isToday(et);
                      
                          return Object.assign(
                            {},
                            {
                              logical_flag: 'trend_chart',
                              studio_code: frameCode,
                              filters: {},
                              accumulation: {
                                custom_accumulation: [
                                  { is_accumulation: true, key: 'game_code' },
                                  { is_accumulation: true, key: 'category' },
                                  { is_accumulation: false, key: 'studio' },
                                ],
                              },
                              start_date: tMinus13,
                              end_date: t,
                              sorted_by: 'date',
                              desc: true,
                              multi_sort: [{ sort_by: 'cs_si_iaa_revenue', desc: true }],
                              metrics: ['cs_si_iaa_revenue'],
                              period: 'daily',
                            },
                          );
                        },
                        "formatData": (data) => {
                          if (!data || !data.metrics_list) return data;
                          const metricsList = data.metrics_list.map((item) => {
                            const { metrics } = item;
                            if (metrics && metrics.cs_si_iaa_revenue) {
                              const newMetrics = Object.assign({}, metrics);
                              newMetrics.ytd_cs_si_iaa_revenue = newMetrics.cs_si_iaa_revenue;
                              delete newMetrics.cs_si_iaa_revenue;
                              return Object.assign({}, item, { metrics: newMetrics });
                            }
                            return item;
                          });
                          return Object.assign({}, data, { metrics_list: metricsList });
                        }
                      },
                      "children": [
                        {
                          "name": "DataMergeWrap",
                          "props": {
                            "dataKey": "selfIncubationTableData",
                            "sparklineDataKey": "selfIncubationSparklineData"
                          },
                          "children": [
                            {
                              "name": "CommonTable",
                              "className": "margin-t-20 dbh-casual-table",
                              "props": {
                                "dataKey": "selfIncubationTableData",
                                "dataPath": "metrics_list",
                                "totalRecordPath": "row_count",
                                "metricsCardWrapProps": {
                                  "titleEn": "Self-Incubation Projects",
                                  "titleCn": "自孵化项目",
                                  "operation": [
                                    {
                                      "name": "DownloadButton",
                                      "className": "dbd-common-table__operation-btn",
                                      "config": {
                                        "apiDownload": {
                                          "fileNameEn": "Self-Incubation Projects",
                                          "fileNameCn": "自孵化项目",
                                          "sheetNameEn": "Self-Incubation Projects",
                                          "sheetNameCn": "自孵化项目",
                                          "api": "/api/v2/dashboard/studio/casual_hub/overview/overall_performance",
                                          "fixedPageSize": 50000,
                                          "formatData": (metricsList, context) => {
                                            var casualInfo = context && context.casualInfo;
                                            var games = casualInfo && casualInfo.games;
                                            var gameMap = {};
                                            if (games && games.length) {
                                              games.forEach(function (g) {
                                                if (g.game_name) gameMap[g.game_name] = g;
                                                if (g.entity_name) gameMap[g.entity_name] = g;
                                                if (g.entity_name_cn) gameMap[g.entity_name_cn] = g;
                                              });
                                            }
                                            const rows = metricsList.map((item, index) => {
                                              const rawDate = item.date ? String(item.date) : '';
                                              // YYYYMMDD → YYYY-MM-DD
                                              const formattedDate = rawDate.length === 8
                                                ? `${rawDate.slice(0, 4)  }-${  rawDate.slice(4, 6)  }-${  rawDate.slice(6, 8)}`
                                                : rawDate;
                                              // 维度：从 custom_dimensions 取，再用 gameMap 映射为真实游戏名
                                              const customDims = item.custom_dimensions;
                                              const getDimValue = function (key) {
                                                if (!customDims || !customDims.length) return '';
                                                const dim = customDims.find((d) => { return d.key === key });
                                                return (dim && dim.value) ? dim.value : '';
                                              };
                                              const rawGameCode = getDimValue('game_code');
                                              const gameInfo = gameMap[rawGameCode];
                                              const isEN = !!(context && context.isEN);
                                              const gameName = gameInfo ? (isEN ? (gameInfo.entity_name || gameInfo.entity_name_cn || rawGameCode) : (gameInfo.entity_name_cn || gameInfo.entity_name || rawGameCode)) : rawGameCode;
                                              const category = getDimValue('category');
                                              const {metrics} = item;
                                              const flatMetrics = {};
                                              if (metrics) {
                                                Object.keys(metrics).forEach((key) => {
                                                  const m = metrics[key];
                                                  flatMetrics[key] = (m && m.value !== undefined && m.value !== '') ? m.value : '';
                                                  flatMetrics[`${key  }_dod`] = (m && m.dod !== undefined && m.dod !== '') ? m.dod : '';
                                                });
                                              }
                                              return Object.assign({}, item, flatMetrics, {
                                                rank: index + 1,
                                                date: formattedDate,
                                                game_name: gameName,
                                                category,
                                              });
                                            });
                                            // 前端排序：读取用户当前排序状态（由 downloadSortKey 写入）
                                            const userSortState = context && context.selfIncubationDownloadSortState;
                                            const sortBy = (userSortState && userSortState.length > 0) ? userSortState[0].by : null;
                                            const sortDesc = (userSortState && userSortState.length > 0) ? userSortState[0].order === 'desc' : true;
                                            if (sortBy) {
                                              return rows.sort((a, b) => {
                                                const va = (a[sortBy] !== '' && a[sortBy] !== undefined && a[sortBy] !== null) ? Number(a[sortBy]) : (sortDesc ? -Infinity : Infinity);
                                                const vb = (b[sortBy] !== '' && b[sortBy] !== undefined && b[sortBy] !== null) ? Number(b[sortBy]) : (sortDesc ? -Infinity : Infinity);
                                                return sortDesc ? vb - va : va - vb;
                                              });
                                            }
                                            // 明细模式：先按日期倒序，再按当年累计 IAA 收入降序（同日期即按收入降序）
                                            const detailMetric = 'ytd_cs_si_iaa_revenue';
                                            return rows.sort((a, b) => {
                                              const da = String(a.date || '');
                                              const db = String(b.date || '');
                                              if (da !== db) return db.localeCompare(da);
                                              const va = (a[detailMetric] !== '' && a[detailMetric] !== undefined && a[detailMetric] !== null) ? Number(a[detailMetric]) : -Infinity;
                                              const vb = (b[detailMetric] !== '' && b[detailMetric] !== undefined && b[detailMetric] !== null) ? Number(b[detailMetric]) : -Infinity;
                                              return vb - va;
                                            });
                                          },
                                          "beforeRequest": (data) => {
                                            const filter = data && data.filter;
                                            const frameCode = data && data.frameCode;
                                            const fv = filter;
                                            const et = fv && fv.end_time;
                                            const endDateStr = et ? String(et).trim().slice(0, 10).split('-').join('') : '';
                                            // start_date：选择日所在年份的 1月1日
                                            const startDateStr = endDateStr ? `${endDateStr.slice(0, 4)  }0101` : '';
                                            return Object.assign(
                                              {},
                                              data.extraParams,
                                              {
                                                studio_code: frameCode,
                                                filters: {},
                                                accumulation: {
                                                  custom_accumulation: [
                                                    { is_accumulation: true, key: 'game_code' },
                                                    { is_accumulation: true, key: 'category' },
                                                    { is_accumulation: false, key: 'studio' },
                                                  ],
                                                },
                                                page: 1,
                                                page_size: 9999,
                                                start_date: startDateStr,
                                                end_date: endDateStr,
                                                sorted_by: 'date',
                                                desc: true,
                                                multi_sort: [{ sort_by: 'date', desc: true }, { sort_by: 'ytd_cs_si_iaa_revenue', desc: true }],
                                                metrics: [
                                                  'ytd_cs_si_iaa_revenue',
                                                  'cs_si_iaa_revenue',
                                                  'cs_si_dnu',
                                                  'cs_si_dau',
                                                  'cs_si_ret_d2_t1',
                                                  'cs_si_ret_d7_t6',
                                                  'cs_si_spend',
                                                  'cs_si_roi_d1',
                                                  'cs_si_roi_d7',
                                                ],
                                                logical_flag: 'ytd_actual_date',
                                                period: 'daily',
                                              },
                                            );
                                          },
                                          "columns": [
                                            { "code": "date", "name": "Date", "nameEn": "Date", "nameCn": "日期", "format": "@", "width": 120 },
                                            { "code": "game_name", "name": "Game", "nameEn": "Game", "nameCn": "游戏", "format": "@", "width": 200 },
                                            { "code": "category", "name": "Category", "nameEn": "Category", "nameCn": "类型", "format": "@", "width": 140 },
                                            { "code": "ytd_cs_si_iaa_revenue", "name": "YTD IAA Revenue($)", "nameEn": "YTD IAA Revenue($)", "nameCn": "当年累计 IAA 收入($)", "format": "#,##0.00", "width": 160 },
                                            { "code": "ytd_cs_si_iaa_revenue_dod", "name": "YTD IAA Revenue($)_dod", "nameEn": "YTD IAA Revenue($)_dod", "nameCn": "当年累计 IAA 收入($)_日环比", "format": "0.0%", "width": 160 },
                                            { "code": "cs_si_iaa_revenue", "name": "IAA Revenue($)", "nameEn": "IAA Revenue($)", "nameCn": "IAA收入($)", "format": "#,##0.00", "width": 180 },
                                            { "code": "cs_si_iaa_revenue_dod", "name": "IAA Revenue($)_dod", "nameEn": "IAA Revenue($)_dod", "nameCn": "IAA收入($)_日环比", "format": "0.0%", "width": 160 },
                                            { "code": "cs_si_dnu", "name": "DNU", "nameEn": "DNU", "nameCn": "日新进", "format": "#,##0", "width": 140 },
                                            { "code": "cs_si_dnu_dod", "name": "DNU_dod", "nameEn": "DNU_dod", "nameCn": "日新进_日环比", "format": "0.0%", "width": 120 },
                                            { "code": "cs_si_dau", "name": "DAU", "nameEn": "DAU", "nameCn": "日活跃", "format": "#,##0", "width": 140 },
                                            { "code": "cs_si_dau_dod", "name": "DAU_dod", "nameEn": "DAU_dod", "nameCn": "日活跃_日环比", "format": "0.0%", "width": 120 },
                                            { "code": "cs_si_ret_d2_t1", "name": "D2(T-1)", "nameEn": "D2(T-1)", "nameCn": "次留(T-1)", "format": "0.00%", "width": 120 },
                                            { "code": "cs_si_ret_d2_t1_dod", "name": "D2(T-1)_dod", "nameEn": "D2(T-1)_dod", "nameCn": "次留(T-1)_日环比", "format": "0.0%", "width": 120 },
                                            { "code": "cs_si_ret_d7_t6", "name": "D7(T-6)", "nameEn": "D7(T-6)", "nameCn": "7留(T-6)", "format": "0.00%", "width": 120 },
                                            { "code": "cs_si_ret_d7_t6_dod", "name": "D7(T-6)_dod", "nameEn": "D7(T-6)_dod", "nameCn": "7留(T-6)_日环比", "format": "0.0%", "width": 120 },
                                            { "code": "cs_si_spend", "name": "Spend($)", "nameEn": "Spend($)", "nameCn": "UA 花费($)", "format": "#,##0.00", "width": 140 },
                                            { "code": "cs_si_spend_dod", "name": "Spend($)_dod", "nameEn": "Spend($)_dod", "nameCn": "UA 花费($)_日环比", "format": "0.0%", "width": 140 },
                                            { "code": "cs_si_roi_d1", "name": "ROAS1", "nameEn": "ROAS1", "nameCn": "ROAS1", "format": "0.00%", "width": 100 },
                                            { "code": "cs_si_roi_d1_dod", "name": "ROAS1_dod", "nameEn": "ROAS1_dod", "nameCn": "ROAS1_日环比", "format": "0.0%", "width": 100 },
                                            { "code": "cs_si_roi_d7", "name": "ROAS7", "nameEn": "ROAS7", "nameCn": "ROAS7", "format": "0.00%", "width": 100 },
                                            { "code": "cs_si_roi_d7_dod", "name": "ROAS7_dod", "nameEn": "ROAS7_dod", "nameCn": "ROAS7_日环比", "format": "0.0%", "width": 100 },
                                          ]
                                        }
                                      }
                                    }
                                  ]
                                },
                                "commonBaseTableProps": {
                                  "tableConfig": {
                                    "useVirtual": {
                                      "horizontal": false,
                                      "vertical": false,
                                      "header": false
                                    },
                                    "hidePaginationWhenSinglePage": true,
                                    "pagination": {},
                                    "downloadSortKey": "selfIncubationDownloadSortState"
                                  },
                                  "columns": [
                                    {
                                      "nameEn": "Game",
                                      "nameCn": "游戏",
                                      "code": "game_name",
                                      "align": "left",
                                      "width": 250,
                                      "features": {
                                        "sortable": false,
                                        "cell": {
                                          "type": "gameIcon",
                                          "showRawOnHover": true,
                                          "rankKey": "rank",
                                          "iconKey": "game_icon",
                                          "nameKey": "game_name",
                                          "countryCodeKey": "country_code",
                                          "countryNameKey": "country_name"
                                        }
                                      }
                                    },
                                    {
                                      "nameEn": "Category",
                                      "nameCn": "类型",
                                      "code": "category",
                                      "align": "left",
                                      "width": 140,
                                      "features": {
                                        "sortable": false,
                                        "cell": {
                                          "type": "category",
                                          "valueMapping": {
                                            "Self-Incubation": {
                                              "color": "#28B463",
                                              "backgroundColor": "#EAFAF1",
                                              "label": "Self-Incubation"
                                            },
                                            "Self-incubation": {
                                              "color": "#28B463",
                                              "backgroundColor": "#EAFAF1",
                                              "label": "Self-incubation"
                                            }
                                          }
                                        }
                                      }
                                    },
                                    {
                                      "nameEn": "YTD IAA Revenue($)",
                                      "nameCn": "当年累计 IAA 收入($)",
                                      "code": "ytd_cs_si_iaa_revenue",
                                      "align": "right",
                                      "width": 240,
                                      "features": {
                                        "sortable": true,
                                        "explainEn": "Total ad revenue cumulatively generated by players after viewing ads during the year.",
                                        "explainCn": "玩家当年观看广告后累计产生的全部广告收入",
                                        "cell": {
                                          "type": "sparkline",
                                          "showChangeRate": true,
                                          "showRawOnHover": true,
                                          "hoverFormatRule": "thousands2Decimal",
                                          "changeKey": "ytd_cs_si_iaa_revenue_dod",
                                          "dodDecimals": 2,
                                          "dodDownloadFormat": "0.0%",
                                          "hoverBubble": true,
                                          "sparklineKey": "sparkline_ytd_cs_si_iaa_revenue",
                                          "sparklineDatesKey": "sparkline_dates",
                                          "tooltipDateFormat": "YYYY-MM-DD",
                                          "trendLastDays": 14
                                        },
                                        "format": "bmk00"
                                      }
                                    },
                                    {
                                      "nameEn": "IAA Revenue($)",
                                      "nameCn": "IAA 收入($)",
                                      "code": "cs_si_iaa_revenue",
                                      "align": "right",
                                      "width": 170,
                                      "features": {
                                        "sortable": true,
                                        "explainEn": "Total Ad Revenue Generated from Players' Ad Views",
                                        "explainCn": "玩家观看广告后产生的全部广告收入",
                                        "cell": {
                                          "type": "percentage",
                                          "showProgressBar": false,
                                          "showChangeRate": true,
                                          "showRawOnHover": true,
                                          "hoverFormatRule": "thousands2Decimal",
                                          "changeKey": "cs_si_iaa_revenue_dod",
                                          "formatDodAsPercent": true,
                                          "dodDecimals": 1,
                                          "dodDownloadFormat": "0.0%",
                                          "hoverBubble": true,
                                          "trendLastDays": 14
                                        },
                                        "format": "bmk00"
                                      }
                                    },
                                    {
                                      "nameEn": "DNU",
                                      "nameCn": "日新进",
                                      "code": "cs_si_dnu",
                                      "align": "right",
                                      "width": 170,
                                      "features": {
                                        "sortable": true,
                                        "cell": {
                                          "type": "percentage",
                                          "showProgressBar": false,
                                          "showChangeRate": true,
                                          "showRawOnHover": true,
                                          "hoverFormatRule": "thousandsInit",
                                          "changeKey": "cs_si_dnu_dod",
                                          "formatDodAsPercent": true,
                                          "dodDecimals": 1,
                                          "dodDownloadFormat": "0.0%",
                                          "hoverBubble": true,
                                        },
                                        "explainEn": "",
                                        "explainCn": "",
                                        "format": "intBmk00"
                                      }
                                    },
                                    {
                                      "nameEn": "DAU",
                                      "nameCn": "日活跃",
                                      "code": "cs_si_dau",
                                      "align": "right",
                                      "width": 170,
                                      "features": {
                                        "sortable": true,
                                        "cell": {
                                          "type": "percentage",
                                          "showProgressBar": false,
                                          "showChangeRate": true,
                                          "showRawOnHover": true,
                                          "hoverFormatRule": "thousandsInit",
                                          "changeKey": "cs_si_dau_dod",
                                          "formatDodAsPercent": true,
                                          "dodDecimals": 1,
                                          "dodDownloadFormat": "0.0%",
                                          "hoverBubble": true,
                                        },
                                        "explainEn": "Unique device count with game logins during the statistical period(device id deduplicated)",
                                        "explainCn": "统计周期内登录过游戏的去重设备数(xwid)。",
                                        "format": "intBmk00"
                                      }
                                    },
                                    {
                                      "nameEn": "D2(T-1)",
                                      "nameCn": "次留(T-1)",
                                      "code": "cs_si_ret_d2_t1",
                                      "align": "right",
                                      "width": 170,
                                      "features": {
                                        "sortable": true,
                                        "cell": {
                                          "type": "percentage",
                                          "showProgressBar": true,
                                          "showChangeRate": true,
                                          "showRawOnHover": true,
                                          "hoverFormatRule": "percent2Decimal",
                                          "changeKey": "cs_si_ret_d2_t1_dod",
                                          "formatDodAsPercent": true,
                                          "dodDecimals": 1,
                                          "dodDownloadFormat": "0.0%",
                                          "hoverBubble": true,
                                        },
                                        "explainEn": "Number of retained users on day N from XX (registration date)/Number of new users on XX (registration date)，Registration date is D1",
                                        "explainCn": "次留=xx日期第2天留存用户数/xx日期新进用户数，注册日期是D1。",
                                        "format": "percent2Decimal",
                                        "downLoadFormat": "0.00%"
                                      }
                                    },
                                    {
                                      "nameEn": "D7(T-6)",
                                      "nameCn": "7留(T-6)",
                                      "code": "cs_si_ret_d7_t6",
                                      "align": "right",
                                      "width": 170,
                                      "features": {
                                        "sortable": true,
                                        "cell": {
                                          "type": "percentage",
                                          "showProgressBar": true,
                                          "showChangeRate": true,
                                          "showRawOnHover": true,
                                          "hoverFormatRule": "percent2Decimal",
                                          "changeKey": "cs_si_ret_d7_t6_dod",
                                          "formatDodAsPercent": true,
                                          "dodDecimals": 1,
                                          "dodDownloadFormat": "0.0%",
                                          "hoverBubble": true,
                                        },
                                        "explainEn": "Number of retained users on day 7 from XX (registration date)/Number of new users on XX (registration date)，Registration date is D1",
                                        "explainCn": "7留=xx日期第7天留存用户数/xx日期新进用户数，注册日期是D1。",
                                        "format": "percent2Decimal",
                                        "downLoadFormat": "0.00%"
                                      }
                                    },
                                    {
                                      "nameEn": "Spend($)",
                                      "nameCn": "UA 花费($)",
                                      "code": "cs_si_spend",
                                      "align": "right",
                                      "width": 170,
                                      "features": {
                                        "sortable": true,
                                        "cell": {
                                          "type": "percentage",
                                          "showProgressBar": false,
                                          "showChangeRate": true,
                                          "showRawOnHover": true,
                                          "hoverFormatRule": "thousands2Decimal",
                                          "changeKey": "cs_si_spend_dod",
                                          "formatDodAsPercent": true,
                                          "dodDecimals": 1,
                                          "dodDownloadFormat": "0.0%",
                                          "hoverBubble": true,
                                        },
                                        "explainEn": "UA Spend",
                                        "explainCn": "UA花费",
                                        "format": "bmk00"
                                      }
                                    },
                                    {
                                      "nameEn": "ROAS1",
                                      "nameCn": "ROAS1",
                                      "code": "cs_si_roi_d1",
                                      "align": "right",
                                      "width": 170,
                                      "features": {
                                        "sortable": true,
                                        "cell": {
                                          "type": "percentage",
                                          "showProgressBar": true,
                                          "showChangeRate": true,
                                          "showRawOnHover": true,
                                          "hoverFormatRule": "percent2Decimal",
                                          "changeKey": "cs_si_roi_d1_dod",
                                          "formatDodAsPercent": true,
                                          "dodDecimals": 1,
                                          "dodDownloadFormat": "0.0%",
                                          "hoverBubble": true,
                                        },
                                        "explainEn": "Return on Ad Spend:SUM(Cohort Revenue from Install)/SUM(UA Spend)",
                                        "explainCn": "投放后第1天的广告支出回报率",
                                        "format": "percent2Decimal",
                                        "downLoadFormat": "0.00%"
                                      }
                                    },
                                    {
                                      "nameEn": "ROAS7",
                                      "nameCn": "ROAS7",
                                      "code": "cs_si_roi_d7",
                                      "align": "right",
                                      "width": 170,
                                      "features": {
                                        "sortable": true,
                                        "cell": {
                                          "type": "percentage",
                                          "showProgressBar": true,
                                          "showChangeRate": true,
                                          "showRawOnHover": true,
                                          "hoverFormatRule": "percent2Decimal",
                                          "changeKey": "cs_si_roi_d7_dod",
                                          "formatDodAsPercent": true,
                                          "dodDecimals": 1,
                                          "dodDownloadFormat": "0.0%",
                                          "hoverBubble": true,
                                        },
                                        "explainEn": "Return on Ad Spend:SUM(Cohort Revenue from Install)/SUM(UA Spend)",
                                        "explainCn": "投放后第7天的广告支出回报率",
                                        "format": "percent2Decimal",
                                        "downLoadFormat": "0.00%"
                                      }
                                    }
                                  ]
                                }
                              }
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  "name": "Service",
                  "data": {
                    "searchKeyword": "",
                    "clientSearchKeyword": "",
                    "extraParams": {
                      "multi_sort": [
                        {
                          "sort_by": "ytd_cs_studio_total_revenue_m",
                          "desc": true
                        }
                      ],
                      "page": 1,
                      "page_size": 9999
                    }
                  },
                  "props": {
                    "api": "/api/v2/dashboard/studio/casual_hub/overview/overall_performance",
                    "trackData": [
                      "extraParams",
                      "frameCode"
                    ],
                    "dataKey": "studioOverviewTableData",
                    "filterLoading": false,
                    "beforeRequest": (data) => {
                      const { filterVal, frameCode } = data || {};
                      const frontendSearch = true; // 前后端搜索开关：true=前端, false=后端
                      const searchKeyword = !frontendSearch && data && data.searchKeyword ? String(data.searchKeyword).trim() : '';
                      const customFilters = searchKeyword ? [
                        {
                          key: 'game_code',
                          operate: 'like',
                          filter_list: [searchKeyword],
                        },
                      ] : [];
                      const et = filterVal?.end_time;
                      const getTargetDate = (dateStr, monthOffset = 0, type = 'current', sep = '') => {
                        if (!dateStr) return '';
    
                        const parts = dateStr.split(/[-/]/); 
                        const year = parseInt(parts[0], 10);
                        const month = parseInt(parts[1], 10) - 1;
                        const day = parseInt(parts[2], 10) || 1;
    
                        const dayMap = { 'first': 1, 'last': 0, 'current': day };
                        const offset = type === 'last' ? monthOffset + 1 : monthOffset;
    
                        const target = new Date(year, month + offset, dayMap[type]);
    
                        const rYear = target.getFullYear();
                        const rMonth = String(target.getMonth() + 1).padStart(2, '0');
                        const rDay = String(target.getDate()).padStart(2, '0');
    
                        return [rYear, rMonth, rDay].join(sep);
                      };
                      const isCurrentMonth = (dateStr) => {
                        if (!dateStr) return false;
    
                        const parts = dateStr.split(/[-/]/);
                        const inputYear = parseInt(parts[0], 10);
                        const inputMonth = parseInt(parts[1], 10) - 1;
    
                        const now = new Date();
                        const currentYear = now.getFullYear();
                        const currentMonth = now.getMonth();
    
                        return inputYear === currentYear && inputMonth === currentMonth;
                      };
                      const mFirstDate = getTargetDate(et, 0, 'first');
                      const mLastDate = getTargetDate(et, 0, 'last');
                      const mMinus1FirstDate = getTargetDate(et, -1, 'first');
                      const mMinus1LastDate = getTargetDate(et, -1, 'last');
                      const mMinus5FirstDate = getTargetDate(et, -5, 'first');
                      const mMinus6FirstDate = getTargetDate(et, -6, 'first');
                      const isM = isCurrentMonth(et);
    
                      return Object.assign(
                        {},
                        {
                          studio_code: frameCode,
                          filters: customFilters.length > 0 ? { custom_filters: customFilters } : {},
                          accumulation: {
                            custom_accumulation: [
                              { is_accumulation: true, key: 'game_code' },
                              { is_accumulation: false, key: 'category' },
                              { is_accumulation: true, key: 'studio' },
                            ],
                          },
                          page: 1,
                          page_size: frontendSearch ? 9999 : 10,
                          start_date: isM ? mMinus1FirstDate : mFirstDate,
                          end_date: isM ? mMinus1LastDate : mLastDate,
                          sorted_by: 'ytd_cs_studio_total_revenue_m',
                          desc: true,
                          multi_sort: [{ sort_by: 'ytd_cs_studio_total_revenue_m', desc: true }],
                          metrics: [
                            'ytd_cs_studio_total_revenue_m',
                            'ytd_cs_studio_iaa_revenue_m',
                            'ytd_cs_studio_iap_revenue_m',
                            'ytd_cs_studio_spend_m',
                          ],
                          logical_flag: 'ytd_actual_date',
                          period: 'monthly',
                        },
                        data.extraParams,
                      );
                    },
                    "formatData": (data) => { return data }
                  },
                  "children": [
                    {
                      "name": "Service",
                      "props": {
                        "api": "/api/v2/dashboard/studio/casual_hub/overview/overall_performance",
                        "trackData": [
                          "frameCode"
                        ],
                        "dataKey": "studioOverviewSparklineData",
                        "filterLoading": false,
                        "beforeRequest": (data) => {
                          const { filterVal, frameCode } = data || {};
                          const et = filterVal?.end_time;
                          const getTargetDate = (dateStr, monthOffset = 0, type = 'current', sep = '') => {
                            if (!dateStr) return '';
    
                            const parts = dateStr.split(/[-/]/); 
                            const year = parseInt(parts[0], 10);
                            const month = parseInt(parts[1], 10) - 1;
                            const day = parseInt(parts[2], 10) || 1;
    
                            const dayMap = { 'first': 1, 'last': 0, 'current': day };
                            const offset = type === 'last' ? monthOffset + 1 : monthOffset;
    
                            const target = new Date(year, month + offset, dayMap[type]);
    
                            const rYear = target.getFullYear();
                            const rMonth = String(target.getMonth() + 1).padStart(2, '0');
                            const rDay = String(target.getDate()).padStart(2, '0');
    
                            return [rYear, rMonth, rDay].join(sep);
                          };
                          const isCurrentMonth = (dateStr) => {
                            if (!dateStr) return false;
    
                            const parts = dateStr.split(/[-/]/);
                            const inputYear = parseInt(parts[0], 10);
                            const inputMonth = parseInt(parts[1], 10) - 1;
    
                            const now = new Date();
                            const currentYear = now.getFullYear();
                            const currentMonth = now.getMonth();
    
                            return inputYear === currentYear && inputMonth === currentMonth;
                          };
                          const mFirstDate = getTargetDate(et, 0, 'first');
                          const mLastDate = getTargetDate(et, 0, 'last');
                          const mMinus1FirstDate = getTargetDate(et, -1, 'first');
                          const mMinus1LastDate = getTargetDate(et, -1, 'last');
                          const mMinus5FirstDate = getTargetDate(et, -5, 'first');
                          const mMinus6FirstDate = getTargetDate(et, -6, 'first');
                          const isM = isCurrentMonth(et);
    
                          return Object.assign(
                            {},
                            {
                              logical_flag: 'trend_chart',
                              studio_code: frameCode,
                              filters: {},
                              accumulation: {
                                custom_accumulation: [
                                  { is_accumulation: true, key: 'game_code' },
                                  { is_accumulation: false, key: 'category' },
                                  { is_accumulation: true, key: 'studio' },
                                ],
                              },
                              start_date: isM ? mMinus6FirstDate : mMinus5FirstDate,
                              end_date: isM ? mMinus1LastDate : mLastDate,
                              sorted_by: 'date',
                              desc: true,
                              multi_sort: [{ sort_by: 'cs_studio_total_revenue_m', desc: true }],
                              metrics: [
                                'cs_studio_total_revenue_m',
                                'cs_studio_iaa_revenue_m',
                                'cs_studio_iap_revenue_m',
                              ],
                              period: 'monthly',
                            },
                          );
                        },
                        "formatData": (data) => { return data }
                      },
                      "children": [
                        {
                          "name": "DataMergeWrap",
                          "props": {
                            "dataKey": "studioOverviewTableData",
                            "sparklineDataKey": "studioOverviewSparklineData",
                            "dateSubtitleConfig": {
                              "templateEn": "{{start}}~{{end}}",
                              "templateCn": "{{start}}~{{end}}",
                              "dateSeparator": "-",
                              "subtitleEndTimeDataKey": "studioYtdActualEndTime"
                            },
                            "studioIconMap": {
                              "Miniclip": "https://ogdb-cdn.intlgame.cn/aupload/admin/studio_hub/image/1741760898187_选中态.png",
                              "Miniclip Game Studios": "https://ogdb-cdn.intlgame.cn/aupload/admin/studio_hub/image/1741760898187_选中态.png"
                            }
                          },
                          "children": [
                            {
                              "name": "TableWithDateSubtitle",
                              "className": "margin-t-20",
                              "props": {
                                "dataKey": "studioOverviewTableData",
                                "dataPath": "metrics_list",
                                "clientFilter": {
                                  "searchKey": "clientSearchKeyword",
                                  "searchFields": [
                                    "game_name"
                                  ]
                                },
                                "metricsCardWrapProps": {
                                  "titleEn": "Studio Projects",
                                  "titleCn": "Studio项目",
                                  "operation": [
                                    {
                                      "name": "SearchBox",
                                      "className": "dbd-common-table__operation-btn",
                                      "props": {
                                        "showWhen": "function() {\n                                                                                    return true;\n                                                                                }",
                                        "placeholderEn": "Search games",
                                        "placeholderCn": "搜索游戏",
                                        "patchData": {
                                          "keys": "data.clientSearchKeyword"
                                        }
                                      }
                                    },
                                    {
                                      "name": "DownloadButton",
                                      "className": "dbd-common-table__operation-btn",
                                      "config": {
                                        "apiDownload": {
                                          "fileNameEn": "Studio Projects",
                                          "fileNameCn": "Studio项目",
                                          "sheetNameEn": "Studio Projects",
                                          "sheetNameCn": "Studio项目",
                                          "api": "/api/v2/dashboard/studio/casual_hub/overview/overall_performance",
                                          "fixedPageSize": 50000,
                                          "formatData": (metricsList, context) => {
                                            // 用 casualInfo.games 把 game_code 映射成完整游戏名（与展示一致）
                                            const casualInfo = context && context.casualInfo;
                                            const games = casualInfo && casualInfo.games;
                                            const gameInfoMap = {};
                                            if (games && games.length) {
                                              games.forEach((g) => {
                                                if (g.game_name) gameInfoMap[g.game_name] = g;
                                                if (g.entity_name) gameInfoMap[g.entity_name] = g;
                                                if (g.entity_name_cn) gameInfoMap[g.entity_name_cn] = g;
                                              });
                                            }
                                            const rows = metricsList.map((item, index) => {
                                              const rawDate = item.date ? String(item.date) : '';
                                              const formattedDate = rawDate.length === 8
                                                ? `${rawDate.slice(0, 4)  }-${  rawDate.slice(4, 6)}`
                                                : rawDate;
                                              const customDims = item.custom_dimensions;
                                              const getDimValue = function (key) {
                                                if (!customDims || !customDims.length) return '';
                                                const dim = customDims.find((d) => { return d.key === key });
                                                return (dim && dim.value) ? dim.value : '';
                                              };
                                              const rawGameCode = getDimValue('game_code');
                                              const gameInfo = gameInfoMap[rawGameCode];
                                              const isEN = !!(context && context.isEN);
                                              const gameName = gameInfo ? (isEN ? (gameInfo.entity_name || gameInfo.entity_name_cn || rawGameCode) : (gameInfo.entity_name_cn || gameInfo.entity_name || rawGameCode)) : rawGameCode;
                                              const {metrics} = item;
                                              const flatMetrics = {};
                                              if (metrics) {
                                                Object.keys(metrics).forEach((key) => {
                                                  const m = metrics[key];
                                                  flatMetrics[key] = (m && m.value !== undefined && m.value !== '') ? m.value : '';
                                                  flatMetrics[`${key  }_dod`] = (m && m.dod !== undefined && m.dod !== '') ? m.dod : '';
                                                });
                                              }
                                              return Object.assign({}, item, flatMetrics, {
                                                rank: index + 1,
                                                date: formattedDate,
                                                game_name: gameName,
                                                studio_name: getDimValue('studio'),
                                              });
                                            });
                                            const userSortState = context && context.studioDownloadSortState;
                                            const sortBy = (userSortState && userSortState.length > 0) ? userSortState[0].by : null;
                                            const sortDesc = (userSortState && userSortState.length > 0) ? userSortState[0].order === 'desc' : true;
                                            if (sortBy) {
                                              return rows.sort((a, b) => {
                                                const va = (a[sortBy] !== '' && a[sortBy] !== undefined && a[sortBy] !== null) ? Number(a[sortBy]) : (sortDesc ? -Infinity : Infinity);
                                                const vb = (b[sortBy] !== '' && b[sortBy] !== undefined && b[sortBy] !== null) ? Number(b[sortBy]) : (sortDesc ? -Infinity : Infinity);
                                                return sortDesc ? vb - va : va - vb;
                                              });
                                            }
                                            // 无用户排序：与宽表展示一致，显式按 ytd_cs_studio_total_revenue_m 降序
                                            // （不再按 game 分组，且不依赖接口返回顺序）
                                            const defaultMetric = 'ytd_cs_studio_total_revenue_m';
                                            return rows.sort((a, b) => {
                                              const va = (a[defaultMetric] !== '' && a[defaultMetric] !== undefined && a[defaultMetric] !== null) ? Number(a[defaultMetric]) : -Infinity;
                                              const vb = (b[defaultMetric] !== '' && b[defaultMetric] !== undefined && b[defaultMetric] !== null) ? Number(b[defaultMetric]) : -Infinity;
                                              return vb - va;
                                            });
                                          },
                                          "beforeRequest": (data) => {
                                            const filter = data && data.filter;
                                            const frameCode = data && data.frameCode;
                                            const fv = filter;
                                            const et = fv && fv.end_time;
                                            const searchKeyword = data && data.clientSearchKeyword ? String(data.clientSearchKeyword).trim() : '';
                                            const customFilters = searchKeyword ? [
                                              { key: 'game_code', operate: 'like', filter_list: [searchKeyword] },
                                            ] : [];
                                            const actualEndTime = data && data.studioYtdActualEndTime;
                                            let endDate = '';
                                            let startDate = '';
                                            if (actualEndTime && String(actualEndTime).length >= 6) {
                                              endDate = String(actualEndTime).replace(/-/g, '').slice(0, 8);
                                              startDate = `${endDate.slice(0, 4)  }0101`;
                                            } else if (et) {
                                              const parts = String(et).trim().split(/[-/]/);
                                              const year = parseInt(parts[0], 10);
                                              const month = parseInt(parts[1], 10) - 1;
                                              const lastDay = new Date(year, month + 1, 0);
                                              const rYear = lastDay.getFullYear();
                                              const rMonth = String(lastDay.getMonth() + 1).padStart(2, '0');
                                              const rDay = String(lastDay.getDate()).padStart(2, '0');
                                              endDate = `${  rYear  }${rMonth  }${rDay}`;
                                              startDate = `${String(rYear)  }0101`;
                                            }
                                            return Object.assign(
                                              {},
                                              data.extraParams,
                                              {
                                                studio_code: frameCode,
                                                filters: customFilters.length > 0 ? { custom_filters: customFilters } : {},
                                                accumulation: {
                                                  custom_accumulation: [
                                                    { is_accumulation: true, key: 'game_code' },
                                                    { is_accumulation: false, key: 'category' },
                                                    { is_accumulation: true, key: 'studio' },
                                                  ],
                                                },
                                                page: 1,
                                                page_size: 9999,
                                                start_date: startDate,
                                                end_date: endDate,
                                                sorted_by: 'ytd_cs_studio_total_revenue_m',
                                                desc: true,
                                                multi_sort: [{ sort_by: 'ytd_cs_studio_total_revenue_m', desc: true }],
                                                metrics: [
                                                  'ytd_cs_studio_total_revenue_m',
                                                  'cs_studio_total_revenue_m',
                                                  'ytd_cs_studio_iaa_revenue_m',
                                                  'cs_studio_iaa_revenue_m',
                                                  'ytd_cs_studio_iap_revenue_m',
                                                  'cs_studio_iap_revenue_m',
                                                  'ytd_cs_studio_spend_m',
                                                  'cs_studio_spend',
                                                ],
                                                logical_flag: 'ytd_actual_date',
                                                period: 'monthly',
                                              },
                                            );
                                          },
                                          "columns": [
                                            { "code": "date", "name": "Date", "nameEn": "Date", "nameCn": "日期", "format": "@", "width": 120 },
                                            { "code": "game_name", "name": "Game", "nameEn": "Game", "nameCn": "游戏", "format": "@", "width": 200 },
                                            { "code": "studio_name", "name": "Studio", "nameEn": "Studio", "nameCn": "Studio", "format": "@", "width": 160 },
                                            { "code": "ytd_cs_studio_total_revenue_m", "name": "Revenue($)", "nameEn": "Revenue($)", "nameCn": "总收入($)", "format": "#,##0.00", "width": 160 },
                                            { "code": "ytd_cs_studio_total_revenue_m_dod", "name": "Revenue($)_mom", "nameEn": "Revenue($)_mom", "nameCn": "总收入($)_月环比", "format": "0.0%", "width": 140 },
                                            { "code": "cs_studio_total_revenue_m", "name": "Monthly Revenue($)", "nameEn": "Monthly Revenue($)", "nameCn": "月总收入($)", "format": "#,##0.00", "width": 180 },
                                            { "code": "cs_studio_total_revenue_m_dod", "name": "Monthly Revenue($)_mom", "nameEn": "Monthly Revenue($)_mom", "nameCn": "月总收入($)_月环比", "format": "0.0%", "width": 160 },
                                            { "code": "ytd_cs_studio_iaa_revenue_m", "name": "IAA Revenue($)", "nameEn": "IAA Revenue($)", "nameCn": "IAA 收入($)", "format": "#,##0.00", "width": 160 },
                                            { "code": "ytd_cs_studio_iaa_revenue_m_dod", "name": "IAA Revenue($)_mom", "nameEn": "IAA Revenue($)_mom", "nameCn": "IAA收入($)_月环比", "format": "0.0%", "width": 140 },
                                            { "code": "cs_studio_iaa_revenue_m", "name": "Monthly IAA Revenue($)", "nameEn": "Monthly IAA Revenue($)", "nameCn": "月IAA收入($)", "format": "#,##0.00", "width": 180 },
                                            { "code": "cs_studio_iaa_revenue_m_dod", "name": "Monthly IAA Revenue($)_mom", "nameEn": "Monthly IAA Revenue($)_mom", "nameCn": "月IAA收入($)_月环比", "format": "0.0%", "width": 180 },
                                            { "code": "ytd_cs_studio_iap_revenue_m", "name": "IAP Revenue($)", "nameEn": "IAP Revenue($)", "nameCn": "IAP 收入($)", "format": "#,##0.00", "width": 160 },
                                            { "code": "ytd_cs_studio_iap_revenue_m_dod", "name": "IAP Revenue($)_mom", "nameEn": "IAP Revenue($)_mom", "nameCn": "IAP收入($)_月环比", "format": "0.0%", "width": 140 },
                                            { "code": "cs_studio_iap_revenue_m", "name": "Monthly IAP Revenue($)", "nameEn": "Monthly IAP Revenue($)", "nameCn": "月IAP收入($)", "format": "#,##0.00", "width": 180 },
                                            { "code": "cs_studio_iap_revenue_m_dod", "name": "Monthly IAP Revenue($)_mom", "nameEn": "Monthly IAP Revenue($)_mom", "nameCn": "月IAP收入($)_月环比", "format": "0.0%", "width": 160 },
                                            { "code": "ytd_cs_studio_spend_m", "name": "Spend($)", "nameEn": "Spend($)", "nameCn": "UA 花费($)", "format": "#,##0.00", "width": 140 },
                                            { "code": "ytd_cs_studio_spend_m_dod", "name": "Spend($)_mom", "nameEn": "Spend($)_mom", "nameCn": "UA花费($)_月环比", "format": "0.0%", "width": 120 },
                                            { "code": "cs_studio_spend", "name": "Monthly Spend($)", "nameEn": "Monthly Spend($)", "nameCn": "月UA花费($)", "format": "#,##0.00", "width": 160 },
                                            { "code": "cs_studio_spend_dod", "name": "Monthly Spend($)_mom", "nameEn": "Monthly Spend($)_mom", "nameCn": "月UA花费($)_月环比", "format": "0.0%", "width": 140 },
                                          ]
                                        }
                                      }
                                    }
                                  ]
                                },
                                "commonBaseTableProps": {
                                  "height": 806.83,
                                  "tableConfig": {
                                    "tableHeight": 756.85,
                                    "isOpenForegroundPage": true,
                                    "hoverBubbleDateFormat": "YYYY-MM",
                                    "pagination": {},
                                    "downloadSortKey": "studioDownloadSortState"
                                  },
                                  "columns": [
                                    {
                                      "nameEn": "Games",
                                      "nameCn": "游戏",
                                      "code": "game_name",
                                      "align": "left",
                                      "width": 250,
                                      "features": {
                                        "sortable": false,
                                        "cell": {
                                          "type": "gameIcon",
                                          "showRawOnHover": true,
                                          "rankKey": "rank",
                                          "iconKey": "game_icon",
                                          "nameKey": "game_name",
                                          "countryCodeKey": "country_code",
                                          "countryNameKey": "country_name"
                                        }
                                      }
                                    },
                                    {
                                      "nameEn": "Studio",
                                      "nameCn": "Studio",
                                      "code": "studio_name",
                                      "align": "left",
                                      "width": 140,
                                      "features": {
                                        "sortable": false,
                                        "cell": {
                                          "type": "studioIcon",
                                          "iconKey": "studio_icon",
                                          "nameKey": "studio_name"
                                        }
                                      }
                                    },
                                    {
                                      "nameEn": "Revenue($)",
                                      "nameCn": "总收入($)",
                                      "code": "ytd_cs_studio_total_revenue_m",
                                      "align": "right",
                                      "width": 240,
                                      "features": {
                                        "sortable": true,
                                        "cell": {
                                          "type": "sparkline",
                                          "showChangeRate": true,
                                          "showRawOnHover": true,
                                          "hoverFormatRule": "thousands2Decimal",
                                          "changeKey": "ytd_cs_studio_total_revenue_m_dod",
                                          "dodDecimals": 2,
                                          "dodDownloadFormat": "0.0%",
                                          "hoverBubble": true,
                                          "sparklineKey": "sparkline_cs_studio_total_revenue_m",
                                          "sparklineDatesKey": "sparkline_dates",
                                          "tooltipDateFormat": "YYYY-MM"
                                        },
                                        "explainEn": "Total Revenue = IAP Revenue + Ad Revenue",
                                        "explainCn": "总收入=游戏内购收入+广告收入",
                                        "format": "bmk00"
                                      }
                                    },
                                    {
                                      "nameEn": "IAA Revenue($)",
                                      "nameCn": "IAA 收入($)",
                                      "code": "ytd_cs_studio_iaa_revenue_m",
                                      "align": "right",
                                      "width": 240,
                                      "features": {
                                        "sortable": true,
                                        "cell": {
                                          "type": "sparkline",
                                          "showChangeRate": true,
                                          "showRawOnHover": true,
                                          "hoverFormatRule": "thousands2Decimal",
                                          "changeKey": "ytd_cs_studio_iaa_revenue_m_dod",
                                          "dodDecimals": 2,
                                          "dodDownloadFormat": "0.0%",
                                          "hoverBubble": true,
                                          "sparklineKey": "sparkline_cs_studio_iaa_revenue_m",
                                          "sparklineDatesKey": "sparkline_dates",
                                          "tooltipDateFormat": "YYYY-MM"
                                        },
                                        "explainEn": "Total Ad Revenue Generated from Players' Ad Views",
                                        "explainCn": "玩家观看广告后产生的全部广告收入",
                                        "format": "bmk00"
                                      }
                                    },
                                    {
                                      "nameEn": "IAP Revenue($)",
                                      "nameCn": "IAP 收入($)",
                                      "code": "ytd_cs_studio_iap_revenue_m",
                                      "align": "right",
                                      "width": 240,
                                      "features": {
                                        "sortable": true,
                                        "cell": {
                                          "type": "sparkline",
                                          "showChangeRate": true,
                                          "showRawOnHover": true,
                                          "hoverFormatRule": "thousands2Decimal",
                                          "changeKey": "ytd_cs_studio_iap_revenue_m_dod",
                                          "dodDecimals": 2,
                                          "dodDownloadFormat": "0.0%",
                                          "hoverBubble": true,
                                          "sparklineKey": "sparkline_cs_studio_iap_revenue_m",
                                          "sparklineDatesKey": "sparkline_dates",
                                          "tooltipDateFormat": "YYYY-MM"
                                        },
                                        "explainEn": "Revenue generated from users’ in-app purchases, such as items, bundles, and subscriptions.",
                                        "explainCn": "用户通过游戏内购买道具、礼包、订阅等产生的收入。",
                                        "format": "bmk00"
                                      }
                                    },
                                    {
                                      "nameEn": "Spend($)",
                                      "nameCn": "UA 花费($)",
                                      "code": "ytd_cs_studio_spend_m",
                                      "align": "right",
                                      "features": {
                                        "sortable": true,
                                        "cell": {
                                          "type": "percentage",
                                          "showProgressBar": false,
                                          "showChangeRate": true,
                                          "showRawOnHover": true,
                                          "hoverFormatRule": "thousands2Decimal",
                                          "changeKey": "ytd_cs_studio_spend_m_dod",
                                          "formatDodAsPercent": true,
                                          "dodDecimals": 1,
                                          "dodDownloadFormat": "0.0%",
                                          "hoverBubble": true,
                                        },
                                        "explainEn": "UA Spend",
                                        "explainCn": "UA花费",
                                        "format": "bmk00"
                                      }
                                    }
                                  ]
                                }
                              }
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "name": "CommonLogWrap",
      "tabId": "day",
      "config": {
        "logConfig": {
          "menuId": "",
          "pageId": "903004",
          "pageName": "IEGG Casual Overview Day",
          "extInfo": "Casual Studio Overview Day",
          "pagePath": "/home/day"
        }
      },
      "children": [
        {
          "name": "CommonTabContentWrap",
          "className": "dbh-casual-card--day",
          "children": [
            {
              "name": "CasualOverviewWrap",
              "children": [
                {
                  "name": "Service",
                  "className": "",
                  "type": "view",
                  "props": {
                    "api": "/api/v2/dashboard/studio/casual_hub/overview/card_metrics",
                    "trackData": [
                      "extraParams",
                      "frameCode"
                    ],
                    "dataKey": "selfIncubationRevenueYtdMetricCardData",
                    "filterLoading": false,
                    "beforeRequest": "function(data) {\n                                            var _ref = data || {}, filterVal = _ref.filterVal, frameCode = _ref.frameCode;\n                                            var st = filterVal === null || filterVal === void 0 ? void 0 : filterVal.start_time;\n                                            var et = filterVal === null || filterVal === void 0 ? void 0 : filterVal.end_time;\n                                            var isConfirm = filterVal === null || filterVal === void 0 ? void 0 : filterVal.is_confirm;\n                                            var getTargetDay = function(dateStr) {\n                                                var dayOffset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, sep = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : '';\n                                                if (!dateStr) return '';\n                                                var parts = dateStr.split(/[-/]/);\n                                                var year = parseInt(parts[0], 10);\n                                                var month = parseInt(parts[1], 10) - 1;\n                                                var day = parseInt(parts[2], 10);\n                                                var target = new Date(year, month, day + dayOffset);\n                                                var rYear = target.getFullYear();\n                                                var rMonth = String(target.getMonth() + 1).padStart(2, '0');\n                                                var rDay = String(target.getDate()).padStart(2, '0');\n                                                return [\n                                                    rYear,\n                                                    rMonth,\n                                                    rDay\n                                                ].join(sep);\n                                            };\n                                            var isToday = function(dateStr) {\n                                                if (!dateStr) return false;\n                                                var parts = dateStr.split(/[-/]/);\n                                                var inputDate = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));\n                                                var now = new Date();\n                                                return inputDate.getFullYear() === now.getFullYear() && inputDate.getMonth() === now.getMonth() && inputDate.getDate() === now.getDate();\n                                            };\n                                            var tMinus13 = getTargetDay(et, -13, '-');\n                                            var isT = isToday(et);\n                                            return Object.assign({}, {\n                                                studio_code: frameCode,\n                                                filters: {},\n                                                period: 'daily',\n                                                start_time: isConfirm ? st : tMinus13,\n                                                end_time: et,\n                                                card_type: '1',\n                                                is_confirm: isConfirm,\n                                                breakdown_dimension: 'game_code',\n                                                \"logical_flag\": \"top_no_others\",\n                                                metrics: [\n                                                    'cs_self_incubation_revenue',\n                                                    'cs_self_incubation_dau',\n                                                    'cs_overall_d2_t1'\n                                                ],\n                                                trend_metrics: [\n                                                    'cs_self_incubation_revenue'\n                                                ],\n                                                breakdown_metrics: 'cs_si_iaa_revenue'\n                                            }, data.extraParams);\n                                        }",
                    "formatData": "function(data) {\n                                            var rawCardList = data && data.card_list ? data.card_list : [];\n                                            var cardList = rawCardList.map(function(card) {\n                                                var result = {\n                                                    metrics_name: card.metrics_name,\n                                                    value: card.value,\n                                                    time: card.time\n                                                };\n                                                var dod = card.dod;\n                                                if (dod) {\n                                                    result.dod = {\n                                                        show_value: dod.show_value || '',\n                                                        this_value: dod.this_value || '',\n                                                        last_value: dod.last_value || '',\n                                                        this_time: dod.this_time || '',\n                                                        last_time: dod.last_time || ''\n                                                    };\n                                                }\n                                                var sdlw = card.sdlw;\n                                                if (sdlw) {\n                                                    result.yoy = {\n                                                        show_value: sdlw.show_value || '',\n                                                        this_value: sdlw.this_value || '',\n                                                        last_value: sdlw.last_value || '',\n                                                        this_time: sdlw.this_time || '',\n                                                        last_time: sdlw.last_time || ''\n                                                    };\n                                                }\n                                                var change = card.change;\n                                                if (change) {\n                                                    result.change = {\n                                                        show_value: change.show_value || '',\n                                                        this_value: change.this_value || '',\n                                                        last_value: change.last_value || '',\n                                                        this_time: change.this_time || '',\n                                                        last_time: change.last_time || ''\n                                                    };\n                                                }\n                                                return result;\n                                            });\n                                            var rawTrendList = data && data.trend_list ? data.trend_list : [];\n                                            var trendList = rawTrendList.map(function(item) {\n                                                return {\n                                                    date: item.date,\n                                                    metrics: item.metrics\n                                                };\n                                            });\n                                            var rawBreakdown = data && data.breakdown ? data.breakdown : [];\n                                            var sortedBreakdown = rawBreakdown.slice().sort(function(a, b) {\n                                                return parseFloat(String(b.value || '0')) - parseFloat(String(a.value || '0'));\n                                            }).slice(0, 3);\n                                            var gameRanks = sortedBreakdown.map(function(item, idx) {\n                                                return {\n                                                    gameCode: item.name || item.full_name || '',\n                                                    rank: idx + 1,\n                                                    name: String(item.full_name || item.name || '')\n                                                };\n                                            });\n                                            return {\n                                                card_list: cardList,\n                                                trend_list: trendList,\n                                                breakdown: data && data.breakdown || [],\n                                                gameRanks: gameRanks\n                                            };\n                                        }"
                  },
                  "children": [
                    {
                      "name": "CasualSubMetricCard",
                      "className": "dbd-casual-sub-metric-card--span-all",
                      "props": {
                        "apiDataKey": "selfIncubationRevenueYtdMetricCardData",
                        "config": {
                          "titleEn": "Self-Incubation Revenue",
                          "titleCn": "自孵化项目收入",
                          "metricKey": "cs_self_incubation_revenue",
                          "formatRule": "bmk00",
                          "preUnit": "$",
                          "compareMetrics": [
                            {
                              "dataKey": "dod",
                              "titleEn": "DoD",
                              "titleCn": "日环比",
                              "when": "single"
                            },
                            {
                              "dataKey": "change",
                              "titleEn": "Change",
                              "titleCn": "变化率",
                              "when": "multi"
                            }
                          ],
                          "useDataGameRanks": true,
                          "gameRankJumpType": "window",
                          "useDynamicSubtitle": true,
                          "subtitleMode": "filterRange",
                          "subMetrics": [
                            {
                              "labelEn": "DAU",
                              "labelCn": "日活跃",
                              "metricKey": "cs_self_incubation_dau",
                              "formatRule": "bmk00",
                              "preUnit": "",
                              "useDynamicSubtitle": false
                            },
                            {
                              "labelEn": "D2(T-1)",
                              "labelCn": "次留(T-1)",
                              "metricKey": "cs_overall_d2_t1",
                              "formatRule": "percent2Decimal",
                              "preUnit": "",
                              "useDynamicSubtitle": false,
                              "compareMetrics": [
                                {
                                  "dataKey": "dod",
                                  "titleEn": "DoD",
                                  "titleCn": "日环比",
                                  "when": "single",
                                  "extendFormatRule": "percent2Decimal"
                                },
                                {
                                  "dataKey": "change",
                                  "titleEn": "Change",
                                  "titleCn": "变化率",
                                  "when": "multi",
                                  "extendFormatRule": "percent2Decimal"
                                }
                              ]
                            }
                          ],
                          "trendConfig": {
                            "metricKey": "cs_self_incubation_revenue",
                            "nameEn": "Revenue",
                            "nameCn": "总收入"
                          },
                          "trendTitleEn": "Revenue Trend",
                          "trendTitleCn": "收入趋势",
                          "trendTimeType": "Day"
                        }
                      }
                    }
                  ]
                },
                {
                  "name": "Service",
                  "data": {
                    "extraParams": {
                      "multi_sort": [
                        {
                          "sort_by": "cs_si_iaa_revenue",
                          "desc": true
                        }
                      ],
                      "page": 1,
                      "page_size": 9999
                    }
                  },
                  "props": {
                    "api": "/api/v2/dashboard/studio/casual_hub/overview/overall_performance",
                    "trackData": [
                      "extraParams",
                      "frameCode"
                    ],
                    "dataKey": "selfIncubationTableData",
                    "filterLoading": false,
                    "beforeRequest": (data) => {
                      const { filterVal, frameCode } = data || {};
                      const st = filterVal && filterVal.start_time;
                      const et = filterVal && filterVal.end_time;
                      const startDateStr = st ? String(st).trim().slice(0, 10).split('-').join('') : '';
                      const endDateStr = et ? String(et).trim().slice(0, 10).split('-').join('') : '';
                      const dauMetric = filterVal && filterVal.is_confirm ? 'avg_cs_si_dau' : 'cs_si_dau';
                      return Object.assign(
                        {},
                        {
                          studio_code: frameCode,
                          filters: {},
                          accumulation: {
                            not_by_date: filterVal?.is_confirm,
                            custom_accumulation: [
                              { is_accumulation: true, key: 'game_code' },
                              { is_accumulation: true, key: 'category' },
                              { is_accumulation: false, key: 'studio' },
                            ],
                          },
                          page: 1,
                          page_size: 9999,
                          start_date: startDateStr,
                          end_date: endDateStr,
                          sorted_by: 'cs_si_iaa_revenue',
                          desc: true,
                          multi_sort: [{ sort_by: 'cs_si_iaa_revenue', desc: true }],
                          metrics: [
                            'cs_si_iaa_revenue',
                            'cs_si_dnu',
                            dauMetric,
                            'cs_si_ret_d2_t1',
                            'cs_si_ret_d7_t6',
                            'cs_si_spend',
                            'cs_si_roi_d1',
                            'cs_si_roi_d7',
                          ],
                          "logical_flag": "cs_si_iaa_revenue",
                          period: 'daily',
                        },
                        data.extraParams,
                      );
                    },
                    "formatData": (data) => { return data }
                  },
                  "children": [
                    {
                      "name": "Service",
                      "props": {
                        "api": "/api/v2/dashboard/studio/casual_hub/overview/overall_performance",
                        "trackData": [
                          "frameCode"
                        ],
                        "dataKey": "selfIncubationSparklineData",
                        "filterLoading": false,
                        "beforeRequest": "function(data) {\n                                                    var _ref = data || {}, filterVal = _ref.filterVal, frameCode = _ref.frameCode;\n                                                    var st = filterVal === null || filterVal === void 0 ? void 0 : filterVal.start_time;\n                                                    var et = filterVal === null || filterVal === void 0 ? void 0 : filterVal.end_time;\n                                                    var isConfirm = filterVal === null || filterVal === void 0 ? void 0 : filterVal.is_confirm;\n                                                    var getTargetDay = function(dateStr) {\n                                                        var dayOffset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, sep = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : '';\n                                                        if (!dateStr) return '';\n                                                        var parts = dateStr.split(/[-/]/);\n                                                        var year = parseInt(parts[0], 10);\n                                                        var month = parseInt(parts[1], 10) - 1;\n                                                        var day = parseInt(parts[2], 10);\n                                                        var target = new Date(year, month, day + dayOffset);\n                                                        var rYear = target.getFullYear();\n                                                        var rMonth = String(target.getMonth() + 1).padStart(2, '0');\n                                                        var rDay = String(target.getDate()).padStart(2, '0');\n                                                        return [\n                                                            rYear,\n                                                            rMonth,\n                                                            rDay\n                                                        ].join(sep);\n                                                    };\n                                                    var isToday = function(dateStr) {\n                                                        if (!dateStr) return false;\n                                                        var parts = dateStr.split(/[-/]/);\n                                                        var inputDate = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));\n                                                        var now = new Date();\n                                                        return inputDate.getFullYear() === now.getFullYear() && inputDate.getMonth() === now.getMonth() && inputDate.getDate() === now.getDate();\n                                                    };\n                                                    var t = getTargetDay(et, 0);\n                                                    var startDate = getTargetDay(st, 0);\n                                                    var tMinus13 = getTargetDay(et, -13);\n                                                    var isT = isToday(et);\n                                                    return Object.assign({}, {\n                                                        logical_flag: 'trend_chart',\n                                                        studio_code: frameCode,\n                                                        filters: {},\n                                                        accumulation: {\n                                                            custom_accumulation: [\n                                                                {\n                                                                    is_accumulation: true,\n                                                                    key: 'game_code'\n                                                                },\n                                                                {\n                                                                    is_accumulation: true,\n                                                                    key: 'category'\n                                                                },\n                                                                {\n                                                                    is_accumulation: false,\n                                                                    key: 'studio'\n                                                                }\n                                                            ]\n                                                        },\n                                                        start_date: isConfirm ? startDate : tMinus13,\n                                                        end_date: t,\n                                                        sorted_by: 'date',\n                                                        desc: true,\n                                                        multi_sort: [\n                                                            {\n                                                                sort_by: 'cs_si_iaa_revenue',\n                                                                desc: true\n                                                            }\n                                                        ],\n                                                        metrics: [\n                                                            'cs_si_iaa_revenue'\n                                                        ],\n                                                        period: 'daily'\n                                                    });\n                                                }"
                      },
                      "children": [
                        {
                          "name": "DataMergeWrap",
                          "props": {
                            "dataKey": "selfIncubationTableData",
                            "sparklineDataKey": "selfIncubationSparklineData"
                          },
                          "children": [
                            {
                              "name": "CommonTable",
                              "className": "margin-t-20 dbh-casual-table",
                              "props": {
                                "dataKey": "selfIncubationTableData",
                                "dataPath": "metrics_list",
                                "totalRecordPath": "row_count",
                                "metricsCardWrapProps": {
                                  "titleEn": "Self-Incubation Projects",
                                  "titleCn": "自孵化项目",
                                  "operation": [
                                    {
                                      "name": "DownloadButton",
                                      "className": "dbd-common-table__operation-btn",
                                      "config": {
                                        "apiDownload": {
                                          "fileNameEn": "Self-Incubation Projects",
                                          "fileNameCn": "自孵化项目",
                                          "sheetNameEn": "Self-Incubation Projects",
                                          "sheetNameCn": "自孵化项目",
                                          "api": "/api/v2/dashboard/studio/casual_hub/overview/overall_performance",
                                          "fixedPageSize": 50000,
                                          "beforeDownloadModal": {
                                            "fields": [
                                              {
                                                "labelEn": "Granularity",
                                                "labelCn": "数据粒度",
                                                "paramKey": "period_mode",
                                                "type": "radio",
                                                "clientOnly": true,
                                                "options": [
                                                  { "labelEn": "Detail", "labelCn": "明细数据", "value": "detail" },
                                                  { "labelEn": "Aggregation", "labelCn": "聚合数据", "value": "aggregation" }
                                                ]
                                              }
                                            ]
                                          },
                                          "formatData": (metricsList, context) => {
                                            const isDetail = context && context.period_mode !== 'aggregation';
                                            const filter = context && context.filter;
                                            const fv = filter;
                                            const st = fv && fv.start_time;
                                            const et = fv && fv.end_time;
                                            const startLabel = st ? String(st).trim().slice(0, 10) : '';
                                            const endLabel = et ? String(et).trim().slice(0, 10) : '';
                                            const rangeLabel = startLabel && endLabel ? `${startLabel}~${endLabel}` : (startLabel || endLabel);
                                            const casualInfo = context && context.casualInfo;
                                            const games = casualInfo && casualInfo.games;
                                            const gameMap = {};
                                            if (games && games.length) {
                                              games.forEach((g) => {
                                                if (g.game_name) gameMap[g.game_name] = g;
                                                if (g.entity_name) gameMap[g.entity_name] = g;
                                                if (g.entity_name_cn) gameMap[g.entity_name_cn] = g;
                                              });
                                            }
                                            const getRawDate = (it) => (it && it.date ? String(it.date) : '');
                                            const rows = metricsList.map((item, index) => {
                                              const rawDate = item.date ? String(item.date) : '';
                                              const formattedDate = isDetail
                                                ? (rawDate.length === 8 ? rawDate.slice(0, 4) + '-' + rawDate.slice(4, 6) + '-' + rawDate.slice(6, 8) : rawDate)
                                                : rangeLabel;
                                              const customDims = item.custom_dimensions;
                                              const gameDim = customDims && customDims.find((d) => { return d.key === 'game_code' });
                                              const categoryDim = customDims && customDims.find((d) => { return d.key === 'category' });
                                              const rawGameName = (gameDim && gameDim.value) ? gameDim.value : '';
                                              const gameInfo = gameMap[rawGameName];
                                              const isEN = !!(context && context.isEN);
                                              const gameName = gameInfo ? (isEN ? (gameInfo.entity_name || gameInfo.entity_name_cn || rawGameName) : (gameInfo.entity_name_cn || gameInfo.entity_name || rawGameName)) : rawGameName;
                                              const category = (categoryDim && categoryDim.value) ? categoryDim.value : '';
                                              const {metrics} = item;
                                              const flatMetrics = {};
                                              if (metrics) {
                                                Object.keys(metrics).forEach((key) => {
                                                  const m = metrics[key];
                                                  flatMetrics[key] = (m && m.value) ? m.value : '';
                                                  flatMetrics[`${key}_dod`] = (m && m.dod) ? m.dod : '';
                                                });
                                              }
                                              return Object.assign({}, item, flatMetrics, {
                                                rank: index + 1,
                                                date: formattedDate,
                                                game_name: gameName,
                                                category,
                                                _rawDate: getRawDate(item),
                                              });
                                            });
                                            // 前端排序：读取用户当前排序状态（由 downloadSortKey 写入）
                                            const userSortState = context && context.selfIncubationDownloadSortState;
                                            const sortBy = (userSortState && userSortState.length > 0) ? userSortState[0].by : null;
                                            const sortDesc = (userSortState && userSortState.length > 0) ? userSortState[0].order === 'desc' : true;
                                            if (sortBy) {
                                              return rows.sort((a, b) => {
                                                const va = (a[sortBy] !== '' && a[sortBy] !== undefined && a[sortBy] !== null) ? Number(a[sortBy]) : (sortDesc ? -Infinity : Infinity);
                                                const vb = (b[sortBy] !== '' && b[sortBy] !== undefined && b[sortBy] !== null) ? Number(b[sortBy]) : (sortDesc ? -Infinity : Infinity);
                                                return sortDesc ? vb - va : va - vb;
                                              });
                                            }
                                            if (!isDetail) {
                                              const defaultMetric = 'cs_si_iaa_revenue';
                                              return rows.sort((a, b) => {
                                                const va = (a[defaultMetric] !== '' && a[defaultMetric] !== undefined && a[defaultMetric] !== null) ? Number(a[defaultMetric]) : -Infinity;
                                                const vb = (b[defaultMetric] !== '' && b[defaultMetric] !== undefined && b[defaultMetric] !== null) ? Number(b[defaultMetric]) : -Infinity;
                                                return vb - va;
                                              });
                                            }
                                            // 明细模式：先按日期倒序，再按 IAA 收入降序（同日期即按收入降序）
                                            const detailMetric = 'cs_si_iaa_revenue';
                                            return rows.sort((a, b) => {
                                              const da = String(a._rawDate || '');
                                              const db = String(b._rawDate || '');
                                              if (da !== db) return db.localeCompare(da);
                                              const va = (a[detailMetric] !== '' && a[detailMetric] !== undefined && a[detailMetric] !== null) ? Number(a[detailMetric]) : -Infinity;
                                              const vb = (b[detailMetric] !== '' && b[detailMetric] !== undefined && b[detailMetric] !== null) ? Number(b[detailMetric]) : -Infinity;
                                              return vb - va;
                                            });
                                          },
                                          "beforeRequest": (data) => {
                                            const filter = data && data.filter;
                                            const frameCode = data && data.frameCode;
                                            const fv = filter;
                                            const st = fv && fv.start_time;
                                            const et = fv && fv.end_time;
                                            const startDateStr = st ? String(st).trim().slice(0, 10).split('-').join('') : '';
                                            const endDateStr = et ? String(et).trim().slice(0, 10).split('-').join('') : '';
                                            const isDetail = data.period_mode !== 'aggregation';
                                            const dauMetric = (!isDetail && fv && fv.is_confirm) ? 'avg_cs_si_dau' : 'cs_si_dau';
                                            return Object.assign(
                                              {},
                                              data.extraParams,
                                              {
                                                studio_code: frameCode,
                                                filters: {},
                                                accumulation: {
                                                  not_by_date: !isDetail,
                                                  custom_accumulation: [
                                                    { is_accumulation: true, key: 'game_code' },
                                                    { is_accumulation: true, key: 'category' },
                                                    { is_accumulation: false, key: 'studio' },
                                                  ],
                                                },
                                                page: 1,
                                                page_size: 9999,
                                                start_date: startDateStr,
                                                end_date: endDateStr,
                                                sorted_by: 'date',
                                                desc: true,
                                                multi_sort: [{ sort_by: 'date', desc: true }, { sort_by: 'cs_si_iaa_revenue', desc: true }],
                                                metrics: [
                                                  'cs_si_iaa_revenue',
                                                  'cs_si_dnu',
                                                  dauMetric,
                                                  'cs_si_ret_d2_t1',
                                                  'cs_si_ret_d7_t6',
                                                  'cs_si_spend',
                                                  'cs_si_roi_d1',
                                                  'cs_si_roi_d7',
                                                ],
                                                logical_flag: 'cs_si_iaa_revenue',
                                                period: 'daily',
                                              },
                                            );
                                          },
                                          "columns": [
                                            { "code": "date", "name": "Date", "nameEn": "Date", "nameCn": "日期", "format": "@", "width": 140 },
                                            { "code": "game_name", "name": "Game", "nameEn": "Game", "nameCn": "游戏", "format": "@", "width": 200 },
                                            { "code": "category", "name": "Category", "nameEn": "Category", "nameCn": "类型", "format": "@", "width": 140 },
                                            { "code": "cs_si_iaa_revenue", "name": "IAA Revenue($)", "nameEn": "IAA Revenue($)", "nameCn": "IAA 收入($)", "format": "#,##0.00", "width": 180 },
                                            { "code": "cs_si_iaa_revenue_dod", "name": "IAA Revenue($)_dod", "nameEn": "IAA Revenue($)_dod", "nameCn": "IAA收入($)_日环比", "format": "0.0%", "width": 160 },
                                            { "code": "cs_si_dnu", "name": "DNU", "nameEn": "DNU", "nameCn": "日新进", "format": "#,##0", "width": 140 },
                                            { "code": "cs_si_dnu_dod", "name": "DNU_dod", "nameEn": "DNU_dod", "nameCn": "日新进_日环比", "format": "0.0%", "width": 120 },
                                            { "code": "cs_si_dau", "name": "DAU", "nameEn": "DAU", "nameCn": "日活跃", "format": "#,##0", "width": 140 },
                                            { "code": "cs_si_dau_dod", "name": "DAU_dod", "nameEn": "DAU_dod", "nameCn": "日活跃_日环比", "format": "0.0%", "width": 120 },
                                            { "code": "avg_cs_si_dau", "overrideCode": "cs_si_dau", "overrideWhen"(data) { return !!(data && data.filter && data.filter.is_confirm && data.period_mode === 'aggregation') }, "name": "Avg.DAU", "nameEn": "Avg.DAU", "nameCn": "日均活跃", "format": "#,##0", "width": 140 },
                                            { "code": "avg_cs_si_dau_dod", "overrideCode": "cs_si_dau_dod", "overrideWhen"(data) { return !!(data && data.filter && data.filter.is_confirm && data.period_mode === 'aggregation') }, "name": "Avg.DAU_dod", "nameEn": "Avg.DAU_dod", "nameCn": "日均活跃_日环比", "format": "0.0%", "width": 120 },
                                            { "code": "cs_si_ret_d2_t1", "name": "D2(T-1)", "nameEn": "D2(T-1)", "nameCn": "次留(T-1)", "format": "0.00%", "width": 120 },
                                            { "code": "cs_si_ret_d2_t1_dod", "name": "D2(T-1)_dod", "nameEn": "D2(T-1)_dod", "nameCn": "次留(T-1)_日环比", "format": "0.0%", "width": 120 },
                                            { "code": "cs_si_ret_d7_t6", "name": "D7(T-6)", "nameEn": "D7(T-6)", "nameCn": "7留(T-6)", "format": "0.00%", "width": 120 },
                                            { "code": "cs_si_ret_d7_t6_dod", "name": "D7(T-6)_dod", "nameEn": "D7(T-6)_dod", "nameCn": "7留(T-6)_日环比", "format": "0.0%", "width": 120 },
                                            { "code": "cs_si_spend", "name": "Spend($)", "nameEn": "Spend($)", "nameCn": "UA 花费($)", "format": "#,##0.00", "width": 140 },
                                            { "code": "cs_si_spend_dod", "name": "Spend($)_dod", "nameEn": "Spend($)_dod", "nameCn": "UA花费($)_日环比", "format": "0.0%", "width": 140 },
                                            { "code": "cs_si_roi_d1", "name": "ROAS1", "nameEn": "ROAS1", "nameCn": "ROAS1", "format": "0.00%", "width": 100 },
                                            { "code": "cs_si_roi_d1_dod", "name": "ROAS1_dod", "nameEn": "ROAS1_dod", "nameCn": "ROAS1_日环比", "format": "0.0%", "width": 100 },
                                            { "code": "cs_si_roi_d7", "name": "ROAS7", "nameEn": "ROAS7", "nameCn": "ROAS7", "format": "0.00%", "width": 100 },
                                            { "code": "cs_si_roi_d7_dod", "name": "ROAS7_dod", "nameEn": "ROAS7_dod", "nameCn": "ROAS7_日环比", "format": "0.0%", "width": 100 },
                                            { "code": "cs_si_iaa_revenue_dod", "overrideCode": "cs_si_iaa_revenue_dod", "overrideWhen"(d) { const f = d && d.filter; const s = f && f.start_time ? String(f.start_time).slice(0, 10) : ''; const e = f && f.end_time ? String(f.end_time).slice(0, 10) : ''; return !!(s && e && s !== e); }, "name": "IAA Revenue($)_Change", "nameEn": "IAA Revenue($)_Change", "nameCn": "IAA收入($)_变化率" },
                                            { "code": "cs_si_dnu_dod", "overrideCode": "cs_si_dnu_dod", "overrideWhen"(d) { const f = d && d.filter; const s = f && f.start_time ? String(f.start_time).slice(0, 10) : ''; const e = f && f.end_time ? String(f.end_time).slice(0, 10) : ''; return !!(s && e && s !== e); }, "name": "DNU_Change", "nameEn": "DNU_Change", "nameCn": "日新进_变化率" },
                                            { "code": "cs_si_dau_dod", "overrideCode": "cs_si_dau_dod", "overrideWhen"(d) { const f = d && d.filter; const s = f && f.start_time ? String(f.start_time).slice(0, 10) : ''; const e = f && f.end_time ? String(f.end_time).slice(0, 10) : ''; return !!(s && e && s !== e); }, "name": "DAU_Change", "nameEn": "DAU_Change", "nameCn": "日活跃_变化率" },
                                            { "code": "cs_si_ret_d2_t1_dod", "overrideCode": "cs_si_ret_d2_t1_dod", "overrideWhen"(d) { const f = d && d.filter; const s = f && f.start_time ? String(f.start_time).slice(0, 10) : ''; const e = f && f.end_time ? String(f.end_time).slice(0, 10) : ''; return !!(s && e && s !== e); }, "name": "D2(T-1)_Change", "nameEn": "D2(T-1)_Change", "nameCn": "次留(T-1)_变化率" },
                                            { "code": "cs_si_ret_d7_t6_dod", "overrideCode": "cs_si_ret_d7_t6_dod", "overrideWhen"(d) { const f = d && d.filter; const s = f && f.start_time ? String(f.start_time).slice(0, 10) : ''; const e = f && f.end_time ? String(f.end_time).slice(0, 10) : ''; return !!(s && e && s !== e); }, "name": "D7(T-6)_Change", "nameEn": "D7(T-6)_Change", "nameCn": "7留(T-6)_变化率" },
                                            { "code": "cs_si_spend_dod", "overrideCode": "cs_si_spend_dod", "overrideWhen"(d) { const f = d && d.filter; const s = f && f.start_time ? String(f.start_time).slice(0, 10) : ''; const e = f && f.end_time ? String(f.end_time).slice(0, 10) : ''; return !!(s && e && s !== e); }, "name": "Spend($)_Change", "nameEn": "Spend($)_Change", "nameCn": "UA花费($)_变化率" },
                                            { "code": "cs_si_roi_d1_dod", "overrideCode": "cs_si_roi_d1_dod", "overrideWhen"(d) { const f = d && d.filter; const s = f && f.start_time ? String(f.start_time).slice(0, 10) : ''; const e = f && f.end_time ? String(f.end_time).slice(0, 10) : ''; return !!(s && e && s !== e); }, "name": "ROAS1_Change", "nameEn": "ROAS1_Change", "nameCn": "ROAS1_变化率" },
                                            { "code": "cs_si_roi_d7_dod", "overrideCode": "cs_si_roi_d7_dod", "overrideWhen"(d) { const f = d && d.filter; const s = f && f.start_time ? String(f.start_time).slice(0, 10) : ''; const e = f && f.end_time ? String(f.end_time).slice(0, 10) : ''; return !!(s && e && s !== e); }, "name": "ROAS7_Change", "nameEn": "ROAS7_Change", "nameCn": "ROAS7_变化率" },
                                          ]
                                        }
                                      }
                                    }
                                  ]
                                },
                                "commonBaseTableProps": {
                                  "tableConfig": {
                                    "useVirtual": {
                                      "horizontal": false,
                                      "vertical": false,
                                      "header": false
                                    },
                                    "hidePaginationWhenSinglePage": true,
                                    "pagination": {},
                                    "downloadSortKey": "selfIncubationDownloadSortState"
                                  },
                                  "columns": [
                                    {
                                      "nameEn": "Game",
                                      "nameCn": "游戏",
                                      "code": "game_name",
                                      "align": "left",
                                      "width": 250,
                                      "features": {
                                        "sortable": false,
                                        "cell": {
                                          "type": "gameIcon",
                                          "showRawOnHover": true,
                                          "rankKey": "rank",
                                          "iconKey": "game_icon",
                                          "nameKey": "game_name",
                                          "countryCodeKey": "country_code",
                                          "countryNameKey": "country_name"
                                        }
                                      }
                                    },
                                    {
                                      "nameEn": "Category",
                                      "nameCn": "类型",
                                      "code": "category",
                                      "align": "left",
                                      "width": 140,
                                      "features": {
                                        "sortable": false,
                                        "cell": {
                                          "type": "category",
                                          "valueMapping": {
                                            "Self-Incubation": {
                                              "color": "#28B463",
                                              "backgroundColor": "#EAFAF1",
                                              "label": "Self-Incubation"
                                            },
                                            "Self-incubation": {
                                              "color": "#28B463",
                                              "backgroundColor": "#EAFAF1",
                                              "label": "Self-incubation"
                                            }
                                          }
                                        }
                                      }
                                    },
                                    {
                                      "nameEn": "IAA Revenue($)",
                                      "nameCn": "IAA 收入($)",
                                      "code": "cs_si_iaa_revenue",
                                      "align": "right",
                                      "width": 240,
                                      "features": {
                                        "sortable": true,
                                        "explainEn": "Total Ad Revenue Generated from Players' Ad Views",
                                        "explainCn": "玩家观看广告后产生的全部广告收入",
                                        "cell": {
                                          "type": "sparkline",
                                          "showChangeRate": true,
                                          "showRawOnHover": true,
                                          "hoverFormatRule": "thousands2Decimal",
                                          "changeKey": "cs_si_iaa_revenue_dod",
                                          "formatDodAsPercent": true,
                                          "dodDecimals": 2,
                                          "dodDownloadFormat": "0.0%",
                                          "hoverBubble": true,
                                          "sparklineKey": "sparkline_cs_si_iaa_revenue",
                                          "sparklineDatesKey": "sparkline_dates",
                                          "tooltipDateFormat": "YYYY-MM-DD"
                                        },
                                        "format": "bmk00"
                                      }
                                    },
                                    {
                                      "nameEn": "DNU",
                                      "nameCn": "日新进",
                                      "code": "cs_si_dnu",
                                      "align": "right",
                                      "width": 170,
                                      "features": {
                                        "sortable": true,
                                        "cell": {
                                          "type": "percentage",
                                          "showProgressBar": false,
                                          "showChangeRate": true,
                                          "showRawOnHover": true,
                                          "hoverFormatRule": "thousandsInit",
                                          "changeKey": "cs_si_dnu_dod",
                                          "formatDodAsPercent": true,
                                          "dodDecimals": 1,
                                          "dodDownloadFormat": "0.0%",
                                          "hoverBubble": true,
                                        },
                                        "explainEn": "",
                                        "explainCn": "",
                                        "format": "intBmk00"
                                      }
                                    },
                                    {
                                      "nameEn": "DAU",
                                      "nameCn": "日活跃",
                                      "code": "cs_si_dau",
                                      "align": "right",
                                      "width": 170,
                                      "features": {
                                        "sortable": true,
                                        "cell": {
                                          "type": "percentage",
                                          "showProgressBar": false,
                                          "showChangeRate": true,
                                          "showRawOnHover": true,
                                          "hoverFormatRule": "thousandsInit",
                                          "changeKey": "cs_si_dau_dod",
                                          "formatDodAsPercent": true,
                                          "dodDecimals": 1,
                                          "dodDownloadFormat": "0.0%",
                                          "hoverBubble": true,
                                        },
                                        "explainEn": "Unique device count with game logins during the statistical period(device id deduplicated)",
                                        "explainCn": "统计周期内登录过游戏的去重设备数(xwid)。",
                                        "format": "intBmk00"
                                      }
                                    },
                                    {
                                      "nameEn": "Avg.DAU",
                                      "nameCn": "日均活跃",
                                      "code": "avg_cs_si_dau",
                                      "overrideCode": "cs_si_dau",
                                      "overrideWhen"(data) { return !!(data && data.filter && data.filter.is_confirm) },
                                      "align": "right",
                                      "width": 170,
                                      "features": {
                                        "sortable": true,
                                        "cell": {
                                          "type": "percentage",
                                          "showProgressBar": false,
                                          "showChangeRate": true,
                                          "showRawOnHover": true,
                                          "hoverFormatRule": "thousandsInit",
                                          "changeKey": "avg_cs_si_dau_dod",
                                          "formatDodAsPercent": true,
                                          "dodDecimals": 1,
                                          "dodDownloadFormat": "0.0%",
                                          "hoverBubble": true,
                                        },
                                        "explainEn": "Average daily active devices across the selected date range(device id deduplicated)",
                                        "explainCn": "所选日期范围内日均登录过游戏的去重设备数(xwid)。",
                                        "format": "intBmk00"
                                      }
                                    },
                                    {
                                      "nameEn": "D2(T-1)",
                                      "nameCn": "次留(T-1)",
                                      "code": "cs_si_ret_d2_t1",
                                      "align": "right",
                                      "width": 170,
                                      "features": {
                                        "sortable": true,
                                        "cell": {
                                          "type": "percentage",
                                          "showProgressBar": true,
                                          "showChangeRate": true,
                                          "showRawOnHover": true,
                                          "hoverFormatRule": "percent2Decimal",
                                          "changeKey": "cs_si_ret_d2_t1_dod",
                                          "formatDodAsPercent": true,
                                          "dodDecimals": 1,
                                          "dodDownloadFormat": "0.0%",
                                          "hoverBubble": true,
                                        },
                                        "explainEn": "Number of retained users on day N from XX (registration date)/Number of new users on XX (registration date)，Registration date is D1",
                                        "explainCn": "次留=xx日期第2天留存用户数/xx日期新进用户数，注册日期是D1。",
                                        "format": "percent2Decimal",
                                        "downLoadFormat": "0.00%"
                                      }
                                    },
                                    {
                                      "nameEn": "D7(T-6)",
                                      "nameCn": "7留(T-6)",
                                      "code": "cs_si_ret_d7_t6",
                                      "align": "right",
                                      "width": 170,
                                      "features": {
                                        "sortable": true,
                                        "cell": {
                                          "type": "percentage",
                                          "showProgressBar": true,
                                          "showChangeRate": true,
                                          "showRawOnHover": true,
                                          "hoverFormatRule": "percent2Decimal",
                                          "changeKey": "cs_si_ret_d7_t6_dod",
                                          "formatDodAsPercent": true,
                                          "dodDecimals": 1,
                                          "dodDownloadFormat": "0.0%",
                                          "hoverBubble": true,
                                        },
                                        "explainEn": "Number of retained users on day 7 from XX (registration date)/Number of new users on XX (registration date)，Registration date is D1",
                                        "explainCn": "7留=xx日期第7天留存用户数/xx日期新进用户数，注册日期是D1。",
                                        "format": "percent2Decimal",
                                        "downLoadFormat": "0.00%"
                                      }
                                    },
                                    {
                                      "nameEn": "Spend($)",
                                      "nameCn": "UA 花费($)",
                                      "code": "cs_si_spend",
                                      "align": "right",
                                      "width": 170,
                                      "features": {
                                        "sortable": true,
                                        "cell": {
                                          "type": "percentage",
                                          "showProgressBar": false,
                                          "showChangeRate": true,
                                          "showRawOnHover": true,
                                          "hoverFormatRule": "thousands2Decimal",
                                          "changeKey": "cs_si_spend_dod",
                                          "formatDodAsPercent": true,
                                          "dodDecimals": 1,
                                          "dodDownloadFormat": "0.0%",
                                          "hoverBubble": true,
                                        },
                                        "explainEn": "UA Spend",
                                        "explainCn": "UA花费",
                                        "format": "bmk00"
                                      }
                                    },
                                    {
                                      "nameEn": "ROAS1",
                                      "nameCn": "ROAS1",
                                      "code": "cs_si_roi_d1",
                                      "align": "right",
                                      "width": 170,
                                      "features": {
                                        "sortable": true,
                                        "cell": {
                                          "type": "percentage",
                                          "showProgressBar": true,
                                          "showChangeRate": true,
                                          "showRawOnHover": true,
                                          "hoverFormatRule": "percent2Decimal",
                                          "changeKey": "cs_si_roi_d1_dod",
                                          "formatDodAsPercent": true,
                                          "dodDecimals": 1,
                                          "dodDownloadFormat": "0.0%",
                                          "hoverBubble": true,
                                        },
                                        "explainEn": "Return on Ad Spend:SUM(Cohort Revenue from Install)/SUM(UA Spend)",
                                        "explainCn": "投放后第1天的广告支出回报率",
                                        "format": "percent2Decimal",
                                        "downLoadFormat": "0.00%"
                                      }
                                    },
                                    {
                                      "nameEn": "ROAS7",
                                      "nameCn": "ROAS7",
                                      "code": "cs_si_roi_d7",
                                      "align": "right",
                                      "width": 170,
                                      "features": {
                                        "sortable": true,
                                        "cell": {
                                          "type": "percentage",
                                          "showProgressBar": true,
                                          "showChangeRate": true,
                                          "showRawOnHover": true,
                                          "hoverFormatRule": "percent2Decimal",
                                          "changeKey": "cs_si_roi_d7_dod",
                                          "formatDodAsPercent": true,
                                          "dodDecimals": 1,
                                          "dodDownloadFormat": "0.0%",
                                          "hoverBubble": true,
                                        },
                                        "explainEn": "Return on Ad Spend:SUM(Cohort Revenue from Install)/SUM(UA Spend)",
                                        "explainCn": "投放后第7天的广告支出回报率",
                                        "format": "percent2Decimal",
                                        "downLoadFormat": "0.00%"
                                      }
                                    }
                                  ]
                                }
                              }
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};